/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ApplicationSuccessResponse {
  /** @example true */
  success?: boolean
  /** @example "Application submitted successfully" */
  message?: string
  data?: {
    /** @example "691c830a895e4323b9da05aa" */
    applicationId?: string
  }
}

export interface ApplicationErrorResponse {
  /** @example false */
  success?: boolean
  /** @example "Validation failed" */
  error?: string
  /** @example ["Invalid email format","Missing required fields: firstName"] */
  errors?: string[]
}

export interface RateLimitErrorResponse {
  /** @example false */
  success?: boolean
  /** @example "Too many requests, please try again later" */
  error?: string
}

export interface RelevancyParams {
  /** @example "asd" */
  keyword?: string
  negatives?: string[]
  positives?: string[]
}

export interface RelevancyResultSuggestionItem {
  /** @example "asd" */
  change?: string
  /** @example "asd" */
  from?: string
  /** @example "asd" */
  to?: string
}

export interface RelevancyResultSuggestions {
  negative?: RelevancyResultSuggestionItem[]
  positive?: RelevancyResultSuggestionItem[]
}

export interface RelevancyResultRelevancy {
  /** @example "asd" */
  change?: string
  /** @example "asd" */
  total?: string
}

export interface RelevancyResult {
  /** @example true */
  success?: boolean
  relevancy?: RelevancyResultRelevancy
  suggestions?: RelevancyResultSuggestions
}

export interface SuggestionsCategories {
  result?: string[]
}

export interface SuggestionsSuggestWord {
  /** @example "asd" */
  suggested_word?: string
}

export interface SuggestionsSuperlativesComparativesItem {
  added?: string[]
  group?: string[]
}

export interface SuggestionsSuperlativesComparatives {
  negatives?: SuggestionsSuperlativesComparativesItem[]
  positives?: SuggestionsSuperlativesComparativesItem[]
}

export interface SuggestionsSynonymsAntonyms {
  antonyms?: string[]
  synonyms?: string[]
}

export interface VacanciesResponse {
  /** @example true */
  success?: boolean
  data?: Vacancy[]
}

export interface Vacancy {
  /** @example "507f1f77bcf86cd799439011" */
  _id?: string
  /** @example "Senior Product Designer" */
  title?: string
  /**
   * @format date
   * @example "2025-05-30"
   */
  postingDate?: string
  /** @example "Tbilisi, Georgia" */
  location?: string
  /** @example "Design Department" */
  department?: string
  /** @example "Full-Time" */
  employmentType?: string
  /** @example "Remote" */
  workArrangement?: string
  /** @example "We're looking for a passionate designer..." */
  aboutRole?: string
  /** @example ["Lead the design process","Translate complex requirements"] */
  responsibilities?: string[]
  /** @example ["5+ years experience","Strong portfolio"] */
  requirements?: string[]
  /** @example ["Flexible working hours","Opportunities for growth"] */
  benefits?: string[]
  /** @example true */
  isActive?: boolean
  /**
   * @format date-time
   * @example "2025-01-18T10:30:00Z"
   */
  createdAt?: string
  /**
   * @format date-time
   * @example "2025-01-18T10:30:00Z"
   */
  updatedAt?: string
}

export interface ErrorResponse {
  /** @example false */
  success?: boolean
  /**
   * Error message
   * @example "campaignIds must be an array with 2-9 campaign IDs"
   */
  error?: string
}

export enum AdminFetchThreadsSentimentType {
  POS = 'POS',
  NEG = 'NEG',
  NEU = 'NEU',
}

export enum AdminFetchThreadsVectorType {
  Desc = 'desc',
  Asc = 'asc',
}

export interface AdminFetchThreadsSupervisedSentiment {
  /** @example ["good"] */
  chatched_positive_keywords?: string[]
  /** @example [] */
  chatched_negative_keywords?: string[]
  /** @example 1 */
  positive_count?: number
  /** @example 0 */
  negative_count?: number
  /** @example 1 */
  positivity_score?: number
  /** @example "POS" */
  output?: string
}

export interface AdminFetchThreadsResponseDataItem {
  /** @example "1234567890abcdef12345678" */
  _id?: string
  /** @example "638483bf7c37f93cf946d870" */
  campaign?: string
  /** @example "England on Reddit" */
  campaign_name?: string
  /** @example "Bellingham" */
  keyword?: string
  /** @example "https://reddit.com/r/FIFA/comments/10k75ac/i_packed_bellingham_what_is_the_best_chem_i_can/" */
  origin?: string
  /** @example "https://reddit.com/r/FIFA/comments/10k75ac/i_packed_bellingham_what_is_the_best_chem_i_can/" */
  link?: string
  /** @example "reddit" */
  source?: string
  /** @example "I packed Bellingham what is the best chem I can put on him." */
  text?: string
  /** @example "2023-01-24T14:49:09.000Z" */
  published_at?: string
  /** @example false */
  irrelevant?: boolean
  /** @example "POS" */
  output?: string
  /** @example ["good"] */
  positive_keywords?: string[]
  /** @example [] */
  negative_keywords?: string[]
  supervised_sentiment?: AdminFetchThreadsSupervisedSentiment
}

export interface AdminFetchThreadsResponse {
  /** @example true */
  success?: boolean
  data?: AdminFetchThreadsResponseDataItem[]
  selectedSources?: string[]
  selectedKeywords?: string[]
  allSources?: string[]
  allKeywords?: string[]
}

/** One ad_library_page_snapshot doc — daily rollup written by ad-library-ops. */
export interface PageSnapshot {
  /** @example "166220546851195" */
  page_id?: string
  /**
   * UTC day-start of the snapshot.
   * @format date-time
   */
  snapshot_date?: string
  /** @format date-time */
  generated_at?: string
  /** @example 16 */
  active_count?: number
  /** @example 1341 */
  total_count?: number
  /** @example 1325 */
  inactive_count?: number
  /** @example {"facebook":1341,"instagram":1340,"audience_network":1314} */
  platforms?: Record<string, number>
  /** @example {"ka":1158,"en":66,"ru":12} */
  languages?: Record<string, number>
  target_countries?: {
    /** @example "IT" */
    code?: string
    /** @example "Italy" */
    name?: string
    /** @example 362 */
    count?: number
  }[]
  top_creatives?: {
    text?: string
    count?: number
  }[]
}

export interface PageSummary {
  /** Latest snapshot; null if the worker hasn't run yet. */
  snapshot?: PageSnapshot | null
  /**
   * - `not_monitored` — no user has saved this page; nothing will ever
   *   be snapshotted unless someone clicks Save. UI should show a
   *   "Save to track" CTA, NOT a "Syncing…" spinner.
   * - `pending` — a monitoring row exists but the worker hasn't
   *   produced a snapshot yet (newly saved page).
   * - `ready` — latest snapshot succeeded. - `failed` — last refresh errored; the last good snapshot is
   *   still served (if any).
   */
  snapshot_status?: 'not_monitored' | 'pending' | 'ready' | 'failed'
  /** @format date-time */
  last_snapshot_at?: string | null
}

export interface PageSearchResponse {
  /** @example true */
  success?: boolean
  data?: FacebookPage[]
}

export interface FacebookPage {
  /** @example "166220546851195" */
  id?: string
  /** @example "Archi" */
  name?: string
  /** @example 45000 */
  fan_count?: number
  /** @example "not_verified" */
  verification_status?: string
  /** @example "Real Estate" */
  category?: string
  /** Profile picture, present when the page is resolved by URL/handle/ID (Graph API). Absent for free-text/ads-archive-derived results, which only carry id and name. */
  picture?: {
    data?: {
      /** @example "https://scontent.xx.fbcdn.net/v/t39.30808-1/....jpg" */
      url?: string
    }
  } | null
}

export interface AdsSearchResponse {
  /** @example true */
  success?: boolean
  data?: Ad[]
  paging?: {
    cursors?: {
      before?: string
      after?: string
    }
    next?: string
  } | null
}

export interface Ad {
  id?: string
  ad_creation_time?: string
  ad_creative_bodies?: string[]
  ad_creative_link_titles?: string[]
  ad_creative_link_captions?: string[]
  ad_delivery_start_time?: string
  ad_delivery_stop_time?: string | null
  ad_snapshot_url?: string
  page_id?: string
  page_name?: string
  publisher_platforms?: string[]
  spend?: {
    lower_bound?: string
    upper_bound?: string
  }
  impressions?: {
    lower_bound?: string
    upper_bound?: string
  }
  /** Derived server-side from ad_delivery_stop_time (Meta does not return this field). */
  ad_active_status?: 'ACTIVE' | 'INACTIVE'
  /** Creative language codes, e.g. ["ka"]. Available for commercial ads. */
  languages?: string[]
  /** Targeted locations (countries/regions). Available for commercial ads. Note: this is targeting, not actual reach. */
  target_locations?: {
    name?: string
    type?: string
    excluded?: boolean
  }[]
  /** Targeted age range as [min, max], e.g. ["27", "62"]. */
  target_ages?: string[]
  /** Targeted gender, e.g. "All", "Men", "Women". */
  target_gender?: string
  /** Total reach in the EU/UK (DSA). Populated only for ads that reached the EU; null otherwise. */
  eu_total_reach?: number | null
}

export interface MonitoringPage {
  _id?: string
  user?: string
  /** @example "166220546851195" */
  page_id?: string
  /** @example "Archi" */
  page_name?: string | null
  /** Page profile picture URL (resolved from the live page at save time) */
  page_picture?: string | null
  /** @example "Real Estate" */
  category?: string | null
  /** @example "blue_verified" */
  verification_status?: string | null
  /** @example "ALL" */
  ad_type?: string | null
  /** @example ["GE"] */
  ad_reached_countries?: string[]
  /** @example "active" */
  status?: 'active' | 'inactive'
  /** @format date-time */
  created_at?: string
  /**
   * Set on create and on every status update.
   * @format date-time
   */
  updated_at?: string
  /** Written by the ad-library-ops snapshot worker. `pending` while the first snapshot is still running (newly saved competitor); `ready` after a successful run; `failed` if the last refresh errored (the last good snapshot is still served inline). */
  snapshot_status?: 'pending' | 'ready' | 'failed' | null
  /**
   * When the worker last finished a snapshot for this page (success or fail).
   * @format date-time
   */
  last_snapshot_at?: string | null
  /** Latest ad_library_page_snapshot inlined per row (joined via `$lookup` on `page_id`). Null until the worker has snapshotted this page at least once. Use this for Saved Competitor cards — it replaces per-card calls to /page-summary or /search. */
  latest_snapshot?: PageSnapshot | null
}

export interface MonitoringPagesListResponse {
  /** @example true */
  success?: boolean
  data?: MonitoringPage[]
}

export interface MonitoringPageResponse {
  /** @example true */
  success?: boolean
  data?: MonitoringPage
}

export interface CreateMonitoringPagePayload {
  /**
   * Numeric Facebook page ID (from pages/search). Resolved server-side; name/picture are populated automatically.
   * @pattern ^\d+$
   * @example "166220546851195"
   */
  page_id: string
  /**
   * Optional; ignored if the page resolves server-side.
   * @example "Archi"
   */
  page_name?: string
  /** @example "ALL" */
  ad_type?:
    | 'ALL'
    | 'POLITICAL_AND_ISSUE_ADS'
    | 'HOUSING_ADS'
    | 'EMPLOYMENT_ADS'
    | 'CREDIT_ADS'
  /** @example ["GE"] */
  ad_reached_countries?: string[]
}

export interface UpdateMonitoringPagePayload {
  /** @example "inactive" */
  status: 'active' | 'inactive'
}

export interface SmartInsightsResponse {
  /** @example true */
  success?: boolean
  /**
   * Indicates if insights are available
   * @example true
   */
  hasInsights: boolean
  /** Only present when hasInsights is true */
  insights?: SmartInsight[]
  data?: {
    /** @example true */
    hasInsights?: boolean
    insights?: SmartInsightItem[]
  }
}

/** One ad_library_smart_insight doc — authored by the separate generator service; sm.back only reads. */
export interface SmartInsight {
  _id?: string
  /** Scope of this insight. `{}` for brand-wide; `{ page_id: "..." }` for per-advertiser. Used by /smart-insights to filter the right set for the current view. */
  scope?: {
    /** @example "166220546851195" */
    page_id?: string
  }
  /**
   * Short headline shown on the card (~60 chars).
   * @example "Critical: Surge in negative mentions after public speech"
   */
  title: string
  /**
   * Free-form category tag set by the generator. Typical values include `media_strategy`, `creatives`, `audience_targeting`. Frontend maps these to the UI category tabs.
   * @example "influencer_opportunities"
   */
  category:
    | 'all'
    | 'brand_health_signals'
    | 'competitor_moves'
    | 'content_recommendations'
    | 'crisis_warnings'
    | 'influencer_opportunities'
  /**
   * Drives left (strength) vs right (challenge) column.
   * @example "strength"
   */
  type: 'challenge' | 'strength'
  /**
   * Concrete actionable CTA.
   * @example "Monitor situation closely. Consider issuing a neutral statement."
   */
  aiRecommendation: string
  /**
   * Detailed description of the insight
   * @example "On December 29, a public figure's speech triggered massive backlash from social media users."
   */
  details?: string
  /** @example true */
  isAIRecommendation?: boolean
  /** @example true */
  isSmartInsight?: boolean
  /**
   * Percentage change (positive or negative)
   * @example 40
   */
  percentageChange?: number
  /** Source mentions that contributed to this insight */
  sources?: {
    /** @example "facebook" */
    platform?: string
    /**
     * Summary text describing the pattern across all links
     * @example "Original mention text from the platform"
     */
    text?: string
    /** Individual source links with per-link text */
    links?: {
      /** @example "https://www.facebook.com/share/p/17wtpQrFti/" */
      url?: string
      /** @example "2025-12-05" */
      date?: string
      /** @example "ka" */
      language?: string
      /**
       * Text specific to this individual link/post
       * @example "Customer asking about renovation budgeting options"
       */
      text?: string
    }[]
  }[]
  /** @example "1" */
  id: string
  /**
   * Categories of the campaign that produced this insight. Empty array if the insight is not tied to a campaign or the campaign has no categories. A campaign may have multiple categories, in which case the insight should appear under each matching tab on the frontend.
   * @example ["Brand Management"]
   */
  campaignCategories?: (
    | 'Brand Management'
    | 'Competitor Analysis'
    | 'Market Research'
  )[]
}

export interface AiListeningCampaignPayload {
  /**
   * @maxLength 200
   * @example "Dressup.ge"
   */
  name: string
  /** @example ["ChatGPT","Claude","Gemini","Perplexity"] */
  aiTools?: ('ChatGPT' | 'Claude' | 'Gemini' | 'Perplexity')[]
  /**
   * @maxLength 200
   * @example "Dressup"
   */
  brandName: string
  /**
   * Brand name variants (e.g. multilingual spellings) — each is matched literally as a whole keyword
   * @maxItems 20
   * @example ["Dressup","დრესაპი"]
   */
  brandNames?: string[]
  /**
   * @format uri
   * @example "https://dressup.ge/ka"
   */
  website?: string
  /**
   * @maxLength 5000
   * @example "Monitor brand mentions across AI tools"
   */
  prompt?: string
  /**
   * @default "draft"
   * @example "active"
   */
  status?: 'draft' | 'active' | 'completed'
}

export interface AiListeningCampaignType {
  /** @example "65f1234567890abcdef12345" */
  _id?: string
  /** @example "507f1f77bcf86cd799439011" */
  user?: string
  /** @example "Dressup.ge" */
  name?: string
  /** @example ["ChatGPT","Claude","Gemini","Perplexity"] */
  aiTools?: string[]
  /** @example "Dressup" */
  brandName?: string
  /**
   * Brand name variants (e.g. multilingual spellings)
   * @example ["Dressup","დრესაპი"]
   */
  brandNames?: string[]
  /** @example "https://dressup.ge/ka" */
  website?: string | null
  /** @example "Monitor brand mentions across AI tools" */
  prompt?: string | null
  /** @example "active" */
  status?: 'draft' | 'active' | 'completed'
  /** Visibility results from AI analysis (populated by analysis system) */
  visibility?: {
    /** @example null */
    brand?: boolean | null
    /** @example null */
    domain?: boolean | null
    /** @example null */
    brandAndDomain?: boolean | null
  }
  /**
   * AI tools that detected the brand (populated by analysis system)
   * @example []
   */
  detectedVia?: string[]
  /**
   * Top insight from analysis (populated by analysis system)
   * @example null
   */
  topInsight?: string | null
  /**
   * When the campaign was last checked by the analysis system
   * @format date-time
   * @example null
   */
  lastCheckedAt?: string | null
  /**
   * @format date-time
   * @example "2026-02-24T10:30:00.000Z"
   */
  createdAt?: string
  /**
   * @format date-time
   * @example "2026-02-24T14:45:00.000Z"
   */
  updatedAt?: string
}

export interface AiListeningCampaignSingleResponse {
  /** @example true */
  success?: boolean
  data?: AiListeningCampaignType
}

export interface AiListeningCampaignListResponse {
  /** @example true */
  success?: boolean
  data?: AiListeningCampaignType[]
}

export interface AiListeningCampaignDeleteResponse {
  /** @example true */
  success?: boolean
  /** @example "AI listening campaign deleted successfully" */
  message?: string
}

export interface AiListeningCampaignErrorResponse {
  /** @example false */
  success?: boolean
  /** @example "Error message" */
  error?: string
}

export interface AiListeningCampaignValidationErrorResponse {
  /** @example false */
  success?: boolean
  /** @example ["Name is required","Brand name is required"] */
  errors?: string[]
}

export interface PromptResultsResponse {
  /** @example true */
  success?: boolean
  data?: {
    /**
     * Whether any AI tool mentioned the brand
     * @example true
     */
    brandMentioned?: boolean
    /**
     * Whether any AI tool mentioned the domain
     * @example false
     */
    domainMentioned?: boolean
    /**
     * List of AI tools that provided responses
     * @example ["ChatGPT","Claude","Gemini","Perplexity"]
     */
    aiToolsAnalyzed?: string[]
    /**
     * Total brand name mention count across all responses
     * @example 6
     */
    totalMentions?: number
    /**
     * Brand name mention count per AI tool
     * @example {"ChatGPT":2,"Claude":3,"Gemini":1,"Perplexity":0}
     */
    mentionsByTool?: Record<string, number>
    /**
     * The prompt that was sent to AI tools
     * @example "Are there any brands in Georgia that sell clothing with quality similar to Dressup?"
     */
    prompt?: string | null
  }
}

export interface ReloadHistoryCheckType {
  /** @example "65f1234567890abcdef12345" */
  _id?: string
  /** @example "65f1234567890abcdef12345" */
  campaign?: string
  /** @example "507f1f77bcf86cd799439011" */
  user?: string
  /**
   * @format date-time
   * @example "2026-02-19T10:00:00.000Z"
   */
  checkedAt?: string
  /**
   * AI-generated summary of the check results. Null when status is pending.
   * @example "Across all analyzed AI tools, the brand and domain were consistently mentioned."
   */
  summary?: string | null
  /** @example "completed" */
  status?: 'pending' | 'completed'
  /**
   * @format date-time
   * @example "2026-02-19T10:00:00.000Z"
   */
  createdAt?: string
}

export interface ReloadHistoryResponse {
  /** @example true */
  success?: boolean
  data?: ReloadHistoryCheckType[]
}

export interface BrandsAlongsideResponse {
  /** @example true */
  success?: boolean
  /** @example ["Puma","Adidas originals","Nike","ASICS","Zara","Bershka","Wrangler","Levi's"] */
  data?: string[]
}

export interface AiListeningResponseType {
  /** @example "65f1234567890abcdef12345" */
  _id?: string
  /** @example "65f1234567890abcdef12345" */
  campaign?: string
  /** @example "507f1f77bcf86cd799439011" */
  user?: string
  /** @example "ChatGPT" */
  aiTool?: 'ChatGPT' | 'Claude' | 'Gemini' | 'Perplexity'
  /** @example "GPT-4.1" */
  model?: string
  /** @example "Are there any brands in Georgia that sell clothing with quality similar to Dressup?" */
  prompt?: string
  /** @example "Nike - known for their popular models..." */
  fullResponse?: string
  /** @example true */
  brandMentioned?: boolean
  /** @example false */
  domainMentioned?: boolean
  /** @example ["Puma","Adidas originals","Nike","ASICS"] */
  competitors?: string[]
  /**
   * @format date-time
   * @example "2026-02-24T10:00:00.000Z"
   */
  checkedAt?: string
  /**
   * @format date-time
   * @example "2026-02-24T10:00:00.000Z"
   */
  createdAt?: string
}

export interface AiListeningResponseListResponse {
  /** @example true */
  success?: boolean
  data?: AiListeningResponseType[]
}

export interface ReloadStatusResponse {
  /** @example true */
  success?: boolean
  data?: {
    /** @example "completed" */
    status?: 'idle' | 'pending' | 'completed'
    /**
     * @format date-time
     * @example "2026-03-08T11:19:55.496Z"
     */
    checkedAt?: string | null
    /** @example "The brand was mentioned in 2 AI tools." */
    summary?: string | null
    /**
     * ISO timestamp when next reload is available. Null if reload is available now.
     * @format date-time
     * @example "2026-03-09T11:19:55.496Z"
     */
    nextReloadAvailableAt?: string | null
  }
}

export interface ReloadResponse {
  /** @example true */
  success?: boolean
  data?: ReloadHistoryCheckType
}

export interface ReloadCooldownResponse {
  /** @example false */
  success?: boolean
  /** @example "Reload is on cooldown" */
  error?: string
  /**
   * @format date-time
   * @example "2026-03-09T10:00:00.000Z"
   */
  nextReloadAvailableAt?: string
}

export interface SmartInsightType {
  /** @example "65f1234567890abcdef12345" */
  id?: string
  /** @example "Strong brand visibility across ChatGPT and Gemini" */
  title?: string
  /** @example "Your brand was mentioned in ChatGPT and Gemini responses when users asked about Georgian clothing brands." */
  details?: string
  sources?: {
    /** @example "ChatGPT" */
    platform?: 'ChatGPT' | 'Claude' | 'Gemini' | 'Perplexity'
    /** @example "Brand mention in clothing query" */
    text?: string
  }[]
  /** @example "Leverage ChatGPT visibility by optimizing brand mentions with structured product descriptions and FAQs." */
  aiRecommendation?: string
  /** @example "brand_health_signals" */
  category?:
    | 'brand_health_signals'
    | 'competitor_moves'
    | 'influencer_opportunities'
    | 'content_recommendations'
    | 'crisis_warnings'
  /** @example "strength" */
  type?: 'strength' | 'challenge'
}

export interface AiListeningOverviewAiTool {
  /** @example "ChatGPT" */
  name?: string
  /** @example "GPT-4.1" */
  model?: string
}

export interface AiListeningOverviewCompetitor {
  /** @example "Nike" */
  name?: string
  /** @example 31 */
  mentions?: number
}

export type AiListeningOverviewTopPrompt = {
  /** @example "Are there any brands in Georgia that sell clothing with quality similar to Dressup?" */
  prompt?: string
  /** @example 15 */
  mentions?: number
} | null

export type AiListeningOverviewTopAi = {
  /** @example "Gemini" */
  name?: string
  /** @example "2.5 Pro" */
  model?: string
  /** @example 10 */
  mentions?: number
} | null

export interface AiListeningOverviewResponse {
  /** @example true */
  success?: boolean
  data?: {
    /** @example 3 */
    totalCampaigns?: number
    /** @example 3 */
    activeCampaigns?: number
    /** @example 34 */
    totalMentions?: number
    aiTools?: AiListeningOverviewAiTool[]
    topCompetitors?: AiListeningOverviewCompetitor[]
    topPrompt?: AiListeningOverviewTopPrompt
    topAi?: AiListeningOverviewTopAi
  }
}

export interface AnalyticsFetchActiveDateRangeResponse {
  /**
   * The earliest date with data
   * @format date-time
   * @example "2023-01-15T00:00:00.000Z"
   */
  firstDate?: string | null
  /**
   * The latest date with data
   * @format date-time
   * @example "2023-12-20T00:00:00.000Z"
   */
  lastDate?: string | null
}

export interface AnalyticsFetchCalendarDetailsResponseDataSentiments {
  /** @example 0 */
  negPercentage?: number
  /** @example 13 */
  negatives?: number
  /** @example 100 */
  neuPercentage?: number
  /** @example 10944 */
  neutrals?: number
  /** @example 0 */
  posPercentage?: number
  /** @example 34 */
  positives?: number
  /** @example 10991 */
  total?: number
}

export interface AnalyticsFetchCalendarDetailsResponse {
  result?: AnalyticsFetchCalendarDetailsResponseDataSentiments
  topCampaigns?: string[]
  topSources?: string[]
}

export enum FetchThreadsCSVSentimentType {
  POS = 'POS',
  NEG = 'NEG',
  NEU = 'NEU',
}

export enum FetchThreadsCSVIsLostType {
  True = 'true',
  False = 'false',
  Both = 'both',
}

export interface FetchThreadsCSVSupervisedSentiment {
  /** @example ["good"] */
  chatched_positive_keywords?: string[]
  /** @example [] */
  chatched_negative_keywords?: string[]
  /** @example 1 */
  positive_count?: number
  /** @example 0 */
  negative_count?: number
  /** @example 1 */
  positivity_score?: number
  /** @example "POS" */
  output?: string
}

/**
 * @maxItems 4
 * @minItems 4
 */
export type AnalyticsFetchCampaignsCalendarResponseSentiments = number[]

export interface AnalyticsFetchCampaignsCalendarResponse {
  /** @example [[0,0,14,0],[0,1,9,0],[0,2,94,0],[0,3,66,0]] */
  sentiments?: AnalyticsFetchCampaignsCalendarResponseSentiments[]
  /** @example ["12:00 AM","3:00 AM","6:00 AM","9:00 AM","12:00 PM","15:00 PM","18:00 PM","21:00 PM","23:00 PM"] */
  xAxis?: string[]
  /** @example ["SAT","FRI","THU","WED","TUE","MON","SUN"] */
  yAxis?: string[]
}

/** @example "last 7 days" */
export enum AnalyticsFetchCustomCalendarRangeDefaultRangeType {
  Last30Days = 'last 30 days',
  Last7Day = 'last 7 day',
  Today = 'today',
}

export interface AnalyticsFetchCustomCalendarRangeResponse {
  /**
   * Only returned for social-listening source.
   * @example "2023-02-16T10:03:01.032Z"
   */
  firstDate?: string
  /**
   * Only returned for social-listening source.
   * @example "2023-03-15T00:00:00.000Z"
   */
  lastDate?: string
  /** Only returned for social-listening source. */
  defaultRange?: AnalyticsFetchCustomCalendarRangeDefaultRangeType
  /**
   * Dates within the requested month that have data.
   * @example ["2026-03-01","2026-03-05","2026-03-12","2026-03-19"]
   */
  dates?: string[]
}

export interface AnalyticsFetchDailyTrendsResponse {
  /** @example ["2023-03-12","2023-03-13","2023-03-14"] */
  dates?: string[]
  /** @example [2,4,5] */
  positives?: number[]
  /** @example [671,758,649] */
  neutrals?: number[]
  /** @example [5,10,10] */
  negatives?: number[]
  /** @example [678,772,664] */
  total?: number[]
}

export interface AnalyticsFetchHomeCalendarDateItem {
  /**
   * @maxItems 2
   * @minItems 2
   */
  value?: (string | number)[]
}

export interface AnalyticsFetchHomeCalendarChartDataPositivityDetails {
  /** @example 152 */
  positives?: number
  /** @example 27 */
  negatives?: number
  /** @example 12585 */
  neutrals?: number
  /** @example 0.0912912912912913 */
  opacity?: number
}

export interface AnalyticsFetchHomeCalendarChartDataPositivity {
  value?: AnalyticsFetchHomeCalendarChartDataPositivityDetails[]
}

export interface AnalyticsFetchHomeCalendarResponse {
  /** @example "2023-03-01" */
  first?: string
  /** @example "2023-03-15" */
  last?: string
  /** @example "2023-03" */
  range?: string
  /** @example "March 2023" */
  title?: string
  /** @example "2023-23-14" */
  today?: string
  datesBefore?: AnalyticsFetchHomeCalendarDateItem[]
  datesAfter?: AnalyticsFetchHomeCalendarDateItem[]
  campaignDates?: AnalyticsFetchHomeCalendarDateItem[]
  daysOfMonth?: AnalyticsFetchHomeCalendarDateItem[]
  negativeData?: AnalyticsFetchHomeCalendarChartDataPositivity[]
  positiveData?: AnalyticsFetchHomeCalendarChartDataPositivity[]
}

export interface AnalyticsFetchHotLinksResponseItem {
  /** @example "Opinions: War in Ukraine" */
  campaign?: string
  /** @example "Netanyahu" */
  keyword?: string
  /** @example "https://twitter.com/17061263/status/1635274782076981249" */
  origin?: string
  /** @example "dunamisfire217" */
  origin_name?: string
  /** @example "dunamisfire217" */
  name?: string
  /** @example "twitter" */
  source?: string
  /** @example "2023-03-13T23:59:59.999Z" */
  date?: string
  /** @example 0 */
  positives?: number
  /** @example 0 */
  negatives?: number
  /** @example 33 */
  neutrals?: number
  /** @example 33 */
  total?: number
  /** @example 0 */
  positivePerc?: number
  /** @example 0 */
  negativePerc?: number
  /** @example 100 */
  neutralPerc?: number
  links?: string[]
}

export type AnalyticsFetchHotLinksResponse =
  AnalyticsFetchHotLinksResponseItem[]

export interface AnalyticsKeywordsAnalysisResponseItem {
  /** @example "Atlassian" */
  keyword?: string
  /** @example 10 */
  positives?: number
  /** @example 10 */
  negatives?: number
  /** @example 30 */
  neutrals?: number
  /** @example 50 */
  total?: number
  /** @example 20 */
  positivePercentage?: number
  /** @example 20 */
  negativePercentage?: number
  /** @example 60 */
  neutralPercentage?: number
  /** @example "Neutral" */
  mostlyRated?: string
}

export interface AnalyticsKeywordsAnalysisResponse {
  /** @example true */
  success?: boolean
  sentiments?: AnalyticsKeywordsAnalysisResponseItem[]
  selectedKeywords?: string[]
  positive?: number
  negative?: number
  neutral?: number
  allKeywords?: AnalyticsKeywordsAnalysisResponseItem[]
}

export interface AnalyticsFetchLocationsResponseRegionCountry {
  /** @example "sweden" */
  name?: string
  /** @example 4 */
  total?: number
}

export interface AnalyticsFetchLocationsResponseItemValue {
  /** @example "northern europe" */
  name?: string
  /** @example 1 */
  positives?: number
  /** @example 1 */
  negatives?: number
  /** @example 23 */
  neutrals?: number
  /** @example 25 */
  total?: number
  /** @example "POS" */
  mostlyRatedAs?: string
  /** @example 62.153637 */
  lat?: number
  /** @example 16.908783 */
  lng?: number
  countries?: AnalyticsFetchLocationsResponseRegionCountry[]
}

export interface AnalyticsFetchLocationsResponse {
  /** @example 211 */
  totalMentions?: number
  locations?: Record<string, AnalyticsFetchLocationsResponseItemValue>
}

export interface AnalyticsFetchMostMentionsResponseItem {
  /** @example "63f3841772f56a167fb29f3e" */
  campaign?: string
  /** @example "Car brands from Germany" */
  name?: string
  /** @example 1403 */
  mentions?: number
  /** @example 5 */
  positives?: number
  /** @example 3 */
  negatives?: number
  /** @example 1395 */
  neutrals?: number
  /** @example 13 */
  percentage?: number
}

export interface AnalyticsFetchMostMentionsResponse {
  result?: AnalyticsFetchMostMentionsResponseItem[]
}

export interface AnalyticsFetchPositivityPercentResponse {
  /** @example 10991 */
  mentions?: number
  /** @example 0.31 */
  positivePerc?: number
  /** @example 0.12 */
  negativePerc?: number
  /** @example 99.57 */
  neutralPerc?: number
}

export interface AnalyticsFetchQuickDetailsResponseItemTopSource {
  /**
   * Source platform of the mentions
   * @example "twitter"
   */
  source?: string
  /**
   * Total number of mentions from this source
   * @example 3339
   */
  total?: number
}

export interface AnalyticsFetchQuickDetailsResponseItem {
  /**
   * Unique identifier of the campaign
   * @example "63edff558461ed8014705982"
   */
  campaign?: string
  /**
   * Name of the campaign
   * @example "Opinions: War in Ukraine"
   */
  name?: string
  /**
   * Count of positive mentions
   * @example 0
   */
  positives?: number
  /**
   * Count of negative mentions
   * @example 0
   */
  negatives?: number
  /**
   * Count of neutral mentions
   * @example 8424
   */
  neutrals?: number
  /**
   * Total number of mentions
   * @example 8424
   */
  total?: number
  /**
   * Percentage of positive mentions
   * @example 0
   */
  positivePerc?: number
  /**
   * Percentage of negative mentions
   * @example 0
   */
  negativePerc?: number
  /**
   * Percentage of neutral mentions
   * @example 100
   */
  neutralPerc?: number
  /** List of sources and their mention counts */
  topSources?: AnalyticsFetchQuickDetailsResponseItemTopSource[]
}

/** Array of campaign analytics data, sorted by total mentions in descending order */
export type AnalyticsFetchQuickDetailsResponse =
  AnalyticsFetchQuickDetailsResponseItem[]

export interface AnalyticsFetchRadarChartResponseItem {
  /** @example "Analyse: Atlassian" */
  campaign?: string
  /** @example 5 */
  positives?: number
  /** @example 10 */
  negatives?: number
  /** @example 15 */
  total?: number
}

export interface AnalyticsFetchRadarChartResponse {
  result?: AnalyticsFetchRadarChartResponseItem[]
}

export enum AnalyticsFetchThreadsIsLostType {
  True = 'true',
  False = 'false',
  Both = 'both',
}

export interface LanguageItem {
  /** @example "English" */
  language?: string
  /** @example 99 */
  total?: number
}

export interface MentionFormatItem {
  /** @example "hashtag" */
  format?: 'hashtag' | 'handle' | 'keyword'
  /** @example 99 */
  total?: number
}

export interface MentionTypeItem {
  /**
   * social_media_mention_type bucket; 'unknown' aggregates docs with null/missing field
   * @example "post"
   */
  type?: string
  /** @example 99 */
  total?: number
}

export interface AnalyticsFetchSentimentAnalysisResponseDataSourceItem {
  /** @example "facebook" */
  source?: string
  /** @example 1 */
  positives?: number
  /** @example 0 */
  negatives?: number
  /** @example 5 */
  neutrals?: number
  /** @example 6 */
  total?: number
  /** @example 16.67 */
  positivePercentage?: number
  /** @example 0 */
  negativePercentage?: number
  /** @example 83.33 */
  neutralPercentage?: number
}

export interface AnalyticsFetchSentimentAnalysisResponseDataKeywordItem {
  /** @example "Messi" */
  keyword?: string
  /** @example "651a95db66f56e2e327ed4b6" */
  campaign?: string
  /** @example "AzerGold " */
  campaign_name?: string
  /** @example 0 */
  positives?: number
  /** @example 0 */
  negatives?: number
  /** @example 1 */
  neutrals?: number
  /** @example 1 */
  total?: number
  /** @example 0 */
  positivePercentage?: number
  /** @example 0 */
  negativePercentage?: number
  /** @example 100 */
  neutralPercentage?: number
}

export interface AnalyticsFetchSentimentAnalysisResponseData {
  /** @example 5 */
  positives?: number
  /** @example 10 */
  negatives?: number
  /** @example 649 */
  neutrals?: number
  /** @example 0.75 */
  positivePercentage?: number
  /** @example 1.51 */
  negativePercentage?: number
  /** @example 97.74 */
  neutralPercentage?: number
  allSources?: AnalyticsFetchSentimentAnalysisResponseDataSourceItem[]
  allKeywords?: AnalyticsFetchSentimentAnalysisResponseDataKeywordItem[]
  /** @example ["facebook"] */
  selectedSources?: string[]
  /** @example ["Messi"] */
  selectedKeywords?: string[]
  /** @example [{"language":"English","total":99},{"language":"Spanish","total":99},{"language":"French","total":99}] */
  allLanguages?: LanguageItem[]
  /** @example ["English","Spanish"] */
  checkedLanguages?: string[]
  /** @example [{"format":"hashtag","total":99},{"format":"handle","total":12},{"format":"keyword","total":99}] */
  allMentionsFormat?: MentionFormatItem[]
  /** @example ["hashtag","handle","keyword"] */
  selectedMentionFormat?: string[]
  /** @example [{"type":"post","total":9803},{"type":"comment","total":44},{"type":"article","total":0},{"type":"unknown","total":254748}] */
  allMentionsType?: MentionTypeItem[]
  /** @example ["post","comment"] */
  selectedMentionType?: string[]
  isLost?: AnalyticsFetchThreadsIsLostType
}

export interface AnalyticsFetchSentimentAnalysisResponse {
  /** @example true */
  success?: boolean
  data?: AnalyticsFetchSentimentAnalysisResponseData
}

export interface AnalyticsSentimentChartAxisData {
  min?: number
  max?: number
  interval?: number
}

export interface AnalyticsFetchSentimentChartResponseDataItem {
  /** @example "twitter" */
  source?: string
  /** @example [[1678748400000,-2],[1678773600000,-1],[1678784400000,1],[1678788000000,-1]] */
  data?: number[][]
}

export interface AnalyticsFetchSentimentChartResponse {
  /** @example {"min":1678737600000,"max":1678823999999,"interval":3600000} */
  XAxis?: AnalyticsSentimentChartAxisData
  /** @example {"min":-20,"max":20} */
  YAxis?: AnalyticsSentimentChartAxisData
  /** @example [] */
  allCampaigns?: string[]
  /** @example ["Trello","Bitbucket","Confluence","Jira"] */
  allKeywords?: string[]
  /** @example ["Twitter","Reddit","Youtube","news & blogs"] */
  allSources?: string[]
  /** @example [] */
  checkedCampaigns?: string[]
  /** @example ["Trello","Bitbucket"] */
  checkedKeywords?: string[]
  /** @example ["reddit","twitter"] */
  checkedSources?: string[]
  data?: AnalyticsFetchSentimentChartResponseDataItem[]
}

export enum AnalyticsFetchThreadsSentimentType {
  POS = 'POS',
  NEG = 'NEG',
  NEU = 'NEU',
}

export enum AnalyticsFetchThreadsVectorType {
  Desc = 'desc',
  Asc = 'asc',
}

export interface AnalyticsFetchThreadsSupervisedSentiment {
  /** @example ["good"] */
  chatched_positive_keywords?: string[]
  /** @example [] */
  chatched_negative_keywords?: string[]
  /** @example 1 */
  positive_count?: number
  /** @example 0 */
  negative_count?: number
  /** @example 1 */
  positivity_score?: number
  /** @example "POS" */
  output?: string
}

export interface AnalyticsFetchThreadsResponseDataItem {
  /** @example "1234567890abcdef12345678" */
  _id?: string
  /**
   * Comments stored for the post this mention points at (social_posts.storedComments summed over the canonical URL). 0 when none were collected.
   * @example 12
   */
  commentsCount?: number
  /** @example "638483bf7c37f93cf946d870" */
  campaign?: string
  /** @example "England on Reddit" */
  campaign_name?: string
  /** @example "Bellingham" */
  keyword?: string
  /** @example "https://reddit.com/r/FIFA/comments/10k75ac/i_packed_bellingham_what_is_the_best_chem_i_can/" */
  origin?: string
  /** @example "https://reddit.com/r/FIFA/comments/10k75ac/i_packed_bellingham_what_is_the_best_chem_i_can/" */
  link?: string
  /** @example "reddit" */
  source?: string
  /** @example 5 */
  score?: number
  /** @example "I packed Bellingham what is the best chem I can put on him." */
  text?: string
  /** @example "2023-01-24T14:49:09.000Z" */
  published_at?: string
  /** @example "POS" */
  output?: string
  /** @example ["good"] */
  positive_keywords?: string[]
  /** @example [] */
  negative_keywords?: string[]
  /** @example "english" */
  language?: string
  /** @example "en" */
  original_lang_code?: string
  /** @example false */
  irrelevant?: boolean
  /**
   * Type of social media mention (e.g., comment, post, share). Returns null if not available.
   * @example "comment"
   */
  /**
   * Who published the post — stored at ingest (Sentione author) or from the scraped post. Null when unknown and for news.
   * @example "BMG • ბიემჯი"
   */
  author_name?: string | null
  /**
   * The author's profile picture, when the source gave one. Some platforms' URLs expire; fall back to the platform icon.
   * @example "https://graph.facebook.com/615313671911493/picture"
   */
  author_avatar?: string | null
  /**
   * News and websites only: the outlet, from the site's og:site_name (looked up once per host), else its host ("bm.ge"). Null for social posts.
   * @example "BMG"
   */
  source_name?: string | null
  social_media_mention_type?: string | null
  /** @example "I packed Bellingham what is the best chem I can put on him." */
  translated?: string
  supervised_sentiment?: AnalyticsFetchThreadsSupervisedSentiment
}

export interface AnalyticsFetchThreadsResponse {
  /** @example true */
  success?: boolean
  data?: AnalyticsFetchThreadsResponseDataItem[]
  selectedSources?: string[]
  selectedKeywords?: string[]
  allSources?: string[]
  allKeywords?: string[]
  allLanguages?: string[]
  checkedLanguages?: string[]
}

export enum FetchThreadsCSVVectorType {
  Desc = 'desc',
  Asc = 'asc',
}

export interface AnalyticsFetchTopSourcesResponseItem {
  /** @example "twitter" */
  name?: string
  /** @example 5 */
  positives?: number
  /** @example 10 */
  negatives?: number
  /** @example 649 */
  neutrals?: number
  /** @example 664 */
  total?: number
  /** @example 0.75 */
  positivePercentage?: number
  /** @example 1.51 */
  negativePercentage?: number
  /** @example 97.74 */
  neutralPercentage?: number
}

export type AnalyticsFetchTopSourcesResponse =
  AnalyticsFetchTopSourcesResponseItem[]

export interface AnalyticsOverviewSummary {
  /**
   * Total mentions across all campaigns
   * @example 12450
   */
  totalMentions?: number
  /**
   * Percentage change vs previous period
   * @example 12
   */
  mentionsTrend?: number
  /**
   * Count of positive mentions
   * @example 5602
   */
  positives?: number
  /**
   * Count of negative mentions
   * @example 2490
   */
  negatives?: number
  /**
   * Count of neutral mentions
   * @example 4358
   */
  neutrals?: number
  /**
   * Percentage of positive mentions
   * @example 45
   */
  positivePerc?: number
  /**
   * Percentage of neutral mentions
   * @example 35
   */
  neutralPerc?: number
  /**
   * Percentage of negative mentions
   * @example 20
   */
  negativePerc?: number
  /**
   * Number of active campaigns
   * @example 7
   */
  activeCampaigns?: number
  /**
   * Total number of campaigns
   * @example 12
   */
  totalCampaigns?: number
}

export interface AnalyticsCampaignHealthItem {
  /**
   * Campaign ID
   * @example "64ad3923615e4b80a14895b0"
   */
  id?: string
  /**
   * Campaign name
   * @example "Summer Promo 2025"
   */
  name?: string
  /**
   * Total mentions for this campaign
   * @example 3420
   */
  mentions?: number
  /**
   * Percentage change vs previous period (positive = up, negative = down)
   * @example 11
   */
  trend?: number
  /**
   * Count of positive mentions
   * @example 2462
   */
  positives?: number
  /**
   * Count of negative mentions
   * @example 616
   */
  negatives?: number
  /**
   * Count of neutral mentions
   * @example 342
   */
  neutrals?: number
  /**
   * Percentage of positive mentions
   * @example 72
   */
  positivePerc?: number
  /**
   * Percentage of neutral mentions
   * @example 10
   */
  neutralPerc?: number
  /**
   * Percentage of negative mentions
   * @example 18
   */
  negativePerc?: number
}

export interface AnalyticsOverviewResponse {
  summary?: AnalyticsOverviewSummary
  campaignHealth?: AnalyticsCampaignHealthItem[]
}

export interface AnalyticsFetchTopKeywordsResponseStats {
  /** @example 0 */
  avgDailyNegativeMentionCount?: number
  /** @example 1 */
  avgDailyNegativeMentionCountChange?: number
  /** @example 1 */
  avgDailyPositiveMentionCount?: number
  /** @example 1 */
  avgDailyPositiveMentionCountChange?: number
  /** @example 186 */
  avgMentionPerKeyword?: number
}

export interface AnalyticsFetchTopKeywordsResponseTopKeyword {
  /** @example "Biden" */
  name?: string
  /** @example 27 */
  positives?: number
  /** @example 34 */
  negatives?: number
  /** @example 2414 */
  mentionsCount?: number
}

export interface AnalyticsFetchTopKeywordsResponse {
  stats?: AnalyticsFetchTopKeywordsResponseStats
  topKeywords?: AnalyticsFetchTopKeywordsResponseTopKeyword[]
}

export interface CampaignCategory {
  categories?: string[]
  /** @example true */
  success?: boolean
}

export interface CampaignCompareRequest {
  /**
   * Array of campaign IDs to compare
   * @maxItems 9
   * @minItems 2
   * @example ["63ff25da11b15267d928b99c","63ff25da11b15267d928b99d"]
   */
  campaignIds: string[]
  /**
   * Optional benchmark campaign ID
   * @example "63ff25da11b15267d928b99c"
   */
  benchmarkCampaignId?: string
  /**
   * Metrics to include in comparison
   * @minItems 1
   * @example ["mentions","sources","sentiments"]
   */
  metrics: ('mentions' | 'sources' | 'sentiments')[]
}

export interface CampaignCompareResponse {
  /** @example true */
  success?: boolean
  data?: {
    campaigns?: CampaignComparisonData[]
    stats?: ComparisonStats
    savedPreferences?: SavedComparisonPreferences
  }
}

export interface CampaignComparisonData {
  /** @example "63ff25da11b15267d928b99c" */
  id?: string
  /** @example "Summer Campaign 2023" */
  name?: string
  /** @example 1250 */
  mentions?: number
  sources?: SourceBreakdown
  sentiments?: SentimentBreakdown
}

export interface SourceBreakdown {
  /** @example 120 */
  facebook?: number
  /** @example 85 */
  instagram?: number
  /** @example 234 */
  twitter?: number
  /** @example 45 */
  linkedin?: number
  /** @example 67 */
  reddit?: number
  /** @example 89 */
  youtube?: number
  /** @example 156 */
  tiktok?: number
  /** @example 34 */
  google?: number
  /** @example 12 */
  googleReviews?: number
  /** @example 8 */
  tripadvisor?: number
  /** @example 5 */
  booking?: number
  /** @example 289 */
  websites?: number
  /** @example 98 */
  newsBlogs?: number
  /** @example 8 */
  yandex?: number
}

export interface SentimentBreakdown {
  /**
   * Count of positive interactions
   * @example 60
   */
  positive: {
    count?: number
    percentage?: number
  }
  /**
   * Count of negative interactions
   * @example 12
   */
  negative: {
    count?: number
    percentage?: number
  }
  /**
   * Count of neutral interactions
   * @example 28
   */
  neutral: {
    count?: number
    percentage?: number
  }
  positivePercentage?: number
  neutralPercentage?: number
  negativePercentage?: number
  total: number
}

export interface ComparisonStats {
  /** @example 3750 */
  totalMentions?: number
  mostMentionsCampaign?: {
    /** @example "63ff25da11b15267d928b99c" */
    id?: string
    /** @example "Summer Campaign 2023" */
    name?: string
    /** @example 1250 */
    count?: number
  } | null
  leastMentionsCampaign?: {
    /** @example "63ff25da11b15267d928b99d" */
    id?: string
    /** @example "Winter Campaign 2023" */
    name?: string
    /** @example 850 */
    count?: number
  } | null
  mostPopularSource?: {
    /** @example "websites" */
    name?: string
    /** @example 867 */
    count?: number
  } | null
  leastPopularSource?: {
    /** @example "booking" */
    name?: string
    /** @example 15 */
    count?: number
  } | null
  mostPositiveCampaign?: {
    /** @example "63ff25da11b15267d928b99c" */
    id?: string
    /** @example "Summer Campaign 2023" */
    name?: string
    /**
     * @format float
     * @example 65.5
     */
    percentage?: number
  } | null
  mostNegativeCampaign?: {
    /** @example "63ff25da11b15267d928b99d" */
    id?: string
    /** @example "Winter Campaign 2023" */
    name?: string
    /**
     * @format float
     * @example 28.3
     */
    percentage?: number
  } | null
}

export type SavedComparisonPreferences = {
  /** @example ["63ff25da11b15267d928b99c","63ff25da11b15267d928b99d"] */
  campaignIds?: string[]
  /** @example ["mentions","sources","sentiments"] */
  metrics?: string[]
  dateRange?: {
    /**
     * @format date-time
     * @example "2023-03-01T00:00:00.000Z"
     */
    fromDate?: string
    /**
     * @format date-time
     * @example "2023-03-31T23:59:59.999Z"
     */
    toDate?: string
  } | null
  /** @example "63ff25da11b15267d928b99c" */
  benchmarkCampaignId?: string | null
  /**
   * @format date-time
   * @example "2024-01-20T14:45:00.000Z"
   */
  lastUpdated?: string
}

export interface DailyPositivityCampaignResponse {
  /** @example 0.1 */
  changePercentage?: number
  /** @example 100 */
  mentions?: number
  /** @example "asd" */
  name?: string
}

export interface CampaignFetchTopLocationData {
  /** @example "asd" */
  country?: string
  /** @example 0.1 */
  lat?: number
  /** @example 0.1 */
  lng?: number
  /** @example 100 */
  mentions?: number
}

export interface CampaignFetchTopSourceData {
  /** @example 100 */
  mentions?: number
  /** @example 0.1 */
  negativePercentage?: number
  /** @example 0.1 */
  neutralPercentage?: number
  /** @example 0.1 */
  positivePercentage?: number
  /** @example "asd" */
  source?: string
}

export interface CampaignPayloadKeyword {
  categories?: string[]
  /** @example "asd" */
  name?: string
  negative?: string[]
  positive?: string[]
  /** Selected suggested keyword variations persisted with the keyword. */
  variations?: string[]
  /** Languages selected for variation generation, persisted with the keyword. */
  variationLanguages?: string[]
}

export interface CampaignStatsTopSource {
  /** @example "twitter" */
  source?: string
  /** @example 4246 */
  mentions?: number
  /** @example 1416 */
  positiveMentions?: number
  /** @example 322 */
  negativeMentions?: number
}

export interface CampaignStatsTopKeyword {
  /** @example "asd" */
  keyword?: string
  /** @example 13 */
  mentions?: number
}

export interface CampaignKeyword {
  /** @example "asd" */
  _id?: string
  /** @example "asd" */
  name?: string
  negative?: string[]
  positive?: string[]
}

export interface CampaignStats {
  /** @example 13 */
  keywordsCount?: number
  /** @example 13 */
  mentions?: number
  /** @example 13 */
  negativeMentionsCount?: number
  /** @example "asd" */
  negativeRatio?: string
  /** @example 13 */
  neutralMentionsCount?: number
  /** @example "asd" */
  neutralRatio?: string
  /** @example 13 */
  positiveMentionsCount?: number
  /** @example "asd" */
  positiveRatio?: string
  sources?: CampaignStatsTopSource[]
  topKeywords?: CampaignStatsTopKeyword[]
}

export interface CampaignType {
  /** @example "asd" */
  _id?: string
  categories?: string[]
  /** @example "asd" */
  createdAt?: string
  /** @example "asd" */
  from?: string
  keywords?: CampaignKeyword[]
  /** Keywords to exclude from campaign results */
  irrelevant_keywords?: string[]
  /** @example "asd" */
  name?: string
  stats?: CampaignStats
  /** @example "asd" */
  status?: string
  tags?: string[]
  targets?: string[]
  facebook_target_endpoints?: string[]
  instagram_target_endpoints?: string[]
  /** @example 13 */
  timezone?: number
  /** @example "asd" */
  timezoneName?: string
  /** @example "asd" */
  to?: string
  /** @example "asd" */
  updatedAt?: string
  /** @example "asd" */
  user?: string
}

export interface CampaignPayload {
  /** Campaign categories */
  categories?: string[]
  deletedKeyWords?: string[]
  keywords?: CampaignPayloadKeyword[]
  /** Keywords to exclude from campaign results */
  irrelevant_keywords?: string[]
  facebook_target_endpoints?: string[]
  /** @example "asd" */
  from?: string
  /** @example "asd" */
  to?: string
  instagram_target_endpoints?: string[]
  /** @example "asd" */
  name?: string
  /** @example "asd" */
  status?: string
  tags?: string[]
  targets?: string[]
  /** @example 13 */
  timezone?: number
  /** @example "asd" */
  timezoneName?: string
}

export interface CampaignResponse {
  campaign?: CampaignType
  /** @example true */
  success?: boolean
}

export interface FetchCampaignByIdResponse {
  campaign?: CampaignType
  /** @example true */
  success?: boolean
}

export interface FetchCampaignsResponse {
  campaigns?: CampaignType[]
  /** @example true */
  success?: boolean
}

export interface UpdateCampaignResponse {
  campaign?: CampaignType
  /** @example true */
  success?: boolean
}

export interface CampaignDelete {
  /** @example true */
  success?: boolean
}

export interface CampaignTargetResponse {
  /** @example true */
  success?: boolean
  /** @example ["Frontpage","Forums","Blog","TV","Instagram","Article","Facebook","Twitter","Comment","Other Social","Tumblr","Video","Review","News","Threads"] */
  targets?: string[]
}

export interface CampaignsOverviewCounts {
  /**
   * All campaigns visible to the session, filtered by campaignIds if provided
   * @example 24
   */
  total?: number
  /**
   * Subset where campaign.status === 'active'
   * @example 12
   */
  active?: number
}

/**
 * positives + neutrals + negatives + unclassified === total. `unclassified` covers
 * mentions whose sentiment did not resolve to POS/NEU/NEG.
 */
export interface CampaignsOverviewMentions {
  /** @example 152340 */
  total?: number
  /** @example 62000 */
  positive?: number
  /** @example 70000 */
  neutral?: number
  /** @example 20340 */
  negative?: number
  /** @example 0 */
  unclassified?: number
  /**
   * @format float
   * @example 0.407
   */
  positiveRatio?: number
  /**
   * @format float
   * @example 0.459
   */
  neutralRatio?: number
  /**
   * @format float
   * @example 0.134
   */
  negativeRatio?: number
}

export type CampaignsOverviewSourceWinner = {
  /** @example "twitter" */
  source?: string
  /** @example 50000 */
  mentions?: number
  /** @example 30000 */
  positiveMentions?: number
  /** @example 5000 */
  negativeMentions?: number
  /**
   * @format float
   * @example 0.6
   */
  positiveRatio?: number
  /**
   * @format float
   * @example 0.1
   */
  negativeRatio?: number
} | null

export interface CampaignsOverviewSources {
  /** @example 7 */
  uniqueCount?: number
  mostPositive?: CampaignsOverviewSourceWinner
  mostNegative?: CampaignsOverviewSourceWinner
}

export type CampaignsOverviewCampaignWinner = {
  /** @example "6a04924e2b80b7842af3d32f" */
  id?: string
  /** @example "Spring Launch" */
  name?: string
  /** @example 32000 */
  mentions?: number
  /** @example 22000 */
  positiveMentions?: number
  /** @example 1000 */
  negativeMentions?: number
  /**
   * @format float
   * @example 0.6875
   */
  positiveRatio?: number
  /**
   * @format float
   * @example 0.0313
   */
  negativeRatio?: number
} | null

export interface CampaignsOverviewTopCampaign {
  mostPositive?: CampaignsOverviewCampaignWinner
  mostNegative?: CampaignsOverviewCampaignWinner
}

export type CampaignsOverviewKeywordWinner = {
  /** @example "great" */
  keyword?: string
  /** @example 4200 */
  mentions?: number
  /** @example 3100 */
  positiveMentions?: number
  /** @example 200 */
  negativeMentions?: number
  /**
   * @format float
   * @example 0.738
   */
  positiveRatio?: number
  /**
   * @format float
   * @example 0.0476
   */
  negativeRatio?: number
} | null

export interface CampaignsOverviewTopKeyword {
  mostPositive?: CampaignsOverviewKeywordWinner
  mostNegative?: CampaignsOverviewKeywordWinner
}

export interface CampaignsOverviewData {
  campaigns?: CampaignsOverviewCounts
  /**
   * positives + neutrals + negatives + unclassified === total. `unclassified` covers
   * mentions whose sentiment did not resolve to POS/NEU/NEG.
   */
  mentions?: CampaignsOverviewMentions
  sources?: CampaignsOverviewSources
  topCampaign?: CampaignsOverviewTopCampaign
  topKeyword?: CampaignsOverviewTopKeyword
}

export interface CampaignsOverviewResponse {
  /** @example true */
  success?: boolean
  data?: CampaignsOverviewData
}

export interface ContentAnalysisPageUrl {
  /**
   * @format uri
   * @example "https://instagram.com/competitor1"
   */
  pageLink: string
  /** @example "instagram" */
  platform:
    | 'instagram'
    | 'facebook'
    | 'twitter'
    | 'linkedin'
    | 'tiktok'
    | 'youtube'
}

export interface ContentAnalysisPostUrl {
  /**
   * @format uri
   * @example "https://instagram.com/p/ABC123"
   */
  postLink: string
  /** @example "instagram" */
  platform:
    | 'instagram'
    | 'facebook'
    | 'twitter'
    | 'linkedin'
    | 'tiktok'
    | 'youtube'
}

export interface ContentAnalysisRecentPosts {
  /**
   * @min 1
   * @max 50
   * @default 10
   * @example 10
   */
  postCount?: number
  /** @minItems 1 */
  urls: ContentAnalysisPageUrl[]
}

export interface ContentAnalysisSpecificPosts {
  /** @minItems 1 */
  urls: ContentAnalysisPostUrl[]
}

export interface ContentAnalysisCaptionSearch {
  /**
   * @maxLength 100
   * @example "hapttic"
   */
  keyword: string
  /** @minItems 1 */
  urls: ContentAnalysisPageUrl[]
}

export interface ContentAnalysisPayload {
  /**
   * @maxLength 200
   * @example "My Competitor Analysis"
   */
  title: string
  /** @example "active" */
  status?: 'active' | 'completed' | 'paused' | 'draft'
  /**
   * Content analysis categories
   * @example ["competitor","influencer"]
   */
  categories?: string[]
  recentPosts?: ContentAnalysisRecentPosts
  specificPosts?: ContentAnalysisSpecificPosts
  captionSearch?: ContentAnalysisCaptionSearch
}

export interface ContentAnalysisType {
  /** @example "65f1234567890abcdef12345" */
  _id?: string
  /** @example "507f1f77bcf86cd799439011" */
  user?: string
  /** @example "My Competitor Analysis" */
  title?: string
  /** @example "active" */
  status?: 'active' | 'completed' | 'paused' | 'draft'
  /** Content analysis categories */
  categories?: string[]
  recentPosts?: ContentAnalysisRecentPosts
  specificPosts?: ContentAnalysisSpecificPosts
  captionSearch?: ContentAnalysisCaptionSearch
  /**
   * @format date-time
   * @example "2024-01-15T10:30:00.000Z"
   */
  createdAt?: string
  /**
   * @format date-time
   * @example "2024-01-20T14:45:00.000Z"
   */
  updatedAt?: string
}

export interface ContentAnalysisSingleResponse {
  /** @example true */
  success?: boolean
  data?: ContentAnalysisType
}

export interface ContentAnalysisSourceItem {
  /** @example "facebook" */
  platform?:
    | 'instagram'
    | 'facebook'
    | 'twitter'
    | 'linkedin'
    | 'tiktok'
    | 'youtube'
  /**
   * Page URL or post URL for this source
   * @format uri
   * @example "https://www.facebook.com/mypage"
   */
  link?: string | null
}

export interface ContentAnalysisListItem {
  /** @example "65f1234567890abcdef12345" */
  _id?: string
  /** @example "My Competitor Analysis" */
  title?: string
  /** @example "active" */
  status?: 'active' | 'completed' | 'paused' | 'draft'
  /** Content analysis categories */
  categories?: string[]
  sources?: ContentAnalysisSourceItem[]
  /** @example 3 */
  urlsCount?: number
  quickStats?: {
    /** @example 1250 */
    reactions?: number
    /** @example 42 */
    comments?: number
    /** @example 15 */
    shares?: number
  }
  topKeywords?: {
    keyword?: string
    count?: number
  }[]
  /** Top 5 phrases from precomputed engagement data */
  topPhrases?: {
    /** @example "beautiful project" */
    keyword?: string
    /** @example 164 */
    count?: number
    /** @example "positive" */
    sentiment?: 'positive' | 'neutral' | 'negative'
  }[]
  /** @example 64 */
  totalPosts?: number
  /** @example 10 */
  positives?: number
  /** @example 5 */
  negatives?: number
  /** @example 27 */
  neutrals?: number
  /** @example 23.8 */
  positivesPerc?: number
  /** @example 11.9 */
  negativesPerc?: number
  /** @example 64.3 */
  neutralsPerc?: number
  /** @format date-time */
  createdAt?: string
  /** @format date-time */
  updatedAt?: string
}

export interface ContentAnalysisListResponse {
  /** @example true */
  success?: boolean
  data?: ContentAnalysisListItem[]
}

export interface ContentAnalysisDeleteResponse {
  /** @example true */
  success?: boolean
  /** @example "Content analysis deleted successfully" */
  message?: string
}

export interface ContentAnalysisErrorResponse {
  /** @example false */
  success?: boolean
  /** @example "Error message" */
  error?: string
}

export interface ContentAnalysisValidationErrorResponse {
  /** @example false */
  success?: boolean
  /** @example "Validation failed" */
  error?: string
  /** @example ["Title is required and must be a non-empty string"] */
  errors?: string[]
}

export interface ContentPerformancePlatform {
  platform?:
    | 'facebook'
    | 'instagram'
    | 'tiktok'
    | 'twitter'
    | 'linkedin'
    | 'youtube'
  posts?: number
  reactions?: number
  comments?: number
  shares?: number
  /** null when the platform did not report views (Facebook and Instagram hide them on post pages) */
  views?: number | null
  followers?: number
  /** Engagement rate by reach */
  err?: number
  /** Engagement rate by views */
  erv?: number | null
  postsBreakdown?: {
    textOnly?: number
    withPicture?: number
    withVideo?: number
  }
}

export interface ContentPerformanceResponse {
  /** @example true */
  success?: boolean
  data?: {
    platforms?: ContentPerformancePlatform[]
  }
}

export interface CommentItem {
  id?: string
  author?: string
  content?: string
  highlightedWords?: string[]
  platform?:
    | 'facebook'
    | 'instagram'
    | 'tiktok'
    | 'twitter'
    | 'linkedin'
    | 'youtube'
  sentiment?: 'positive' | 'neutral' | 'negative'
  /**
   * URL of the post this comment belongs to
   * @format uri
   * @example "https://www.facebook.com/page/posts/abc123"
   */
  postUrl?: string | null
}

export interface CommentsResponse {
  /** @example true */
  success?: boolean
  data?: {
    totalComments?: number
    sentimentBreakdown?: SentimentBreakdown
    comments?: CommentItem[]
  }
}

export interface PostComment {
  author?: string
  content?: string
  sentiment?: 'positive' | 'neutral' | 'negative'
  timestamp?: string
}

export interface IndividualPost {
  id?: string
  platform?:
    | 'facebook'
    | 'instagram'
    | 'tiktok'
    | 'twitter'
    | 'linkedin'
    | 'youtube'
  content?: string
  date?: string
  imageUrl?: string
  reactions?: number
  shares?: number
  /** Instagram only: the repost count, separate from shares. Absent when not reported (never an invented 0). Not part of engagement. */
  reposts?: number
  /** null when the platform did not report views (Facebook and Instagram hide them on post pages) */
  views?: number | null
  /** true when views came from the page's Reels grid, which Facebook rounds ("3.1M") */
  viewsApproximate?: boolean
  commentsCount?: number
  duplicatesCount?: number
  commentsBreakdown?: {
    positive?: number
    neutral?: number
    negative?: number
  }
  comments?: PostComment[]
}

export interface IndividualPostsResponse {
  /** @example true */
  success?: boolean
  data?: {
    totalCount?: number
    /** Number of posts per platform */
    platformCounts?: {
      facebook?: number
      instagram?: number
      tiktok?: number
      twitter?: number
      linkedin?: number
      youtube?: number
    }
    posts?: IndividualPost[]
  }
}

export interface KeywordItem {
  keyword?: string
  count?: number
  sentiment?: 'positive' | 'neutral' | 'negative'
}

export interface EmojiItem {
  emoji?: string
  count?: number
}

export interface ReactionItem {
  emoji?: string
  name?: string
  count?: number
}

export interface EngagementInsightsResponse {
  /** @example true */
  success?: boolean
  data?: {
    /** Keywords broken down by comments/captions and platform */
    keywords?: object
    /** Multi-word phrases broken down by comments/captions and platform. Same structure as keywords. */
    phrases?: object
    /** Emojis broken down by comments/captions and platform */
    emojis?: object
    /** Reactions broken down by platform */
    reactions?: object
  }
}

export interface ActivityFrequencyResponse {
  /** @example true */
  success?: boolean
  data?: {
    /** Day names (Mon-Sun) */
    xAxis?: string[]
    /** Hour labels (24 hours) */
    yAxis?: string[]
    /** Subset of hours to show on axis */
    visibleHours?: string[]
    /** Post frequency by platform. Each key (allPlatform, facebook, etc.) maps to an object with data and averages. */
    posts?: Record<string, ActivityFrequencyPlatform>
    /** Engagement frequency by platform. Same structure as posts. */
    engagement?: Record<string, ActivityFrequencyPlatform>
  }
}

export interface ActivityFrequencyPlatform {
  /** 24x7 heatmap grid (rows=hours, cols=days) */
  data?: number[][]
  /**
   * Average value per hour across all days. Keys are hour strings (e.g. '00:00', '15:00').
   * @example {"00:00":4,"15:00":12}
   */
  averages?: Record<string, number>
}

export interface InsightSource {
  /**
   * Free-form label such as "Facebook", "Instagram", "WhatsApp",
   * "Conversation #123", or "Operator Anna".
   */
  platform:
    | 'facebook'
    | 'instagram'
    | 'tiktok'
    | 'twitter'
    | 'linkedin'
    | 'youtube'
  /** Quoted snippet shown in the modal. */
  text: string
  links?: {
    url: string
    /** @format date-time */
    date: string
    /** BCP-47 language tag */
    language: string
  }[]
}

export interface SmartInsightItem {
  id?: string
  type?: 'strength' | 'challenge'
  category?:
    | 'influencer_opportunities'
    | 'brand_health_signals'
    | 'content_recommendations'
    | 'crisis_warnings'
  title?: string
  details?: string
  aiRecommendation?: string
  percentageChange?: number
  sources?: InsightSource[]
}

export interface PlatformCategorizationResponse {
  type: 'platform'
  /**
   * Array of category tags with platform breakdown.
   * Category names come from the per-page taxonomy in `inbox_category_taxonomy`
   * (e.g. "Course Inquiry", "Pricing & Payment", "Other"). The set is dynamic
   * per page — do not assume a fixed list. "Other" is always present.
   * Empty array if the page has no precomputed data in the range.
   */
  data: PlatformTagData[]
  stats: CategorizationStats
}

export interface OperatorCategorizationResponse {
  type: 'operator'
  /**
   * Array of category tags with operator breakdown.
   * Category names come from the per-page taxonomy in `inbox_category_taxonomy`
   * (e.g. "Course Inquiry", "Pricing & Payment", "Other"). The set is dynamic
   * per page — do not assume a fixed list. "Other" is always present.
   * Empty array if the page has no precomputed data in the range.
   */
  data: OperatorTagData[]
  /** List of operators with their IDs and names (empty array if no data) */
  operators: OperatorInfo[]
  stats: CategorizationStats
}

export interface PlatformTagData {
  /**
   * Category identifier — equal to the taxonomy category `name`.
   * Free-form string drawn from the per-page taxonomy (may contain
   * spaces, ampersands, Unicode). Do not validate against a fixed enum.
   * @example "Course Inquiry"
   */
  id: string
  /**
   * Category display name (same as `id`, kept for UI compatibility).
   * @example "Course Inquiry"
   */
  name: string
  conversations: {
    /**
     * Count of conversations on Facebook
     * @example 12000
     */
    facebook: number
    /**
     * Count of conversations on Instagram
     * @example 6000
     */
    instagram: number
    /**
     * Count of conversations on WhatsApp
     * @example 0
     */
    whatsapp: number
  }
  /**
   * Sum of all platform conversations for this tag
   * @example 18000
   */
  totalConversations: number
}

export interface OperatorTagData {
  /**
   * Category identifier — equal to the taxonomy category `name`.
   * Free-form string drawn from the per-page taxonomy (may contain
   * spaces, ampersands, Unicode). Do not validate against a fixed enum.
   * @example "Course Inquiry"
   */
  id: string
  /**
   * Category display name (same as `id`, kept for UI compatibility).
   * @example "Course Inquiry"
   */
  name: string
  /**
   * Count of conversations per operator for this tag
   * @example {"op-1":8000,"op-2":6000,"op-3":4000}
   */
  conversations: Record<string, number>
  /**
   * Sum of all operator conversations for this tag
   * @example 18000
   */
  totalConversations: number
}

export interface CategorizationStats {
  /**
   * Overall total conversations across all tags
   * @example 45000
   */
  totalConversations: number
  /**
   * Total non-system messages for this page in the requested range
   * (computed from inbox_messages_raw). Page-level only — there is
   * no per-category breakdown because category lives only in the
   * precompute, not on raw messages.
   * @example 132450
   */
  totalMessages: number
  /** Tag with most conversations (null if no data) */
  mostUsedTag: TagInfo | null
  /** Tag with least conversations (null if no data) */
  leastUsedTag: TagInfo | null
}

export interface TagInfo {
  /**
   * Category identifier — equal to the taxonomy category `name`.
   * Free-form string from the per-page taxonomy; not constrained to a fixed enum.
   * @example "Course Inquiry"
   */
  id: string
  /**
   * Category display name (same as `id`).
   * @example "Course Inquiry"
   */
  name: string
  /**
   * Total conversations for this tag
   * @example 18000
   */
  totalConversations: number
}

export interface OperatorInfo {
  /**
   * Operator unique identifier
   * @example "op-1"
   */
  id: string
  /**
   * Operator display name
   * @example "Rati Nabijashvili"
   */
  name: string
}

export interface FrequentlyUsedKeywordsResponse {
  /** List of frequently used keywords sorted by totalMentions in descending order (empty array if no data) */
  keywords: KeywordData[]
}

export interface KeywordData {
  /**
   * Unique identifier for the keyword
   * @example "1"
   */
  id: string
  /**
   * The actual keyword text
   * @example "service"
   */
  keyword: string
  /**
   * The sentiment with the highest percentage
   * @example "negative"
   */
  mostlyRatedAs: 'positive' | 'negative' | 'neutral'
  /**
   * Total count of mentions for this keyword
   * @example 11629
   */
  totalMentions: number
  /**
   * Count of positive sentiment mentions
   * @example 2906
   */
  positiveMentions: number
  /**
   * Percentage of positive mentions (0-100)
   * @min 0
   * @max 100
   * @example 25
   */
  positivePercentage: number
  /**
   * Count of neutral sentiment mentions
   * @example 3489
   */
  neutralMentions: number
  /**
   * Percentage of neutral mentions (0-100)
   * @min 0
   * @max 100
   * @example 30
   */
  neutralPercentage: number
  /**
   * Count of negative sentiment mentions
   * @example 5234
   */
  negativeMentions: number
  /**
   * Percentage of negative mentions (0-100)
   * @min 0
   * @max 100
   * @example 45
   */
  negativePercentage: number
}

export interface InboxPreviewConversationMessagesResponse {
  conversation: {
    /** @example "t_123456789" */
    id: string
    /** @example "223850724706670" */
    pageId?: string | null
    /** @example "facebook" */
    platform?: 'facebook' | 'instagram' | 'whatsapp' | null
    /** @example "https://facebook.com/..." */
    externalUrl?: string | null
    /** @example ["Customer Name","Operator Name"] */
    participants?: string[]
    /** @format date-time */
    lastActivityAt?: string | null
    /** @example "neutral" */
    sentiment?: 'positive' | 'neutral' | 'negative'
    topics?: {
      id?: string
      name?: string
    }[]
    summary?: string | null
  }
  /**
   * Total message count after the system-message filter (ignores limit/offset).
   * @example 87
   */
  total: number
  /** @example 0 */
  offset: number
  /** @example 50 */
  limit: number
  /** @example true */
  hasMore: boolean
  messages: {
    /** Stable identifier within the conversation (source id or positional fallback). */
    id: string
    senderType?: 'Customer' | 'Operator' | null
    senderId?: string | null
    senderName?: string | null
    text: string
    attachments?: object[]
    isSystemMessage?: boolean
    /** Source timestamp if present; may be null. */
    createdAt?: string | null
  }[]
}

export interface InboxPreviewConversationsResponse {
  conversations: ConversationPreview[]
  nextCursor: string | null
}

export interface ConversationPreview {
  id: string
  platform: string | null
  externalUrl: string | null
  user: {
    id: string | null
    name: string
    avatarUrl: string | null
  }
  operator: {
    id: string | null
    name: string
  }
  snippet: string
  sentiment: 'positive' | 'neutral' | 'negative'
  /** @format date-time */
  lastActivityAt: string | null
  topics: {
    id: string
    name: string
  }[]
  /** New or returning customer; not sent until the collector records customer ids (HAP-502) */
  audience?: 'new' | 'returning' | null
  /** Whether the chat started from an ad; not sent until the collector records ad referrals (HAP-502) */
  origin?: 'organic' | 'paid' | 'unknown' | null
  /** `converted` (paid / booked through the chat) or `committed` (agreed to buy, payment not confirmed). Omitted when the chat has no status. */
  conversion?: 'converted' | 'committed'
  /**
   * Present only when `search` was given. The most recent non-system message whose text contains the term, so the list can show where the chat matched. `null` when the hit was on a participant name only.
   */
  match?: {
    /**
     * Excerpt of the matched message (~240 chars) centred on the first occurrence of the term.
     * @example "…the refund will be processed within 5 working days…"
     */
    text: string
    senderType: 'Customer' | 'Operator' | null
    senderName: string | null
    /**
     * Number of non-system messages in the conversation that contain the term.
     * @min 1
     * @example 2
     */
    count: number
  } | null
}

export interface InboxPreviewSummaryResponse {
  donut: {
    total: number
    positive: SentimentBucket
    neutral: SentimentBucket
    negative: SentimentBucket
    dominantSentiment: 'positive' | 'neutral' | 'negative' | 'balanced'
  }
  facets: {
    platforms: FacetEntry[]
    topics: FacetEntry[]
    operators: FacetEntry[]
  }
  /** True when the page has Organic / Paid attribution, so the Source filter can be enabled. */
  sourceAvailable?: boolean
  /** How the UI shows conversion statuses for this page. Opt-in: `subtle` / `prominent` only when set on the page; unset or `off` is `off`. */
  conversionDisplay?: 'off' | 'subtle' | 'prominent'
  /** Converted / Committed / Unconverted chat counts over the donut's scope (conversion filter not applied). null when conversionDisplay is off. */
  conversionCounts?: {
    converted?: number
    committed?: number
    unconverted?: number
  } | null
  /** Organic / Paid chat counts (same scope as the donut) with the change vs the previous window; null without attribution. */
  sourceCounts?: {
    organic: { value: number; changePercent: number | null }
    paid: { value: number; changePercent: number | null }
  } | null
}

export interface SentimentBucket {
  count: number
  /**
   * @min 0
   * @max 100
   */
  percentage: number
}

export interface FacetEntry {
  id: string
  name: string
  count: number
}

export interface Platform {
  /** Platform name */
  name: 'Facebook' | 'Instagram' | 'Whatsapp'
  /** Number of mentions/messages */
  mentions: number
}

export interface PlatformStats {
  /** Platform with most/least activity */
  platform: string
  /** Number of mentions for this platform */
  count: number
}

export interface OverallPeriodResponse {
  period: 'overall'
  stats: {
    /**
     * Total mentions across all platforms (0 if no data)
     * @example 2035
     */
    totalMentions: number
    /** Platform with most activity (null if no data) */
    mostActive: PlatformStats | null
    /** Platform with least activity (null if no data) */
    leastActive: PlatformStats | null
  }
  /** Array of platforms with mention counts (empty array if no data) */
  platforms: Platform[]
}

export interface DailyPeriodResponse {
  period: 'daily'
  stats: {
    /**
     * Day with highest total mentions
     * @example "Wednesday"
     */
    bestDay: string
    mostActive: PlatformStats
    leastActive: PlatformStats
  }
  data: {
    /**
     * Day of week
     * @example "Monday"
     */
    day: string
    /**
     * ISO date
     * @format date
     * @example "2024-01-15"
     */
    date: string
    platforms: Platform[]
  }[]
}

export interface WeeklyPeriodResponse {
  period: 'weekly'
  stats: {
    /**
     * Week with highest total mentions
     * @example "Week 1"
     */
    bestWeek: string
    mostActive: PlatformStats
    leastActive: PlatformStats
  }
  /** @maxItems 4 */
  data: {
    /**
     * Week identifier
     * @example "Week 1"
     */
    week: string
    dateRange: {
      /**
       * @format date
       * @example "2024-01-01"
       */
      start: string
      /**
       * @format date
       * @example "2024-01-07"
       */
      end: string
    }
    platforms: Platform[]
  }[]
}

export interface MonthlyPeriodResponse {
  period: 'monthly'
  stats: {
    /**
     * Month with highest total mentions
     * @example "January"
     */
    bestMonth: string
    mostActive: PlatformStats
    leastActive: PlatformStats
  }
  /** @maxItems 12 */
  data: {
    /**
     * Month name
     * @example "January"
     */
    month: string
    /**
     * Year
     * @example 2024
     */
    year: number
    platforms: Platform[]
  }[]
}

export interface MetaInsightsResponse {
  hasInsights: boolean
  cards: MetaCard[]
  /**
   * Most recent `createdAt` across the returned cards.
   * @format date-time
   */
  generatedAt?: string
}

export interface MetaCard {
  id: string
  /** Drives card style + filter tabs. */
  kind: 'trend' | 'risk' | 'opportunity'
  /**
   * ≤70 chars. May contain inline `<red>`/`<green>`/`<yellow>` tags
   * that the frontend renders as colored highlights.
   */
  title: string
  /** ≤2 sentences. Same highlight tag conventions as `title`. */
  detail: string
  /** Single sentence. Same highlight tag conventions. */
  recommendation: string
  /**
   * ObjectIds (stringified) of the underlying `smart_insights` documents
   * this card was synthesized from. Use the existing
   * `/v1_private/inbox-analysis/smart-insights` endpoint to drill down.
   */
  sourceInsightIds: string[]
  window: {
    /** @format date-time */
    from: string | null
    /** @format date-time */
    to: string | null
  }
  /**
   * Optional structured metrics box rendered between `detail` and
   * `recommendation`. Omitted/null when the writer has no metrics for
   * the card — the frontend then renders the card without the box.
   * `variant` drives the layout (independent of `kind`, though they
   * usually align): `metric` (a before→after value with an optional
   * sparkline + progress bar), `comparison` (two labelled columns),
   * or `highlight` (a single labelled value). Only the sub-object
   * matching `variant` is populated.
   */
  stats?: {
    variant: 'metric' | 'comparison' | 'highlight'
    /** Populated when `variant` is `metric`. */
    metric?: {
      /** e.g. "Volume". */
      label?: string
      /** Starting value (e.g. 100). */
      from?: number
      /** Ending value (e.g. 140). */
      to?: number
      /** Optional suffix, e.g. "%". */
      unit?: string | null
      /** Ordered points for the inline trend line. Omit to hide the sparkline. */
      sparkline?: number[] | null
      /** Progress bar fill from 0 to 1. Omit to hide the bar. */
      progress?: number | null
    }
    /** Populated when `variant` is `comparison`. */
    comparison?: {
      /** Exactly two labelled columns rendered side by side. */
      columns?: {
        /** e.g. "Handled". */
        label: string
        /** e.g. "High Volume". May contain highlight tags. */
        value: string
      }[]
    } | null
    /** Populated when `variant` is `highlight`. */
    highlight?: {
      /** e.g. "Strength". */
      label?: string
      /** e.g. "Fast resolution time". May contain highlight tags. */
      value?: string
    } | null
  }
}

export interface OperatorPerformanceResponse {
  /** List of operators with their performance metrics (empty array if no data) */
  operators: OperatorData[]
  stats: PerformanceStats
}

export interface OperatorData {
  /**
   * Unique operator identifier
   * @example "op-1"
   */
  id: string
  /**
   * Operator full name
   * @example "Rati Nabijashvili"
   */
  name: string
  sentiments: SentimentBreakdown
  /**
   * Sum of all sentiment counts
   * @example 100
   */
  totalSentiments: number
}

export interface PerformanceStats {
  /**
   * Total sentiment interactions across all operators (0 if no data)
   * @example 300
   */
  totalSentiments: number
  /** Operator with highest positive ratio (null if no data) */
  mostPositiveOperator: TopOperator | null
  /** Operator with highest negative ratio (null if no data) */
  mostNegativeOperator: TopOperator | null
}

export interface TopOperator {
  /**
   * Operator unique identifier
   * @example "op-1"
   */
  id: string
  /**
   * Operator display name
   * @example "Rati Nabijashvili"
   */
  name: string
  /**
   * Positive sentiment ratio as percentage (0-100)
   * @format float
   * @example 60
   */
  positiveRatio: number
  /**
   * Negative sentiment ratio as percentage (0-100)
   * @format float
   * @example 12
   */
  negativeRatio?: number
}

export interface PeriodChange {
  /** The value over the previous period */
  previous: number
  /** Rounded % change vs previous; null when previous is 0 (hide the badge) */
  changePercent: number | null
  /**
   * Start of the previous period (response-time comparisons)
   * @format date-time
   */
  previousFromDate?: string
  /**
   * End of the previous period (response-time comparisons)
   * @format date-time
   */
  previousToDate?: string
}

export interface OperatorRef {
  id: string
  name: string
}

export interface OperatorAnalyticsOperator {
  id: string
  name: string
  /** Follows speed; null with fewer than 5 replies */
  rating: 'excellent' | 'good' | 'needs_attention' | null
  totalChats: number
  totalMessages: number
  sentiment: {
    positive: number
    neutral: number
    negative: number
  }
  /** Average reply time in minutes; null when the operator had no replies */
  responseTime: number | null
  replies: number
  /** fast ≤ 0.8× team average, slow ≥ 1.2×; null with fewer than 5 replies */
  speed: 'fast' | 'steady' | 'slow' | null
  /** % of the operator's chats that got a reply within 24h */
  followUpRate: number | null
  topPlatform: OperatorRef | null
  /** Weekday with the most replies from this operator */
  topDay: string | null
  /** Newest AI sentence about the operator (qualitative, no numbers); null when none generated */
  insight: string | null
  /** The window the insight was written over (not the viewer's dates) */
  insightWindow?: {
    /** @format date-time */
    from: string
    /** @format date-time */
    to: string
  } | null
}

export interface OperatorAnalyticsResponse {
  /** Sorted by totalChats, busiest first */
  operators: OperatorAnalyticsOperator[]
  stats: {
    totalOperators: number
    /** Team average reply time in minutes */
    averageResponseTime: number
    averageResponseTimeComparison: PeriodChange | null
    topPerformer: OperatorRef | null
    needsAttention: OperatorRef | null
  }
}

export interface InboxOverviewComparison {
  /** @format date-time */
  previousFromDate: string
  /** @format date-time */
  previousToDate: string
  totalChats: PeriodChange
  totalMessages: PeriodChange
  totalUsers: PeriodChange
  sources: {
    /** Platforms with chats in the previous period */
    previous: number
    /** Platforms with chats now but none in the previous period (groupBy=platforms only) */
    newSources: {
      id: string
      name: string
    }[]
  }
}

export interface InboxOverviewResponse {
  totalChats: SentimentBreakdown
  totalMessages: SentimentBreakdown
  /**
   * Users in the range: distinct (customer name, platform) pairs, the
   * same count as the listing page card, until the collector stores a
   * customer id (HAP-502).
   */
  totalUsers: {
    total: number
  }
  /**
   * Organic vs Paid for the chats in the range, from the `ad_id.<id>`
   * labels Meta puts on a chat started from an ad. A chat that ever came
   * from an ad counts as paid; `unknown` = no attribution record yet.
   * null when the page has no attribution.
   */
  sourceSplit?: {
    paid: number
    organic: number
    unknown: number
    users: {
      paid: number
      organic: number
      unknown: number
    }
  } | null
  /**
   * The same figures over the equal-length window right before the
   * selected one. null for lifetime / open ranges.
   */
  comparison: InboxOverviewComparison | null
  groups: {
    /** Number of distinct groups (platforms or operators) in the range */
    total: number
    items: {
      id: string
      name: string
      /**
       * Real non-system message count for this group when
       * `groupBy=platforms`. For `groupBy=operators` this
       * mirrors `conversations` (operatorId is not present
       * on raw messages, so a true message count cannot be
       * computed there).
       */
      messages: number
      /** Conversation count for this group from the precompute. */
      conversations: number
    }[]
  }
  topGroup: {
    mostPositive: TopGroupEntry | null
    mostNegative: TopGroupEntry | null
  }
  topDay: {
    mostPositive: TopDayEntry | null
    mostNegative: TopDayEntry | null
  }
  topTopic: {
    mostPositive: TopicRef | null
    mostNegative: TopicRef | null
  }
}

export interface TopGroupEntry {
  id: string
  name: string
  metricLabel: 'Messages' | 'Chats'
  metricValue: number
}

export interface TopDayEntry {
  day:
    | 'Monday'
    | 'Tuesday'
    | 'Wednesday'
    | 'Thursday'
    | 'Friday'
    | 'Saturday'
    | 'Sunday'
  /**
   * Chats on that day-of-week within the range carrying the card's own
   * sentiment (positive count for mostPositive, negative for mostNegative).
   */
  count: number
  /**
   * % change vs the previous comparable period (positive = up).
   * `null` in lifetime mode (no comparable previous window).
   */
  trendPercent?: number | null
}

export interface TopicRef {
  id: string
  name: string
  /**
   * Chats tagged with this topic in the range carrying the card's own
   * sentiment (positive count for mostPositive, negative for mostNegative).
   */
  count: number
}

export interface PlatformResponseTimeResponse {
  type: 'platform'
  /** Array of platform response time data (empty array if no data) */
  data: PlatformResponseData[]
  stats: ResponseTimeStats
}

export interface OperatorResponseTimeResponse {
  type: 'operator'
  /** Array of operator response time data (empty array if no data) */
  data: OperatorResponseData[]
  stats: ResponseTimeStats
}

export interface PlatformResponseData {
  /**
   * Platform identifier
   * @example "facebook"
   */
  id: 'facebook' | 'instagram' | 'whatsapp'
  /**
   * Platform display name
   * @example "Facebook"
   */
  name: string
  /**
   * Average response time in minutes
   * @example 18
   */
  averageResponseTime: number
  /**
   * Total messages handled on this platform
   * @example 1250
   */
  messageCount: number
}

export interface OperatorResponseData {
  /**
   * Operator unique identifier
   * @example "op-1"
   */
  id: string
  /**
   * Operator full name
   * @example "Rati Nabijashvili"
   */
  name: string
  /**
   * Average response time in minutes
   * @example 15
   */
  averageResponseTime: number
  /**
   * Total conversations handled by this operator. Note: for the
   * operator breakdown this is currently a conversation count, not
   * a raw message count, because the precompute is the only source
   * with a stable operatorId. Platform breakdown returns true
   * non-system message counts.
   * @example 145
   */
  messageCount: number
}

export interface ResponseTimeStats {
  /**
   * Overall weighted average response time in minutes (0 if no data)
   * @example 23
   */
  averageResponseTime: number
  /**
   * Average response time over the equal-length previous period and the
   * % change (lower is better). null for lifetime or when the previous
   * period had no replies.
   */
  averageResponseTimeComparison?: PeriodChange | null
  /** Platform/operator with fastest response time (null if no data) */
  fastestResponder: ResponderInfo | null
  /** Platform/operator with slowest response time (null if no data) */
  slowestResponder: ResponderInfo | null
}

export interface ResponderInfo {
  /**
   * Responder unique identifier
   * @example "facebook"
   */
  id: string
  /**
   * Responder display name
   * @example "Facebook"
   */
  name: string
  /**
   * Average response time in minutes
   * @example 18
   */
  averageResponseTime: number
}

export interface InboxSmartInsightsResponse {
  /**
   * `false` (or `true` with empty `insights`) → frontend shows the
   * global empty state.
   */
  hasInsights: boolean
  insights: SmartInsight[]
  /**
   * Most recent `createdAt` across the returned insights. Omitted if there are no insights.
   * @format date-time
   */
  generatedAt?: string
}

export interface TopPhrasesResponse {
  /** Available filter values for this page+range (drives the dropdowns) */
  facets?: {
    operators?: { id: string; name: string }[]
    platforms?: string[]
  }
  /** List of top phrases sorted by mentions in descending order (empty array if no data) */
  phrases: PhraseData[]
}

export interface PhraseData {
  /**
   * Sequential identifier for the phrase in the result list
   * @example "1"
   */
  id: string
  /**
   * The normalized phrase text (lowercased, whitespace-collapsed)
   * @example "გრაფიკული დიზაინი"
   */
  phrase: string
  /**
   * Sentiment with the highest count. Note: phrase-level sentiment is inherited
   * from the conversation's overall sentiment, not from the individual message.
   * @example "positive"
   */
  mostlyRatedAs: 'positive' | 'negative' | 'neutral'
  /**
   * Total count of occurrences across the date range
   * @example 11
   */
  totalMentions: number
  /** @example 8 */
  positiveMentions: number
  /**
   * @min 0
   * @max 100
   * @example 73
   */
  positivePercentage: number
  /** @example 2 */
  neutralMentions: number
  /**
   * @min 0
   * @max 100
   * @example 18
   */
  neutralPercentage: number
  /** @example 1 */
  negativeMentions: number
  /**
   * @min 0
   * @max 100
   * @example 9
   */
  negativePercentage: number
}

export interface KeywordFetchDailyTrends {
  /** @example ["2023-03-12","2023-03-13","2023-03-14"] */
  dates?: string[]
  /** @example [2,4,5] */
  positives?: number[]
  /** @example [671,758,649] */
  neutrals?: number[]
  /** @example [5,10,10] */
  negatives?: number[]
  /** @example [678,772,664] */
  total?: number[]
}

export interface KeywordFetchKeywordsWithStatsTopSource {
  /** @example "twitter" */
  _id?: string
  /** @example 13 */
  count?: number
}

export interface KeywordFetchKeywordsWithStats {
  topSources?: KeywordFetchKeywordsWithStatsTopSource[]
  /** @example "active" */
  activeStatus?: string
  /** @example "React" */
  campaign?: string
  /** @example "63f0d4deb64d852011735791" */
  campaignID?: string
  /** @example "2023-02-20T11:37:15.868Z" */
  createdAt?: string
  /** @example "2023-02-20T11:37:15.868Z" */
  from?: string
  /** @example "2023-02-20T11:37:15.868Z" */
  to?: string
  /** @example "2023-02-20T11:37:15.868Z" */
  updatedAt?: string
  /** @example 10 */
  mentions?: number
  /** @example "React Course" */
  name?: string
  /** @example 10 */
  negativeCount?: number
  /** @example 10 */
  negativityPercentage?: number
  /** @example 10 */
  neutralCount?: number
  /** @example 10 */
  neutralityPercentage?: number
  /** @example 10 */
  positiveCount?: number
  /** @example 10 */
  positivityPercentage?: number
}

export interface KeywordFetchSentimentAnalysis {
  /** @example 10 */
  negativeMentionsCount?: number
  /** @example 10 */
  negativePercentage?: number
  /** @example 10 */
  neutralMentionsCount?: number
  /** @example 10 */
  neutralPercentage?: number
  /** @example 10 */
  positiveMentionsCount?: number
  /** @example 10 */
  positivePercentage?: number
}

export interface KeywordFetchSentimentChartAxisData {
  /** @example 10 */
  interval?: number
  /** @example 10 */
  max?: number
  /** @example 10 */
  min?: number
}

export interface KeywordFetchSentimentChartSource {
  /** @example [[10,10],[10,10]] */
  data?: [number][]
  /** @example ["twitter"] */
  source?: string
}

export interface KeywordFetchSentimentChart {
  XAxis?: KeywordFetchSentimentChartAxisData
  YAxis?: KeywordFetchSentimentChartAxisData
  data?: KeywordFetchSentimentChartSource[]
  allCampaigns?: string[]
  checkedCampaigns?: string[]
  allSources?: string[]
  checkedSources?: string[]
  allKeywords?: string[]
  checkedKeywords?: string[]
}

export interface KeywordFetchTopSources {
  /** @example "twitter" */
  name?: string
  /** @example 0 */
  positivePercentage?: number
  /** @example 0 */
  positives?: number
  /** @example 0 */
  negativePercentage?: number
  /** @example 0 */
  negatives?: number
  /** @example 100 */
  neutralPercentage?: number
  /** @example 4 */
  neutrals?: number
  /** @example 4 */
  total?: number
}

export interface ReviewAnalysisLocation {
  /** @example "Stamba Tbilisi" */
  name: string
  /** @example "https://maps.app.goo.gl/cE7eZLz2bPyACF3A" */
  url: string
}

export interface ReviewAnalysisCampaign {
  /** @example "67a1b2c3d4e5f6a7b8c9d0e1" */
  _id?: string
  /** @example "Stamba Hotel Group" */
  name?: string
  /** Owner user id */
  user?: string
  locations?: ReviewAnalysisLocation[]
  /** @example ["google","booking","tripadvisor"] */
  platforms?: string[]
  /** @example ["https://www.tripadvisor.com/Hotel_Review-..."] */
  dataSourceLinks?: string[]
  /** @example ["ChIJN1t_tDeuEmsRUsoyG83frY4"] */
  placeIds?: string[]
  /** References to uploaded files (shape determined by upload service) */
  files?: object[]
  /** @format date-time */
  createdAt?: string
  /** @format date-time */
  updatedAt?: string
}

export interface ReviewAnalysisCampaignCreateBody {
  /**
   * @maxLength 200
   * @example "Stamba Hotel Group"
   */
  name: string
  /** Physical locations under this campaign (name + URL each) */
  locations?: ReviewAnalysisLocation[]
  /** Platform ids to monitor (e.g. google, booking, tripadvisor, expedia) */
  platforms?: string[]
  dataSourceLinks?: string[]
  /** Google Place IDs */
  placeIds?: string[]
  files?: object[]
}

/** Any subset of fields. Omitted fields are preserved. */
export interface ReviewAnalysisCampaignUpdateBody {
  /**
   * @maxLength 200
   * @example "Stamba Hotel Group (renamed)"
   */
  name?: string
  locations?: ReviewAnalysisLocation[]
  platforms?: string[]
  dataSourceLinks?: string[]
  placeIds?: string[]
  files?: object[]
}

export interface ReviewAnalysisCampaignResponse {
  /** @example true */
  success?: boolean
  data?: ReviewAnalysisCampaign
}

export interface ReviewAnalysisCampaignListResponse {
  /** @example true */
  success?: boolean
  data?: ReviewAnalysisCampaign[]
}

export interface ReviewAnalysisCampaignValidationErrorResponse {
  /** @example false */
  success?: boolean
  /** @example ["Name is required"] */
  errors?: string[]
}

export interface ReviewAnalysisCampaignErrorResponse {
  /** @example false */
  success?: boolean
  /** @example "Failed to fetch review analysis campaigns" */
  error?: string
}

export interface BrandStats {
  /** @example 4.7 */
  averageRating?: number
  /** @example 4 */
  averageRatingChange?: number
  /** @example 4949 */
  totalReviews?: number
  /** @example 12 */
  totalReviewsChange?: number
  sentiment?: SentimentBreakdown
}

export interface BrandOverviewResponse {
  stats?: BrandStats
  reviewsByPlatform?: {
    /** @example "google" */
    platform?: string
    /** @example "Google Maps" */
    name?: string
    /** @example 5 */
    rating?: number
    /** @example 3249 */
    reviewCount?: number
  }[]
  topIssues?: {
    name?: string
    percentage?: number
    reviewCount?: number
    avgRating?: number
    tooltip?: {
      quotes?: string[]
      platforms?: {
        platform?: string
        name?: string
      }[]
    }
  }[]
  /**
   * Each facility holds one card per review platform. Cards may be
   * scraped (status='ready') or pending — pending entries come from
   * unprocessed campaign.platformSubmissions[] and have null
   * rating/reviewCount/sentiment/lastUpdate so the frontend can
   * render a "Collecting data…" state.
   */
  facilities?: {
    /** @example "fac-lolita" */
    id?: string
    name?: string
    cards?: {
      /**
       * Stable per-(facility, platform, venue) card id, present on every card (e.g. 'fac-stamba::google::Cafe Stamba')
       * @example "fac-stamba::google::Cafe Stamba"
       */
      id?: string
      /** Set on submission-backed cards (pending/collecting/failed) — pass to DELETE /platforms/{submissionId}. null on scraped 'ready' cards. */
      submissionId?: string | null
      /** @example "ready" */
      status?: 'ready' | 'pending' | 'collecting' | 'failed'
      title?: string
      platform?: string
      providerName?: string
      rating?: number | null
      reviewCount?: number | null
      sentiment?: {
        positive?: number
        neutral?: number
        negative?: number
        total?: number
      } | null
      createdOn?: string
      lastUpdate?: string | null
      links?: string[]
    }[]
  }[]
}

export interface Competitor {
  /** @example "a" */
  id?: string
  /** @example "Competitor A" */
  name?: string
  /** @example 4.7 */
  rating?: number | null
  /** @example 1478 */
  reviews?: number | null
  /** @example 82 */
  positiveSentiment?: number | null
  /** [ratingStatus, sentimentStatus, reviewsStatus] — null when populated. */
  loadingStatuses?: (
    | 'ratings_in_progress'
    | 'reviews_collected'
    | 'sentiment_pending'
    | null
  )[]
}

export interface CompetitorTarget {
  id?: string
  name?: string
  location?: string
  logoUrl?: string | null
}

export interface PlatformAnalysis {
  platform?: string
  platformName?: string
  /** Set when scoped via ?facilityId */
  facilityId?: string | null
  facilityTabs?: string[]
  /** Last-30-day rating summary (A1). null when the scope has no data. */
  ratingSummary?: {
    /** @example 4.7 */
    averageRating?: number
    /** @example "Last 30 days" */
    periodLabel?: string
    /** % change in avg rating vs previous period */
    trendPercent?: number
    /**
     * Absolute avg-rating change vs previous period
     * @example 0.1
     */
    ratingDelta?: number
    /** Reviews rated >=4 but with negative text */
    mismatch?: {
      negativeTextReviews?: number
      percentage?: number
    }
  } | null
  stats?: BrandStats
  distribution?: {
    stars?: number
    percentage?: number
  }[]
  trend?: {
    barHeights?: number[]
    xAxisFrom?: string
    xAxisTo?: string
  }
  locations?: {
    rank?: number
    name?: string
    rating?: string
    positiveSentiment?: string
    reviews?: number
    oneStarReviews?: string
    alerts?: number
    trend?: 'up' | 'down'
  }[]
  performance?: {
    best?: PerformanceLocation[]
    worst?: PerformanceLocation[]
  }
}

export interface PerformanceLocation {
  name?: string
  label?: string
  value?: string
  text?: string
  trend?: 'up' | 'down'
  isRating?: boolean
}

/** Shared shape for facility and platform activity endpoints. */
export interface ActivityResponse {
  velocity?: {
    period?: 'daily' | 'weekly' | 'monthly'
    count?: number
    /** % vs previous equal window */
    trend?: number
  }[]
  platformActivity?: {
    platform?: string
    reviewsPerDay?: number
    peakDays?: string[]
    spikeDate?: string | null
  }
  spike?: {
    date?: string
    changePercent?: number
    scope?: string
  } | null
  alerts?: {
    label?: string
    /** @format date-time */
    time?: string
  }[]
}

export type QueryParamsType = Record<string | number, any>
export type ResponseFormat = keyof Omit<Body, 'body' | 'bodyUsed'>

export interface FullRequestParams extends Omit<RequestInit, 'body'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean
  /** request path */
  path: string
  /** content type of request body */
  type?: ContentType
  /** query params */
  query?: QueryParamsType
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat
  /** request body */
  body?: unknown
  /** base url */
  baseUrl?: string
  /** request cancellation token */
  cancelToken?: CancelToken
}

export type RequestParams = Omit<
  FullRequestParams,
  'body' | 'method' | 'query' | 'path'
>

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string
  baseApiParams?: Omit<RequestParams, 'baseUrl' | 'cancelToken' | 'signal'>
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<RequestParams | void> | RequestParams | void
  customFetch?: typeof fetch
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D
  error: E
}

type CancelToken = Symbol | string | number

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = ''
  private securityData: SecurityDataType | null = null
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker']
  private abortControllers = new Map<CancelToken, AbortController>()
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams)

  private baseApiParams: RequestParams = {
    credentials: 'same-origin',
    headers: {},
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
  }

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig)
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data
  }

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key)
    return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key])
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key]
    return value.map((v: any) => this.encodeQueryParam(key, v)).join('&')
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {}
    const keys = Object.keys(query).filter(
      (key) => 'undefined' !== typeof query[key]
    )
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key)
      )
      .join('&')
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery)
    return queryString ? `?${queryString}` : ''
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === 'object' || typeof input === 'string')
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== 'string'
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key]
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === 'object' && property !== null
              ? JSON.stringify(property)
              : `${property}`
        )
        return formData
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  }

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    }
  }

  protected createAbortSignal = (
    cancelToken: CancelToken
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken)
      if (abortController) {
        return abortController.signal
      }
      return void 0
    }

    const abortController = new AbortController()
    this.abortControllers.set(cancelToken, abortController)
    return abortController.signal
  }

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken)

    if (abortController) {
      abortController.abort()
      this.abortControllers.delete(cancelToken)
    }
  }

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {}
    const requestParams = this.mergeRequestParams(params, secureParams)
    const queryString = query && this.toQueryString(query)
    const payloadFormatter = this.contentFormatters[type || ContentType.Json]
    const responseFormat = format || requestParams.format

    return this.customFetch(
      `${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { 'Content-Type': type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === 'undefined' || body === null
            ? null
            : payloadFormatter(body),
      }
    ).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>
      r.data = null as unknown as T
      r.error = null as unknown as E

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data
              } else {
                r.error = data
              }
              return r
            })
            .catch((e) => {
              r.error = e
              return r
            })

      if (cancelToken) {
        this.abortControllers.delete(cancelToken)
      }

      if (!response.ok) throw data
      return data
    })
  }
}

/**
 * @title User Features API
 * @version 1.0.0
 *
 * API endpoint to change sentiment of multiple threads
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  v1 = {
    /**
     * @description Submit a job application with resume upload. Rate limited to 5 requests per 15 minutes per IP address.
     *
     * @tags Application
     * @name ApplyCreate
     * @summary Submit job application
     * @request POST:/v1/apply
     */
    applyCreate: (
      data: {
        /**
         * Applicant's first name
         * @example "John"
         */
        firstName: string
        /**
         * Applicant's last name
         * @example "Doe"
         */
        lastName: string
        /**
         * Applicant's email address
         * @format email
         * @example "john.doe@example.com"
         */
        email: string
        /**
         * Mobile number with country code
         * @example "+995123456789"
         */
        mobile: string
        /**
         * Country
         * @example "Georgia"
         */
        country: string
        /**
         * City
         * @example "Tbilisi"
         */
        city: string
        /**
         * Portfolio URL (optional)
         * @example "https://portfolio.example.com"
         */
        portfolio?: string
        /**
         * Cover letter or message
         * @example "I am interested in the position..."
         */
        message: string
        /**
         * Vacancy ID if applying to specific position (optional)
         * @example "691c830a895e4323b9da05aa"
         */
        vacancyId?: string
        /**
         * Resume file (PDF or DOCX, max 10MB)
         * @format binary
         */
        resume: File
      },
      params: RequestParams = {}
    ) =>
      this.request<
        ApplicationSuccessResponse,
        ApplicationErrorResponse | RateLimitErrorResponse
      >({
        path: `/v1/apply`,
        method: 'POST',
        body: data,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * @description Submit a contact message from the Contact Us form. Rate limited to 3 requests per 15 minutes per IP address.
     *
     * @tags Contact Message
     * @name ContactMessageCreate
     * @summary Submit contact message
     * @request POST:/v1/contact-message
     */
    contactMessageCreate: (
      data: {
        /**
         * First name
         * @minLength 1
         * @example "John"
         */
        firstName: string
        /**
         * Last name
         * @minLength 1
         * @example "Doe"
         */
        lastName: string
        /**
         * Email address
         * @format email
         * @example "john.doe@example.com"
         */
        email: string
        /**
         * Message content
         * @minLength 1
         * @example "Tell us briefly what you're looking for.."
         */
        message: string
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /** @example true */
          success?: boolean
          /** @example "Contact message submitted successfully" */
          message?: string
          data?: {
            /** @example "691c830a895e4323b9da05aa" */
            contactMessageId?: string
          }
        },
        | {
            /** @example false */
            success?: boolean
            /** @example "Validation failed" */
            error?: string
            /** @example ["Invalid email format",{"Missing or empty required fields":"message"}] */
            errors?: string[]
          }
        | {
            /** @example false */
            success?: boolean
            /** @example "Too many requests, please try again later" */
            error?: string
          }
        | {
            /** @example false */
            success?: boolean
            /** @example "Failed to submit contact message" */
            error?: string
          }
      >({
        path: `/v1/contact-message`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Submit a demo request for product evaluation. Rate limited to 3 requests per 15 minutes per IP address.
     *
     * @tags Demo Request
     * @name DemoRequestCreate
     * @summary Submit demo request
     * @request POST:/v1/demo-request
     */
    demoRequestCreate: (
      data: {
        /**
         * First name
         * @minLength 1
         * @example "John"
         */
        firstName: string
        /**
         * Last name
         * @minLength 1
         * @example "Doe"
         */
        lastName: string
        /**
         * Business email address
         * @format email
         * @example "john.doe@company.com"
         */
        businessEmail: string
        /**
         * Mobile number in E.164 format with country code
         * @pattern ^\+[1-9]\d{1,14}$
         * @example 12025550123
         */
        mobileNumber: string
        /**
         * Company name
         * @minLength 1
         * @example "Acme Corp"
         */
        companyName: string
        /**
         * ISO 3166-1 alpha-2 country code (2 letters)
         * @minLength 2
         * @maxLength 2
         * @pattern ^[A-Z]{2}$
         * @example "US"
         */
        country: string
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /** @example true */
          success?: boolean
          /** @example "Demo request submitted successfully" */
          message?: string
          data?: {
            /** @example "691c830a895e4323b9da05aa" */
            demoRequestId?: string
          }
        },
        | {
            /** @example false */
            success?: boolean
            /** @example "Validation failed" */
            error?: string
            /** @example ["Invalid business email format","Invalid country code. Must be a 2-letter ISO country code (e.g., US, GB, DE)"] */
            errors?: string[]
          }
        | {
            /** @example false */
            success?: boolean
            /** @example "Too many requests, please try again later" */
            error?: string
          }
        | {
            /** @example false */
            success?: boolean
            /** @example "Failed to submit demo request" */
            error?: string
          }
      >({
        path: `/v1/demo-request`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Relevancy
     * @name RelevancyCreate
     * @summary Get relevancy based on words
     * @request POST:/v1/relevancy
     */
    relevancyCreate: (data: any, params: RequestParams = {}) =>
      this.request<RelevancyResult, any>({
        path: `/v1/relevancy`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Suggestions
     * @name SuggestionsCategoriesList
     * @summary Get suggestion categories based on word
     * @request GET:/v1/suggestions/categories
     */
    suggestionsCategoriesList: (
      query?: {
        /**
         * Word to generate suggestions
         * @example "asd"
         */
        word?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<SuggestionsCategories, any>({
        path: `/v1/suggestions/categories`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Suggestions
     * @name SuggestionsSuggestWordList
     * @summary Get suggestions based on word
     * @request GET:/v1/suggestions/suggest-word
     */
    suggestionsSuggestWordList: (
      query?: {
        /**
         * Word to generate suggestions
         * @example "asd"
         */
        word?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<SuggestionsSuggestWord, any>({
        path: `/v1/suggestions/suggest-word`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Suggestions
     * @name SuggestionsSuperlativesComparativesList
     * @summary Get superlatives and comparatives based on words
     * @request GET:/v1/suggestions/superlatives-comparatives
     */
    suggestionsSuperlativesComparativesList: (
      query?: {
        /**
         * Positive word to generate superlatives and comparatives
         * @example "asd,asd,asd"
         */
        positives?: string
        /**
         * Negative word to generate superlatives and comparatives
         * @example "asd,asd,asd"
         */
        negatives?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<SuggestionsSuperlativesComparatives, any>({
        path: `/v1/suggestions/superlatives-comparatives`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Suggestions
     * @name SuggestionsSynonymsAntonymsList
     * @summary Get synonyms and antonyms based on word
     * @request GET:/v1/suggestions/synonyms-antonyms
     */
    suggestionsSynonymsAntonymsList: (
      query?: {
        /**
         * Word to generate suggestions
         * @example "asd"
         */
        word?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<SuggestionsSynonymsAntonyms, any>({
        path: `/v1/suggestions/synonyms-antonyms`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns a list of all active job vacancies
     *
     * @tags Vacancies
     * @name VacanciesList
     * @summary Fetch all active vacancies
     * @request GET:/v1/vacancies
     */
    vacanciesList: (params: RequestParams = {}) =>
      this.request<VacanciesResponse, ErrorResponse>({
        path: `/v1/vacancies`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  }
  v1Api = {
    /**
     * No description
     *
     * @tags Admin
     * @name AdminThreadsList
     * @summary Get Threads filtered by Keyword, Source or Sentiment
     * @request GET:/v1_api/admin/threads
     */
    adminThreadsList: (
      query?: {
        /**
         * Filter by campaign keyword
         * @example "Bellingham"
         */
        keyword?: string
        /**
         * Filter by source, allowed values: twitter, youtube, reddit, news & blogs
         * @example "reddit"
         */
        source?: string
        /**
         * Filter by sentiment, allowed values: POS, NEG, NEU
         * @example "POS"
         */
        sentiment?: AdminFetchThreadsSentimentType
        /**
         * Used in paging together with vector. If specified, returns results before / after the date
         * @example "2023-01-24T14:49:09.000Z"
         */
        lastDate?: string
        /**
         * Used in paging together with lastDate. If specified, sets the sorting order, e.g. desc means descending date order. allowed values: desc, asc
         * @example "desc"
         */
        vector?: AdminFetchThreadsVectorType
        /**
         * Number of items returned in the response
         * @example 10
         */
        limit?: number
        /**
         * Selected sources for threads, seperated by comma
         * @example "Facebook,Instagram"
         */
        selectedSources?: string
        /**
         * Selected keywords for threads, seperated by comma
         * @example "Apple,Microsoft"
         */
        selectedKeywords?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<AdminFetchThreadsResponse, any>({
        path: `/v1_api/admin/threads`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  }
  v1Private = {
    /**
     * @description Resolves a Facebook page to its page ID (plus name, fan_count, verification_status, category) before saving for monitoring. Most reliable input is a page URL, @handle, or numeric ID — these are resolved directly via the Graph API (Page Public Content Access) and work for any public page. Plain free-text names are best-effort only: Meta no longer exposes a public page-name autocomplete, so free text falls back to deriving advertiser pages from the Ads Library archive and will not match Facebook's UI search dropdown.
     *
     * @tags Ads Library
     * @name AdsLibraryPagesSearchList
     * @summary Resolve a Facebook page by URL, handle, or ID
     * @request GET:/v1_private/ads-library/pages/search
     */
    adsLibraryPagesSearchList: (
      query: {
        /**
         * Page URL, @handle, numeric ID, or (best-effort) page name
         * @example "facebook.com/cocacola"
         */
        q: string
      },
      params: RequestParams = {}
    ) =>
      this.request<PageSearchResponse, ErrorResponse>({
        path: `/v1_private/ads-library/pages/search`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Proxies a search to the Meta Ads Library API (ads_archive) and returns one page of ad results. Each ad's `ad_active_status` is derived server-side from `ad_delivery_stop_time` (Meta does not return it as a field). When `ad_reached_countries` is omitted we query Meta's full list of accepted countries so all of an advertiser's ads are returned, not just those delivered to one country. COVERAGE LIMITATION: the public Ad Library API only exposes ads that are about social issues, elections or politics (globally), plus any ad that reached the EU/UK. Commercial ads outside the EU are NOT available via the API even though they appear on the Ad Library website. As a result this endpoint can return far fewer (often a handful of) active ads than facebook.com/ads/library shows for non-EU commercial advertisers. This is a Meta restriction, not a bug — see docs/ads-library-api-limitations.md.
     *
     * @tags Ads Library
     * @name AdsLibrarySearchList
     * @summary Search Meta Ads Library
     * @request GET:/v1_private/ads-library/search
     */
    adsLibrarySearchList: (
      query: {
        /**
         * JSON array of Facebook page IDs, e.g. ["123456789"]
         * @example "["166220546851195"]"
         */
        search_page_ids: string
        /**
         * Type of ads to search. Use ALL for general queries. HOUSING_ADS/EMPLOYMENT_ADS/CREDIT_ADS only work for EU/US countries.
         * @default "ALL"
         * @example "ALL"
         */
        ad_type?:
          | 'ALL'
          | 'POLITICAL_AND_ISSUE_ADS'
          | 'HOUSING_ADS'
          | 'EMPLOYMENT_ADS'
          | 'CREDIT_ADS'
        /**
         * JSON array of country codes, e.g. ["GE"]
         * @example "["GE"]"
         */
        ad_reached_countries?: string
        /**
         * Filter by ad active status
         * @example "ALL"
         */
        ad_active_status?: 'ACTIVE' | 'INACTIVE' | 'ALL'
        /** Pagination cursor (from previous response paging.cursors.after) */
        after?: string
        /**
         * Number of ads to return per page
         * @min 1
         * @max 100
         * @default 25
         */
        limit?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<AdsSearchResponse, ErrorResponse>({
        path: `/v1_private/ads-library/search`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns the countries Meta accepts for `ad_reached_countries`, as `{ code, name }` sorted by name — ready for a country-filter dropdown.
     *
     * @tags Ads Library
     * @name AdsLibraryCountriesList
     * @summary List supported countries
     * @request GET:/v1_private/ads-library/countries
     */
    adsLibraryCountriesList: (params: RequestParams = {}) =>
      this.request<
        {
          /** @example true */
          success?: boolean
          data?: {
            /** @example "GE" */
            code?: string
            /** @example "Georgia" */
            name?: string
          }[]
        },
        ErrorResponse
      >({
        path: `/v1_private/ads-library/countries`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns the most recent `ad_library_page_snapshot` for the page (produced by the ad-library-ops snapshot worker) plus `snapshot_status` and `last_snapshot_at` from any matching monitoring-page record. Use this for the Saved Competitor card and the StatsCards on the advertiser detail page — trustworthy per-advertiser totals (active/total/inactive counts, platform mix, language mix, target countries, top creatives) without paging Meta on every render. When the worker hasn't snapshotted the page yet, `snapshot` is null and `snapshot_status` is `"pending"` so the UI can show "Syncing…".
     *
     * @tags Ads Library
     * @name AdsLibraryPageSummaryList
     * @summary Latest snapshot summary for a monitored page
     * @request GET:/v1_private/ads-library/page-summary
     */
    adsLibraryPageSummaryList: (
      query: {
        /**
         * Numeric Facebook page ID
         * @pattern ^\d+$
         * @example "166220546851195"
         */
        page_id: string
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /** @example true */
          success?: boolean
          data?: PageSummary
        },
        ErrorResponse
      >({
        path: `/v1_private/ads-library/page-summary`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns all pages the authenticated user has saved for monitoring.
     *
     * @tags Ads Library
     * @name AdsLibraryMonitoringPagesList
     * @summary List saved monitoring pages
     * @request GET:/v1_private/ads-library/monitoring-pages
     */
    adsLibraryMonitoringPagesList: (params: RequestParams = {}) =>
      this.request<MonitoringPagesListResponse, ErrorResponse>({
        path: `/v1_private/ads-library/monitoring-pages`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Saves a Facebook page to the user's monitoring list. page_id must be a numeric Facebook page ID; the page is resolved server-side (via Page Public Content Access) and the stored record's page_name, page_picture, category and verification_status are populated from the live page. Returns 400 if page_id is non-numeric or does not resolve to a public page.
     *
     * @tags Ads Library
     * @name AdsLibraryMonitoringPagesCreate
     * @summary Save a page for monitoring
     * @request POST:/v1_private/ads-library/monitoring-pages
     */
    adsLibraryMonitoringPagesCreate: (
      data: CreateMonitoringPagePayload,
      params: RequestParams = {}
    ) =>
      this.request<MonitoringPageResponse, ErrorResponse>({
        path: `/v1_private/ads-library/monitoring-pages`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Toggle a saved monitoring page between active and inactive.
     *
     * @tags Ads Library
     * @name AdsLibraryMonitoringPagesPartialUpdate
     * @summary Update monitoring page status
     * @request PATCH:/v1_private/ads-library/monitoring-pages/{id}
     */
    adsLibraryMonitoringPagesPartialUpdate: (
      id: string,
      data: UpdateMonitoringPagePayload,
      params: RequestParams = {}
    ) =>
      this.request<MonitoringPageResponse, ErrorResponse>({
        path: `/v1_private/ads-library/monitoring-pages/${id}`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Removes a saved page from the user's monitoring list.
     *
     * @tags Ads Library
     * @name AdsLibraryMonitoringPagesDelete
     * @summary Delete a monitoring page
     * @request DELETE:/v1_private/ads-library/monitoring-pages/{id}
     */
    adsLibraryMonitoringPagesDelete: (id: string, params: RequestParams = {}) =>
      this.request<
        {
          /** @example true */
          success?: boolean
          /** @example "Monitoring page removed" */
          message?: string
        },
        ErrorResponse
      >({
        path: `/v1_private/ads-library/monitoring-pages/${id}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns AI-generated smart insights from the `ad_library_smart_insight` collection (written by a separate generator service — sm.back only reads). Sorted newest first. `hasInsights:false` and `insights:[]` until the generator has produced anything; frontend should render an empty state in that case.
     *
     * @tags Ads Library
     * @name AdsLibrarySmartInsightsList
     * @summary Get smart insights for ads library
     * @request GET:/v1_private/ads-library/smart-insights
     */
    adsLibrarySmartInsightsList: (
      query?: {
        /**
         * Numeric Facebook page ID. When provided, returns per-advertiser insights (`scope.page_id` matches). When omitted, returns brand-wide / cross-page insights (`scope.page_id` absent).
         * @pattern ^\d+$
         * @example "166220546851195"
         */
        page_id?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<SmartInsightsResponse, any>({
        path: `/v1_private/ads-library/smart-insights`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns aggregated stats across all user's AI listening campaigns: campaign counts, total mentions, AI tools, top competitors, top prompt, and top AI tool.
     *
     * @tags AI Listening Campaign
     * @name AiListeningOverviewList
     * @summary Get AI listening dashboard overview stats
     * @request GET:/v1_private/ai-listening/overview
     */
    aiListeningOverviewList: (params: RequestParams = {}) =>
      this.request<
        AiListeningOverviewResponse,
        AiListeningCampaignErrorResponse
      >({
        path: `/v1_private/ai-listening/overview`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AI Listening Campaign
     * @name AiListeningCampaignList
     * @summary List all AI listening campaigns for the authenticated user
     * @request GET:/v1_private/ai-listening/campaign
     */
    aiListeningCampaignList: (params: RequestParams = {}) =>
      this.request<
        AiListeningCampaignListResponse,
        AiListeningCampaignErrorResponse
      >({
        path: `/v1_private/ai-listening/campaign`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AI Listening Campaign
     * @name AiListeningCampaignCreate
     * @summary Create a new AI listening campaign
     * @request POST:/v1_private/ai-listening/campaign
     */
    aiListeningCampaignCreate: (
      data: AiListeningCampaignPayload,
      params: RequestParams = {}
    ) =>
      this.request<
        AiListeningCampaignSingleResponse,
        | AiListeningCampaignValidationErrorResponse
        | AiListeningCampaignErrorResponse
      >({
        path: `/v1_private/ai-listening/campaign`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Creates a copy of the campaign with '(Copy)' appended to the name, reset to draft status with no analytics data.
     *
     * @tags AI Listening Campaign
     * @name AiListeningCampaignDuplicateCreate
     * @summary Duplicate an AI listening campaign
     * @request POST:/v1_private/ai-listening/campaign/{id}/duplicate
     */
    aiListeningCampaignDuplicateCreate: (
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<
        AiListeningCampaignSingleResponse,
        | AiListeningCampaignValidationErrorResponse
        | AiListeningCampaignErrorResponse
      >({
        path: `/v1_private/ai-listening/campaign/${id}/duplicate`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AI Listening Campaign
     * @name AiListeningCampaignDetail
     * @summary Get a single AI listening campaign by ID
     * @request GET:/v1_private/ai-listening/campaign/{id}
     */
    aiListeningCampaignDetail: (id: string, params: RequestParams = {}) =>
      this.request<
        AiListeningCampaignSingleResponse,
        AiListeningCampaignErrorResponse
      >({
        path: `/v1_private/ai-listening/campaign/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AI Listening Campaign
     * @name AiListeningCampaignUpdate
     * @summary Update an existing AI listening campaign
     * @request PUT:/v1_private/ai-listening/campaign/{id}
     */
    aiListeningCampaignUpdate: (
      id: string,
      data: AiListeningCampaignPayload,
      params: RequestParams = {}
    ) =>
      this.request<
        AiListeningCampaignSingleResponse,
        | AiListeningCampaignValidationErrorResponse
        | AiListeningCampaignErrorResponse
      >({
        path: `/v1_private/ai-listening/campaign/${id}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AI Listening Campaign
     * @name AiListeningCampaignDelete
     * @summary Delete an AI listening campaign
     * @request DELETE:/v1_private/ai-listening/campaign/{id}
     */
    aiListeningCampaignDelete: (id: string, params: RequestParams = {}) =>
      this.request<
        AiListeningCampaignDeleteResponse,
        AiListeningCampaignErrorResponse
      >({
        path: `/v1_private/ai-listening/campaign/${id}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * @description Aggregates AI responses to produce brand/domain mention summary, per-tool mention counts, and the prompt used.
     *
     * @tags AI Listening Campaign
     * @name AiListeningCampaignPromptResultsDetail
     * @summary Get prompt results summary for a campaign
     * @request GET:/v1_private/ai-listening/campaign/{id}/prompt-results
     */
    aiListeningCampaignPromptResultsDetail: (
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<PromptResultsResponse, AiListeningCampaignErrorResponse>({
        path: `/v1_private/ai-listening/campaign/${id}/prompt-results`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns deduplicated list of competitor brands mentioned across all AI responses for this campaign.
     *
     * @tags AI Listening Campaign
     * @name AiListeningCampaignBrandsAlongsideDetail
     * @summary Get brands appearing alongside your brand
     * @request GET:/v1_private/ai-listening/campaign/{id}/brands-alongside
     */
    aiListeningCampaignBrandsAlongsideDetail: (
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<BrandsAlongsideResponse, AiListeningCampaignErrorResponse>({
        path: `/v1_private/ai-listening/campaign/${id}/brands-alongside`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns list of check events with AI summary and status, sorted by date descending.
     *
     * @tags AI Listening Campaign
     * @name AiListeningCampaignReloadHistoryDetail
     * @summary Get reload history for a campaign
     * @request GET:/v1_private/ai-listening/campaign/{id}/reload-history
     */
    aiListeningCampaignReloadHistoryDetail: (
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<ReloadHistoryResponse, AiListeningCampaignErrorResponse>({
        path: `/v1_private/ai-listening/campaign/${id}/reload-history`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AI Listening Campaign
     * @name AiListeningCampaignResponsesDetail
     * @summary Get AI responses for a campaign
     * @request GET:/v1_private/ai-listening/campaign/{id}/responses
     */
    aiListeningCampaignResponsesDetail: (
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<
        AiListeningResponseListResponse,
        AiListeningCampaignErrorResponse
      >({
        path: `/v1_private/ai-listening/campaign/${id}/responses`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns the latest check status and cooldown information. Frontend can poll this after initiating a reload.
     *
     * @tags AI Listening Campaign
     * @name AiListeningCampaignReloadStatusDetail
     * @summary Get reload status for a campaign
     * @request GET:/v1_private/ai-listening/campaign/{id}/reload-status
     */
    aiListeningCampaignReloadStatusDetail: (
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<ReloadStatusResponse, AiListeningCampaignErrorResponse>({
        path: `/v1_private/ai-listening/campaign/${id}/reload-status`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Initiates a new data reload from external AI tools. Limited to once per 24 hours per campaign. Only active campaigns can be reloaded.
     *
     * @tags AI Listening Campaign
     * @name AiListeningCampaignReloadCreate
     * @summary Reload/refresh AI listening campaign data
     * @request POST:/v1_private/ai-listening/campaign/{id}/reload
     */
    aiListeningCampaignReloadCreate: (id: string, params: RequestParams = {}) =>
      this.request<
        ReloadResponse,
        AiListeningCampaignErrorResponse | ReloadCooldownResponse
      >({
        path: `/v1_private/ai-listening/campaign/${id}/reload`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns AI-generated insights including strengths, challenges, and recommendations for the campaign.
     *
     * @tags AI Listening Campaign
     * @name AiListeningCampaignSmartInsightsDetail
     * @summary Get smart insights for an AI listening campaign
     * @request GET:/v1_private/ai-listening/campaign/{id}/smart-insights
     */
    aiListeningCampaignSmartInsightsDetail: (
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<SmartInsightsResponse, AiListeningCampaignErrorResponse>({
        path: `/v1_private/ai-listening/campaign/${id}/smart-insights`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns the first and last dates where the user has data across all their campaigns
     *
     * @tags Analytics
     * @name AnalyticsFetchActiveDateRangeList
     * @summary Get Active Date Range
     * @request GET:/v1_private/analytics/fetchActiveDateRange
     */
    analyticsFetchActiveDateRangeList: (params: RequestParams = {}) =>
      this.request<AnalyticsFetchActiveDateRangeResponse, any>({
        path: `/v1_private/analytics/fetchActiveDateRange`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Analytics
     * @name AnalyticsFetchCalendarDetailsList
     * @summary Get Calendar Details on specific date
     * @request GET:/v1_private/analytics/fetchCalendarDetails
     */
    analyticsFetchCalendarDetailsList: (
      query?: {
        /**
         * Filter by Date
         * @example "2023-03-14"
         */
        date?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<AnalyticsFetchCalendarDetailsResponse, any>({
        path: `/v1_private/analytics/fetchCalendarDetails`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Analytics
     * @name AnalyticsFetchCampaignExcelList
     * @summary Get Calendar Details on specific date
     * @request GET:/v1_private/analytics/fetchCampaignExcel
     */
    analyticsFetchCampaignExcelList: (
      query?: {
        /**
         * Filter by Campaign
         * @example "campaign-id"
         */
        campaign?: string
        /**
         * Filter by source, allowed values: twitter, youtube, reddit, news & blogs
         * @example "reddit"
         */
        source?: string
        /**
         * Filter by sentiment, allowed values: POS, NEG, NEU
         * @example "POS"
         */
        sentiment?: FetchThreadsCSVSentimentType
        /**
         * Selected sources for threads, seperated by comma
         * @example "Facebook,Instagram"
         */
        selectedSources?: string
        /**
         * Selected keywords for threads, seperated by comma
         * @example "Apple,Microsoft"
         */
        selectedKeywords?: string
        /**
         * Filter by languages, separated by comma
         * @example "english,spanish,french"
         */
        languages?: string
        /**
         * Filter by lost status, allowed values: true, false, both
         * @example "both"
         */
        isLost?: FetchThreadsCSVIsLostType
        /**
         * Filter by mention format. Comma-separated subset of: hashtag, handle, keyword. Legacy value 'both' = no filter.
         * @example "both"
         */
        mentionFormat?: string
        /**
         * Filter by Date From
         * @example "2023-03-13T20:00:00.000Z"
         */
        fromDate?: string
        /**
         * Filter by Date To
         * @example "2023-03-14T19:59:59.999Z"
         */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<File, any>({
        path: `/v1_private/analytics/fetchCampaignExcel`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Analytics
     * @name AnalyticsFetchCampaignsCalendarList
     * @summary Get Calendar of Campaign or Category
     * @request GET:/v1_private/analytics/fetchCampaignsCalendar
     */
    analyticsFetchCampaignsCalendarList: (
      query?: {
        /**
         * Filter by Date From
         * @example "2023-03-13T20:00:00.000Z"
         */
        fromDate?: string
        /**
         * Filter by Date To
         * @example "2023-03-14T19:59:59.999Z"
         */
        toDate?: string
        /**
         * Filter by Campaign ID
         * @example "63ff25da11b15267d928b99c"
         */
        campaign?: string
        /** Filter by Category */
        category?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<AnalyticsFetchCampaignsCalendarResponse, any>({
        path: `/v1_private/analytics/fetchCampaignsCalendar`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns date range info and/or an array of dates with data for a given month (used for calendar dot indicators). Supports multiple data sources via the source parameter.
     *
     * @tags Analytics
     * @name AnalyticsFetchCustomCalendarRangeList
     * @summary Get calendar date range and dates with data
     * @request GET:/v1_private/analytics/fetchCustomCalendarRange
     */
    analyticsFetchCustomCalendarRangeList: (
      query?: {
        /**
         * Data source to query. Defaults to social-listening.
         * @default "social-listening"
         */
        source?: 'social-listening' | 'inbox' | 'content'
        /**
         * Month in YYYY-MM format. When provided, the response includes a dates array with days that have data. Required for inbox and content sources.
         * @example "2026-03"
         */
        month?: string
        /** Inbox page ID. Required when source=inbox. */
        pageId?: string
        /** Content analysis ID. Required when source=content. */
        analysisId?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<AnalyticsFetchCustomCalendarRangeResponse, any>({
        path: `/v1_private/analytics/fetchCustomCalendarRange`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Analytics
     * @name AnalyticsFetchDailyTrendsList
     * @summary Get Daily Trends
     * @request GET:/v1_private/analytics/fetchDailyTrends
     */
    analyticsFetchDailyTrendsList: (
      query?: {
        /**
         * Filter by Date From
         * @example "2023-03-11T20:00:00.000Z"
         */
        fromDate?: string
        /**
         * Filter by Date To
         * @example "2023-03-14T19:59:59.999Z"
         */
        toDate?: string
        /**
         * Filter by Campaign ID
         * @example "63ff25da11b15267d928b99c"
         */
        campaign?: string
        /** Filter by Category */
        category?: string
        /** Filter by Keyword */
        keyword?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<AnalyticsFetchDailyTrendsResponse, any>({
        path: `/v1_private/analytics/fetchDailyTrends`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Analytics
     * @name AnalyticsFetchHomeCalendarList
     * @summary Get Home Calendar
     * @request GET:/v1_private/analytics/fetchHomeCalendar
     */
    analyticsFetchHomeCalendarList: (
      query?: {
        /**
         * Filter by Date From
         * @example "2023-03-13T20:00:00.000Z"
         */
        fromDate?: string
        /**
         * Filter by Date To
         * @example "2023-03-14T19:59:59.999Z"
         */
        toDate?: string
        /**
         * Current Date
         * @example "2023-03-14"
         */
        currentDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<AnalyticsFetchHomeCalendarResponse, any>({
        path: `/v1_private/analytics/fetchHomeCalendar`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Analytics
     * @name AnalyticsFetchHotLinksList
     * @summary Get Hot Links
     * @request GET:/v1_private/analytics/fetchHotLinks
     */
    analyticsFetchHotLinksList: (
      query?: {
        /**
         * Filter by Date From
         * @example "2023-03-13T20:00:00.000Z"
         */
        fromDate?: string
        /**
         * Filter by Date To
         * @example "2023-03-14T19:59:59.999Z"
         */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<AnalyticsFetchHotLinksResponse, any>({
        path: `/v1_private/analytics/fetchHotLinks`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Analytics
     * @name AnalyticsFetchKeywordsAnalysisList
     * @summary Get Keywords Analysis on campaigns
     * @request GET:/v1_private/analytics/fetchKeywordsAnalysis
     */
    analyticsFetchKeywordsAnalysisList: (
      query?: {
        /**
         * Filter by Date From
         * @example "2023-03-13T20:00:00.000Z"
         */
        fromDate?: string
        /**
         * Filter by Date To
         * @example "2023-03-14T19:59:59.999Z"
         */
        toDate?: string
        /** @example "6508926c66f56e47617ed4a6" */
        campaign?: string
        /**
         * User selected keywords
         * @example "AzerGold,Ogtay Mammadov"
         */
        selectedKeywords?: string
        /**
         * filterCount is a number which user selects
         * @example 10
         */
        filterCount?: string
        /**
         * filterChoice is a string, more or less
         * @example "more"
         */
        filterChoice?: string
        /**
         * sentimentType is a string to filter by sentiment, can be single word e.g positive or comma seperated positive,negative,neutral. if selected All Types sentimentType should be 'total'
         * @example "positives,neutrals"
         */
        sentimentType?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<AnalyticsKeywordsAnalysisResponse, any>({
        path: `/v1_private/analytics/fetchKeywordsAnalysis`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Analytics
     * @name AnalyticsFetchLocationsList
     * @summary Get Locations Data filtered by campaign and zoom level
     * @request GET:/v1_private/analytics/fetchLocations
     */
    analyticsFetchLocationsList: (
      query?: {
        /**
         * Filter by Date From
         * @example "2023-03-13T20:00:00.000Z"
         */
        fromDate?: string
        /**
         * Filter by Date To
         * @example "2023-03-14T19:59:59.999Z"
         */
        toDate?: string
        /**
         * Filter by Campaign ID
         * @example "63ff25da11b15267d928b99c"
         */
        campaign?: string
        /**
         * Zoom level
         * @example "1"
         */
        zoom?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<AnalyticsFetchLocationsResponse, any>({
        path: `/v1_private/analytics/fetchLocations`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Analytics
     * @name AnalyticsFetchMostMentionsList
     * @summary Get Most Mentions
     * @request GET:/v1_private/analytics/fetchMostMentions
     */
    analyticsFetchMostMentionsList: (
      query?: {
        /**
         * Filter by Date From
         * @example "2023-03-13T20:00:00.000Z"
         */
        fromDate?: string
        /**
         * Filter by Date To
         * @example "2023-03-14T19:59:59.999Z"
         */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<AnalyticsFetchMostMentionsResponse, any>({
        path: `/v1_private/analytics/fetchMostMentions`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Analytics
     * @name AnalyticsFetchPositivityPercentList
     * @summary Get Positivity Percent
     * @request GET:/v1_private/analytics/fetchPositivityPercent
     */
    analyticsFetchPositivityPercentList: (
      query?: {
        /**
         * Filter by Date From
         * @example "2023-03-13T20:00:00.000Z"
         */
        fromDate?: string
        /**
         * Filter by Date To
         * @example "2023-03-14T19:59:59.999Z"
         */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<AnalyticsFetchPositivityPercentResponse, any>({
        path: `/v1_private/analytics/fetchPositivityPercent`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves analytics data for all campaigns within the specified date range
     *
     * @tags Analytics
     * @name AnalyticsFetchQuickDetailsList
     * @summary Get Campaign Analytics Details
     * @request GET:/v1_private/analytics/fetchQuickDetails
     */
    analyticsFetchQuickDetailsList: (
      query?: {
        /**
         * Start date for analytics data
         * @format date-time
         * @example "2023-03-13T20:00:00.000Z"
         */
        fromDate?: string
        /**
         * End date for analytics data
         * @format date-time
         * @example "2023-03-14T19:59:59.999Z"
         */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<AnalyticsFetchQuickDetailsResponse, any>({
        path: `/v1_private/analytics/fetchQuickDetails`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Analytics
     * @name AnalyticsFetchRadarChartList
     * @summary Get Radar Chart
     * @request GET:/v1_private/analytics/fetchRadarChart
     */
    analyticsFetchRadarChartList: (
      query?: {
        /**
         * Filter by Date From
         * @example "2023-03-13T20:00:00.000Z"
         */
        fromDate?: string
        /**
         * Filter by Date To
         * @example "2023-03-14T19:59:59.999Z"
         */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<AnalyticsFetchRadarChartResponse, any>({
        path: `/v1_private/analytics/fetchRadarChart`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Analytics
     * @name AnalyticsFetchSentimentAnalysisList
     * @summary Get Sentiment Analysis filtered by Campaign, Category, Keyword or Source
     * @request GET:/v1_private/analytics/fetchSentimentAnalysis
     */
    analyticsFetchSentimentAnalysisList: (
      query?: {
        /**
         * Filter by Date From
         * @example "2023-03-07T20:00:00.000Z"
         */
        fromDate?: string
        /**
         * Filter by Date To
         * @example "2023-03-14T19:59:59.999Z"
         */
        toDate?: string
        /**
         * Filter by campaign id
         * @example "63ff25da11b15267d928b99c"
         */
        campaign?: string
        /** Filter by category */
        category?: string
        /**
         * Filter by keyword
         * @example "Bellingham"
         */
        keyword?: string
        /**
         * Filter by source, allowed values: twitter, youtube, reddit, news & blogs
         * @example "reddit"
         */
        source?: string
        /**
         * Selected sources separated by comma. Use 'none' to explicitly return zero results.
         * @example "Facebook,Instagram"
         */
        selectedSources?: string
        /**
         * Selected keywords separated by comma. Use 'none' to explicitly return zero results.
         * @example "Bellingham,Messi"
         */
        selectedKeywords?: string
        /**
         * Selected languages separated by comma
         * @example "English,Spanish"
         */
        languages?: string
        /**
         * Filter for lost mentions (values: both, lost, not_lost)
         * @default "both"
         * @example "both"
         */
        isLost?: string
        /**
         * Filter for mention format. Comma-separated subset of: hashtag, handle, keyword. Legacy value 'both' = no filter.
         * @default "both"
         * @example "both"
         */
        mentionFormat?: string
        /**
         * Filter by social_media_mention_type. Comma-separated subset of: post, comment, article. Omit for no filter (all types, including null).
         * @example "post,comment"
         */
        mentionType?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<AnalyticsFetchSentimentAnalysisResponse, any>({
        path: `/v1_private/analytics/fetchSentimentAnalysis`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Analytics
     * @name AnalyticsFetchSentimentChartList
     * @summary Get Sentiment Chart filtered by Campaign, Category, Keyword, and Source
     * @request GET:/v1_private/analytics/fetchSentimentChart
     */
    analyticsFetchSentimentChartList: (
      query?: {
        /**
         * Filter by Date From
         * @example "2023-03-13T20:00:00.000Z"
         */
        fromDate?: string
        /**
         * Filter by Date To
         * @example "2023-03-14T19:59:59.999Z"
         */
        toDate?: string
        /**
         * Filter by Campaign ID
         * @example "63ff25da11b15267d928b99c"
         */
        campaign?: string
        /** Filter by Category */
        category?: string
        /**
         * Filter by Keywords (comma separated list). Use 'none' to explicitly return zero results.
         * @example "Trello,Bitbucket"
         */
        keywords?: string
        /**
         * Filter by Sources (comma separated list). Use 'none' to explicitly return zero results.
         * @example "reddit,twitter"
         */
        sources?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<AnalyticsFetchSentimentChartResponse, any>({
        path: `/v1_private/analytics/fetchSentimentChart`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Analytics
     * @name AnalyticsFetchThreadsList
     * @summary Get Threads filtered by Campaign, Keyword, Source or Sentiment
     * @request GET:/v1_private/analytics/fetchThreads
     */
    analyticsFetchThreadsList: (
      query?: {
        /**
         * Filter by campaign id
         * @example "638483bf7c37f93cf946d870"
         */
        campaign?: string
        /**
         * Filter by campaign keyword
         * @example "Bellingham"
         */
        keyword?: string
        /**
         * Filter by source, allowed values: twitter, youtube, reddit, news & blogs
         * @example "reddit"
         */
        source?: string
        /**
         * Filter by sentiment, allowed values: POS, NEG, NEU
         * @example "POS"
         */
        sentiment?: AnalyticsFetchThreadsSentimentType
        /**
         * Used in paging together with vector. If specified, returns results before / after the date
         * @example "2023-01-24T14:49:09.000Z"
         */
        lastDate?: string
        /**
         * Used in paging together with lastDate. If specified, sets the sorting order, e.g. desc means descending date order. allowed values: desc, asc
         * @example "desc"
         */
        vector?: AnalyticsFetchThreadsVectorType
        /**
         * Number of items returned in the response
         * @example 10
         */
        limit?: number
        /**
         * Selected sources for threads, separated by comma. Use 'none' to explicitly return zero results.
         * @example "Facebook,Instagram"
         */
        selectedSources?: string
        /**
         * Selected keywords for threads, separated by comma. Use 'none' to explicitly return zero results.
         * @example "Apple,Microsoft"
         */
        selectedKeywords?: string
        /**
         * Filter by languages, separated by comma
         * @example "english,spanish,french"
         */
        languages?: string
        /**
         * Filter by lost status, allowed values: true, false, both
         * @example "both"
         */
        isLost?: AnalyticsFetchThreadsIsLostType
        /**
         * Filter by mention format. Comma-separated subset of: hashtag, handle, keyword. Legacy value 'both' = no filter.
         * @example "both"
         */
        mentionFormat?: string
        /**
         * Filter by social_media_mention_type. Comma-separated subset of: post, comment, article. Omit for no filter (all types, including null).
         * @example "post,comment"
         */
        mentionType?: string
        /**
         * Search threads by text, translated text, or link URL (case-insensitive partial match)
         * @example "bellingham"
         */
        search?: string
        /**
         * Filter by date, returns results after the date
         * @example "2023-01-24T14:49:09.000Z"
         */
        fromDate?: string
        /**
         * Filter by date, returns results before the date
         * @example "2023-01-24T14:49:09.000Z"
         */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<AnalyticsFetchThreadsResponse, any>({
        path: `/v1_private/analytics/fetchThreads`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CSV
     * @name AnalyticsFetchThreadsCsvList
     * @summary Download a CSV file
     * @request GET:/v1_private/analytics/fetchThreadsCSV
     */
    analyticsFetchThreadsCsvList: (
      query?: {
        /**
         * Filter by campaign keyword
         * @example "Bellingham"
         */
        keyword?: string
        /**
         * Filter by source, allowed values: twitter, youtube, reddit, news & blogs
         * @example "reddit"
         */
        source?: string
        /**
         * Filter by sentiment, allowed values: POS, NEG, NEU
         * @example "POS"
         */
        sentiment?: FetchThreadsCSVSentimentType
        /**
         * Used in paging together with vector. If specified, returns results before / after the date
         * @example "2023-01-24T14:49:09.000Z"
         */
        lastDate?: string
        /**
         * Used in paging together with lastDate. If specified, sets the sorting order, e.g. desc means descending date order. allowed values: desc, asc
         * @example "desc"
         */
        vector?: FetchThreadsCSVVectorType
        /**
         * Number of items returned in the response
         * @example 10
         */
        limit?: number
        /**
         * Selected sources for threads, seperated by comma
         * @example "Facebook,Instagram"
         */
        selectedSources?: string
        /**
         * Selected keywords for threads, seperated by comma
         * @example "Apple,Microsoft"
         */
        selectedKeywords?: string
        /**
         * Filter by languages, separated by comma
         * @example "english,spanish,french"
         */
        languages?: string
        /**
         * Filter by lost status, allowed values: true, false, both
         * @example "both"
         */
        isLost?: FetchThreadsCSVIsLostType
        /**
         * Filter by mention format. Comma-separated subset of: hashtag, handle, keyword. Legacy value 'both' = no filter.
         * @example "both"
         */
        mentionFormat?: string
        /**
         * Filter by social_media_mention_type. Comma-separated subset of: post, comment, article. Omit for no filter (all types, including null).
         * @example "post,comment"
         */
        mentionType?: string
        /**
         * Filter by date, returns results after the date
         * @example "2023-01-24T14:49:09.000Z"
         */
        fromDate?: string
        /**
         * Filter by date, returns results before the date
         * @example "2023-01-24T14:49:09.000Z"
         */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<File, any>({
        path: `/v1_private/analytics/fetchThreadsCSV`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Analytics
     * @name AnalyticsFetchTopSourcesList
     * @summary Get Top Sources
     * @request GET:/v1_private/analytics/fetchTopSources
     */
    analyticsFetchTopSourcesList: (
      query?: {
        /**
         * Filter by Date From
         * @example "2023-03-13T20:00:00.000Z"
         */
        fromDate?: string
        /**
         * Filter by Date To
         * @example "2023-03-14T19:59:59.999Z"
         */
        toDate?: string
        /**
         * Filter by Campaign ID
         * @example "63ef6abdb64d85ff5d735782"
         */
        campaign?: string
        /** Filter by Category */
        category?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<AnalyticsFetchTopSourcesResponse, any>({
        path: `/v1_private/analytics/fetchTopSources`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns summary stats and campaign health data for the dashboard overview
     *
     * @tags Analytics
     * @name AnalyticsOverviewList
     * @summary Get Analytics Overview
     * @request GET:/v1_private/analytics/overview
     */
    analyticsOverviewList: (
      query?: {
        /**
         * Filter by Date From (ISO format)
         * @example "2024-01-01T00:00:00.000Z"
         */
        fromDate?: string
        /**
         * Filter by Date To (ISO format)
         * @example "2024-12-31T23:59:59.999Z"
         */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<AnalyticsOverviewResponse, any>({
        path: `/v1_private/analytics/overview`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Analytics
     * @name AnalyticsTopKeywordsList
     * @summary Get Top Keywords
     * @request GET:/v1_private/analytics/topKeywords
     */
    analyticsTopKeywordsList: (
      query?: {
        /**
         * Filter by Date From
         * @example "2023-03-13T20:00:00.000Z"
         */
        fromDate?: string
        /**
         * Filter by Date To
         * @example "2023-03-14T19:59:59.999Z"
         */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<AnalyticsFetchTopKeywordsResponse, any>({
        path: `/v1_private/analytics/topKeywords`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Campaign
     * @name CampaignCategoryList
     * @summary Fetch campaign categories
     * @request GET:/v1_private/campaign/category
     */
    campaignCategoryList: (params: RequestParams = {}) =>
      this.request<CampaignCategory, any>({
        path: `/v1_private/campaign/category`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Export comparison data for campaigns in Excel format with visual charts. If no campaign IDs provided, exports all user campaigns.
     *
     * @tags Campaign
     * @name CampaignCompareExcelList
     * @summary Export campaign comparison to Excel with charts
     * @request GET:/v1_private/campaign/compare/excel
     */
    campaignCompareExcelList: (
      query?: {
        /**
         * Comma-separated list of campaign IDs to compare. If not provided, exports all user campaigns
         * @example "63ff25da11b15267d928b99c,63ff25da11b15267d928b99d"
         */
        campaignIds?: string
        /**
         * Comma-separated list of metrics to include (mentions, sources, sentiments)
         * @example "mentions,sources,sentiments"
         */
        metrics?: string
        /**
         * Start date for comparison (defaults to 1970-01-01 if not provided)
         * @example "2023-03-01T00:00:00.000Z"
         */
        fromDate?: string
        /**
         * End date for comparison (defaults to current date if not provided)
         * @example "2023-03-31T23:59:59.999Z"
         */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<File, ErrorResponse>({
        path: `/v1_private/campaign/compare/excel`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * @description Export comparison data for campaigns in CSV format. If no campaign IDs provided, exports all user campaigns.
     *
     * @tags Campaign
     * @name CampaignCompareExportList
     * @summary Export campaign comparison data to CSV
     * @request GET:/v1_private/campaign/compare/export
     */
    campaignCompareExportList: (
      query?: {
        /**
         * Comma-separated list of campaign IDs to compare. If not provided, exports all user campaigns
         * @example "63ff25da11b15267d928b99c,63ff25da11b15267d928b99d"
         */
        campaignIds?: string
        /**
         * Comma-separated list of metrics to include (mentions, sources, sentiments)
         * @example "mentions,sources,sentiments"
         */
        metrics?: string
        /**
         * Include summary statistics section (default: true)
         * @example true
         */
        includeStats?: boolean
        /**
         * Start date for comparison (defaults to 1970-01-01 if not provided)
         * @example "2023-03-01T00:00:00.000Z"
         */
        fromDate?: string
        /**
         * End date for comparison (defaults to current date if not provided)
         * @example "2023-03-31T23:59:59.999Z"
         */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<File, ErrorResponse>({
        path: `/v1_private/campaign/compare/export`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * @description Compare 2-9 campaigns across various metrics including mentions, sources, and sentiments
     *
     * @tags Campaign
     * @name CampaignCompareCreate
     * @summary Compare multiple campaigns
     * @request POST:/v1_private/campaign/compare
     */
    campaignCompareCreate: (
      data: CampaignCompareRequest,
      query?: {
        /**
         * Start date for comparison (defaults to 1970-01-01 if not provided)
         * @example "2023-03-01T00:00:00.000Z"
         */
        fromDate?: string
        /**
         * End date for comparison (defaults to current date if not provided)
         * @example "2023-03-31T23:59:59.999Z"
         */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<CampaignCompareResponse, ErrorResponse>({
        path: `/v1_private/campaign/compare`,
        method: 'POST',
        query: query,
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Campaign
     * @name CampaignFetchDailyPositivityCampaignList
     * @summary Fetch daily positivity campaign data
     * @request GET:/v1_private/campaign/fetchDailyPositivityCampaign
     */
    campaignFetchDailyPositivityCampaignList: (
      query?: {
        /**
         * Filter by Date
         * @example "2023-03-14"
         */
        fromDate?: string
        /**
         * Filter by Date
         * @example "2023-03-14"
         */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<DailyPositivityCampaignResponse, any>({
        path: `/v1_private/campaign/fetchDailyPositivityCampaign`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Campaign
     * @name CampaignFetchTopLocationList
     * @summary Fetch top location data
     * @request GET:/v1_private/campaign/fetchTopLocation
     */
    campaignFetchTopLocationList: (
      query?: {
        /**
         * Filter by Date
         * @example "2023-03-14"
         */
        fromDate?: string
        /**
         * Filter by Date
         * @example "2023-03-14"
         */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<CampaignFetchTopLocationData, any>({
        path: `/v1_private/campaign/fetchTopLocation`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Campaign
     * @name CampaignFetchTopSourceList
     * @summary Fetch top source data
     * @request GET:/v1_private/campaign/fetchTopSource
     */
    campaignFetchTopSourceList: (
      query?: {
        /**
         * Filter by Date
         * @example "2023-03-14"
         */
        fromDate?: string
        /**
         * Filter by Date
         * @example "2023-03-14"
         */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<CampaignFetchTopSourceData, any>({
        path: `/v1_private/campaign/fetchTopSource`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Campaign
     * @name CampaignList
     * @summary Fetch campaign
     * @request GET:/v1_private/campaign
     */
    campaignList: (
      query?: {
        /**
         * Filter by Date
         * @example "2023-03-14"
         */
        fromDate?: string
        /**
         * Filter by Date
         * @example "2023-03-14"
         */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<FetchCampaignsResponse, any>({
        path: `/v1_private/campaign`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Campaign
     * @name CampaignCreate
     * @summary Create campaign
     * @request POST:/v1_private/campaign
     */
    campaignCreate: (data: CampaignPayload, params: RequestParams = {}) =>
      this.request<CampaignResponse, any>({
        path: `/v1_private/campaign`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Campaign
     * @name CampaignDetail
     * @summary Fetch campaign
     * @request GET:/v1_private/campaign/{id}
     */
    campaignDetail: (id: string, params: RequestParams = {}) =>
      this.request<FetchCampaignByIdResponse, any>({
        path: `/v1_private/campaign/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Campaign
     * @name CampaignUpdate
     * @summary Update campaign
     * @request PUT:/v1_private/campaign/{id}
     */
    campaignUpdate: (
      id: string,
      data: CampaignPayload,
      params: RequestParams = {}
    ) =>
      this.request<UpdateCampaignResponse, any>({
        path: `/v1_private/campaign/${id}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Campaign
     * @name CampaignDelete
     * @summary Delete campaign
     * @request DELETE:/v1_private/campaign/{id}
     */
    campaignDelete: (id: string, params: RequestParams = {}) =>
      this.request<CampaignDelete, any>({
        path: `/v1_private/campaign/${id}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Thread Management
     * @name CampaignMakeThreadIrrelevantCreate
     * @summary Mark threads as irrelevant
     * @request POST:/v1_private/campaign/makeThreadIrrelevant
     */
    campaignMakeThreadIrrelevantCreate: (
      data: {
        /** Array of thread IDs to mark as irrelevant */
        ids: string[]
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /** @example true */
          success?: boolean
        },
        | {
            /** @example "An array of thread IDs is required in the request body" */
            error?: string
          }
        | {
            /** @example "An error occurred while marking the threads as irrelevant" */
            error?: string
          }
      >({
        path: `/v1_private/campaign/makeThreadIrrelevant`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Thread Management
     * @name CampaignMakeThreadRelevantCreate
     * @summary Mark threads as irrelevant
     * @request POST:/v1_private/campaign/makeThreadRelevant
     */
    campaignMakeThreadRelevantCreate: (
      data: {
        /** Array of thread IDs to mark as irrelevant */
        ids: string[]
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /** @example true */
          success?: boolean
        },
        | {
            /** @example "An array of thread IDs is required in the request body" */
            error?: string
          }
        | {
            /** @example "An error occurred while marking the threads as irrelevant" */
            error?: string
          }
      >({
        path: `/v1_private/campaign/makeThreadRelevant`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Thread Management
     * @name CampaignRemoveThreadDelete
     * @summary Remove threads
     * @request DELETE:/v1_private/campaign/removeThread
     */
    campaignRemoveThreadDelete: (
      data: {
        /** Array of thread IDs to remove */
        ids: string[]
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /** @example true */
          success?: boolean
        },
        | {
            /** @example "An array of thread IDs is required in the request body" */
            error?: string
          }
        | {
            /** @example "An error occurred while removing the threads" */
            error?: string
          }
      >({
        path: `/v1_private/campaign/removeThread`,
        method: 'DELETE',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Thread Management
     * @name CampaignReportThreadCreate
     * @summary Report threads
     * @request POST:/v1_private/campaign/reportThread
     */
    campaignReportThreadCreate: (
      data: {
        /** Array of thread IDs to report */
        ids: string[]
        /** Optional message for the report */
        message?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /** @example true */
          success?: boolean
        },
        | {
            /** @example "An array of thread IDs is required in the request body" */
            error?: string
          }
        | {
            /** @example "An error occurred while reporting the threads" */
            error?: string
          }
      >({
        path: `/v1_private/campaign/reportThread`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Updates the sentiment value for one or more threads in the enriched thread collection
     *
     * @tags Campaign
     * @name CampaignChangeSentimentCreate
     * @summary Change sentiment for multiple threads
     * @request POST:/v1_private/campaign/change-sentiment
     * @secure
     */
    campaignChangeSentimentCreate: (
      data: {
        /**
         * Array of thread IDs to update
         * @example ["64b4253d12da87805f15112f","64b4253d12da87805f15112e"]
         */
        ids: string[]
        /**
         * New sentiment value
         * @example "POS"
         */
        sentiment: 'POS' | 'NEG' | 'NEU'
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /** @example true */
          success?: boolean
          /**
           * Number of threads that were modified
           * @example 2
           */
          modified?: number
        },
        | {
            /** @example "An array of thread IDs is required in the request body" */
            error?: string
          }
        | {
            /** @example "An error occurred while changing the sentiment" */
            error?: string
          }
      >({
        path: `/v1_private/campaign/change-sentiment`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Campaign
     * @name CampaignTargetList
     * @summary Fetch campaign target
     * @request GET:/v1_private/campaign/target
     */
    campaignTargetList: (params: RequestParams = {}) =>
      this.request<CampaignTargetResponse, any>({
        path: `/v1_private/campaign/target`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns the data backing the campaigns hero/overview cards: campaign counts, sentiment totals + ratios, source breakdown, top-campaign and top-keyword sentiment winners. Items are ranked by positiveRatio / negativeRatio with deterministic tie-breakers (mentions desc, then stable id). mostPositive and mostNegative are always distinct items; any slot the backend cannot resolve returns null.
     *
     * @tags Campaigns
     * @name CampaignsOverviewList
     * @summary Campaigns hero overview
     * @request GET:/v1_private/campaigns/overview
     */
    campaignsOverviewList: (
      query: {
        /**
         * ISO-8601, inclusive
         * @example "2025-01-01T00:00:00.000Z"
         */
        fromDate: string
        /**
         * ISO-8601, inclusive
         * @example "2025-12-31T23:59:59.999Z"
         */
        toDate: string
        /**
         * Comma-separated campaign ids. When omitted, the response aggregates across
         * every campaign the session can see (global hero). When present, the response
         * is restricted to the intersection of these ids with the session's campaigns.
         * @example "6a04924e2b80b7842af3d32f,6a04928f2b80b70ed2f3d330"
         */
        campaignIds?: string
        /**
         * IANA tz or offset, applied to fromDate/toDate by the filter middleware
         * @example "Europe/Tbilisi"
         */
        timezone?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<CampaignsOverviewResponse, any>({
        path: `/v1_private/campaigns/overview`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Content Analysis
     * @name ContentAnalysisList
     * @summary List all content analyses for the authenticated user
     * @request GET:/v1_private/content-analysis
     */
    contentAnalysisList: (params: RequestParams = {}) =>
      this.request<ContentAnalysisListResponse, ContentAnalysisErrorResponse>({
        path: `/v1_private/content-analysis`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Content Analysis
     * @name ContentAnalysisCreate
     * @summary Create a new content analysis
     * @request POST:/v1_private/content-analysis
     */
    contentAnalysisCreate: (
      data: ContentAnalysisPayload,
      params: RequestParams = {}
    ) =>
      this.request<
        ContentAnalysisSingleResponse,
        ContentAnalysisValidationErrorResponse | ContentAnalysisErrorResponse
      >({
        path: `/v1_private/content-analysis`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Content Analysis
     * @name ContentAnalysisDetail
     * @summary Get a single content analysis by ID
     * @request GET:/v1_private/content-analysis/{id}
     */
    contentAnalysisDetail: (id: string, params: RequestParams = {}) =>
      this.request<ContentAnalysisSingleResponse, ContentAnalysisErrorResponse>(
        {
          path: `/v1_private/content-analysis/${id}`,
          method: 'GET',
          format: 'json',
          ...params,
        }
      ),

    /**
     * No description
     *
     * @tags Content Analysis
     * @name ContentAnalysisUpdate
     * @summary Update an existing content analysis
     * @request PUT:/v1_private/content-analysis/{id}
     */
    contentAnalysisUpdate: (
      id: string,
      data: ContentAnalysisPayload,
      params: RequestParams = {}
    ) =>
      this.request<
        ContentAnalysisSingleResponse,
        ContentAnalysisValidationErrorResponse | ContentAnalysisErrorResponse
      >({
        path: `/v1_private/content-analysis/${id}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Content Analysis
     * @name ContentAnalysisDelete
     * @summary Delete a content analysis
     * @request DELETE:/v1_private/content-analysis/{id}
     */
    contentAnalysisDelete: (id: string, params: RequestParams = {}) =>
      this.request<ContentAnalysisDeleteResponse, ContentAnalysisErrorResponse>(
        {
          path: `/v1_private/content-analysis/${id}`,
          method: 'DELETE',
          format: 'json',
          ...params,
        }
      ),

    /**
     * No description
     *
     * @tags Content Analysis Detail
     * @name ContentAnalysisContentPerformanceDetail
     * @summary Get content performance metrics by platform
     * @request GET:/v1_private/content-analysis/{id}/content-performance
     */
    contentAnalysisContentPerformanceDetail: (
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<ContentPerformanceResponse, ContentAnalysisErrorResponse>({
        path: `/v1_private/content-analysis/${id}/content-performance`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Content Analysis Detail
     * @name ContentAnalysisCommentsDetail
     * @summary Get comments with sentiment breakdown
     * @request GET:/v1_private/content-analysis/{id}/comments
     */
    contentAnalysisCommentsDetail: (
      id: string,
      query?: {
        /** Filter comments by platform */
        platform?:
          | 'facebook'
          | 'instagram'
          | 'tiktok'
          | 'twitter'
          | 'linkedin'
          | 'youtube'
        /**
         * Start date for filtering comments (inclusive)
         * @example "2024-01-01T00:00:00.000Z"
         */
        fromDate?: string
        /**
         * End date for filtering comments (inclusive)
         * @example "2024-01-31T23:59:59.999Z"
         */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<CommentsResponse, ContentAnalysisErrorResponse>({
        path: `/v1_private/content-analysis/${id}/comments`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Content Analysis Detail
     * @name ContentAnalysisIndividualPostsDetail
     * @summary Get paginated list of individual posts
     * @request GET:/v1_private/content-analysis/{id}/individual-posts
     */
    contentAnalysisIndividualPostsDetail: (
      id: string,
      query?: {
        /** Filter posts by platform */
        platform?:
          | 'facebook'
          | 'instagram'
          | 'tiktok'
          | 'twitter'
          | 'linkedin'
          | 'youtube'
        /**
         * Start date for filtering posts (inclusive)
         * @example "2024-01-01T00:00:00.000Z"
         */
        fromDate?: string
        /**
         * End date for filtering posts (inclusive)
         * @example "2024-01-31T23:59:59.999Z"
         */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<IndividualPostsResponse, ContentAnalysisErrorResponse>({
        path: `/v1_private/content-analysis/${id}/individual-posts`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Content Analysis Detail
     * @name ContentAnalysisEngagementInsightsDetail
     * @summary Get engagement insights (keywords, emojis, reactions)
     * @request GET:/v1_private/content-analysis/{id}/engagement-insights
     */
    contentAnalysisEngagementInsightsDetail: (
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<EngagementInsightsResponse, ContentAnalysisErrorResponse>({
        path: `/v1_private/content-analysis/${id}/engagement-insights`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Content Analysis Detail
     * @name ContentAnalysisActivityFrequencyDetail
     * @summary Get activity frequency heatmap data
     * @request GET:/v1_private/content-analysis/{id}/activity-frequency
     */
    contentAnalysisActivityFrequencyDetail: (
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<ActivityFrequencyResponse, ContentAnalysisErrorResponse>({
        path: `/v1_private/content-analysis/${id}/activity-frequency`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Content Analysis Detail
     * @name ContentAnalysisSmartInsightsDetail
     * @summary Get AI-generated smart insights
     * @request GET:/v1_private/content-analysis/{id}/smart-insights
     */
    contentAnalysisSmartInsightsDetail: (
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<SmartInsightsResponse, ContentAnalysisErrorResponse>({
        path: `/v1_private/content-analysis/${id}/smart-insights`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns the current credit balance and reset information for the authenticated user. Each user receives 100 credits daily that reset at midnight UTC.
     *
     * @tags Credits
     * @name CreditsList
     * @summary Get current user's credit balance
     * @request GET:/v1_private/credits
     */
    creditsList: (params: RequestParams = {}) =>
      this.request<
        {
          /** @example true */
          success?: boolean
          data?: {
            /**
             * Current available credits
             * @example 85
             */
            available?: number
            /**
             * Credits used since last reset
             * @example 15
             */
            totalUsedToday?: number
            /**
             * Maximum daily credits
             * @example 100
             */
            dailyLimit?: number
            /**
             * Credits required per AI chat message
             * @example 5
             */
            costPerMessage?: number
            /**
             * When credits were last reset
             * @format date-time
             * @example "2024-01-15T00:00:00.000Z"
             */
            lastResetDate?: string
            /**
             * Next credit reset time (midnight UTC)
             * @format date-time
             * @example "2024-01-16T00:00:00.000Z"
             */
            resetsAt?: string
          }
        },
        | {
            /** @example false */
            success?: boolean
            /** @example "Unauthorized" */
            error?: string
          }
        | {
            /** @example false */
            success?: boolean
            /** @example "Failed to fetch credit balance" */
            error?: string
          }
      >({
        path: `/v1_private/credits`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns the earliest and latest dates with data for a specific inbox analysis page. Used to populate the "Lifetime" date range in the date picker.
     *
     * @tags Inbox Analysis
     * @name InboxAnalysisActiveDateRangeDetail
     * @summary Get active date range for an inbox analysis page
     * @request GET:/v1_private/inbox-analysis/{pageId}/activeDateRange
     */
    inboxAnalysisActiveDateRangeDetail: (
      pageId: string,
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /**
           * Earliest date with data (null if no data exists)
           * @format date-time
           * @example "2024-06-15T00:00:00.000Z"
           */
          firstDate: string | null
          /**
           * Latest date with data (null if no data exists)
           * @format date-time
           * @example "2025-03-17T00:00:00.000Z"
           */
          lastDate: string | null
        },
        | {
            /** @example false */
            success?: boolean
            /** @example "pageId is required" */
            error?: string
          }
        | {
            /** @example false */
            success?: boolean
            /** @example "Unauthorized access" */
            error?: string
          }
        | {
            /** @example false */
            success?: boolean
            /** @example "Inbox analysis feature is not enabled for your account" */
            error?: string
          }
        | {
            /** @example false */
            success?: boolean
            /** @example "Failed to fetch inbox active date range" */
            error?: string
          }
      >({
        path: `/v1_private/inbox-analysis/${pageId}/activeDateRange`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns conversation categorization metrics grouped by platform or operator with tag distribution
     *
     * @tags Inbox Analysis
     * @name InboxAnalysisConversationCategorizationList
     * @summary Get conversation categorization analysis
     * @request GET:/v1_private/inbox-analysis/conversation-categorization
     */
    inboxAnalysisConversationCategorizationList: (
      query: {
        /**
         * Page/Account ID to fetch conversation categorization for
         * @example "page-123"
         */
        pageId: string
        /**
         * Analysis type - platform or operator based
         * @example "platform"
         */
        type: 'platform' | 'operator'
        /**
         * Start date for analysis (ISO format)
         * @format date
         * @example "2024-01-01"
         */
        fromDate?: string
        /**
         * End date for analysis (ISO format)
         * @format date
         * @example "2024-01-31"
         */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<
        PlatformCategorizationResponse | OperatorCategorizationResponse,
        ErrorResponse
      >({
        path: `/v1_private/inbox-analysis/conversation-categorization`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns frequently used keywords from conversations with sentiment analysis, filtered by customer or operator messages
     *
     * @tags Inbox Analysis
     * @name InboxAnalysisFrequentlyUsedKeywordsList
     * @summary Get frequently used keywords analysis
     * @request GET:/v1_private/inbox-analysis/frequently-used-keywords
     */
    inboxAnalysisFrequentlyUsedKeywordsList: (
      query: {
        /**
         * Page/Account ID to fetch keywords for
         * @example "page-123"
         */
        pageId: string
        /**
         * Analyze keywords from customer messages or operator messages
         * @example "customers"
         */
        type: 'customers' | 'operators'
        /**
         * Start date for analysis (ISO format)
         * @format date
         * @example "2024-01-01"
         */
        fromDate?: string
        /**
         * End date for analysis (ISO format)
         * @format date
         * @example "2024-01-31"
         */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<FrequentlyUsedKeywordsResponse, ErrorResponse>({
        path: `/v1_private/inbox-analysis/frequently-used-keywords`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns the messages belonging to one conversation from `inbox_messages_raw`, ordered as stored (oldest → newest), with offset/limit pagination over the in-document `messages` array. Scoped to the authenticated user via `hapttic_user_id` so a user cannot fetch someone else's conversation. System messages are excluded by default; set `includeSystem=true` to include them. The response also includes conversation-level metadata (platform, sentiment, topics, summary, external URL) the frontend typically wants when rendering a detail view, so a single round trip is enough for the initial page.
     *
     * @tags Inbox Analysis
     * @name InboxAnalysisInboxPreviewConversationsMessagesDetail
     * @summary Fetch messages of a single inbox conversation
     * @request GET:/v1_private/inbox-analysis/inbox-preview/conversations/{conversationId}/messages
     */
    inboxAnalysisInboxPreviewConversationsMessagesDetail: (
      conversationId: string,
      query?: {
        /**
         * @min 1
         * @max 200
         * @default 50
         */
        limit?: number
        /**
         * @min 0
         * @default 0
         */
        offset?: number
        /**
         * Include system messages in the result. Default excludes them.
         * @default false
         */
        includeSystem?: boolean
      },
      params: RequestParams = {}
    ) =>
      this.request<InboxPreviewConversationMessagesResponse, void>({
        path: `/v1_private/inbox-analysis/inbox-preview/conversations/${conversationId}/messages`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns a paginated page of conversation rows for the current filter scope. Cursor pagination is opaque (base64-encoded `{updated_time, conversation_id}`) and stable across pages as long as the filter scope does not change. Notes: - `sentiment=other` maps to `neutral`. - `operators` filter matches by operator display name. - `snippet` is the first non-system Customer message text, falling back to the bedrock conversation summary, trimmed to ~240 chars.
     *
     * @tags Inbox Analysis
     * @name InboxAnalysisInboxPreviewConversationsList
     * @summary Inbox Preview paginated conversation list
     * @request GET:/v1_private/inbox-analysis/inbox-preview/conversations
     */
    inboxAnalysisInboxPreviewConversationsList: (
      query: {
        pageId: string
        /** @format date-time */
        fromDate?: string
        /** @format date-time */
        toDate?: string
        /** Comma-separated platform ids. */
        platforms?: string
        topics?: string
        operators?: string
        /** @default "all" */
        sentiment?: 'all' | 'positive' | 'negative' | 'other'
        /** Keep only paid or organic conversations (pages with ad-label attribution only). */
        source?: 'paid' | 'organic'
        /** Keep only converted, committed or unconverted (no status) conversations. Ignored for pages without conversion data. */
        conversion?: 'converted' | 'committed' | 'unconverted'
        /** Opaque cursor; omit for the first page. */
        cursor?: string
        /**
         * @min 1
         * @max 100
         * @default 20
         */
        limit?: number
        /** @default "newest" */
        sort?: 'newest' | 'oldest'
        /**
         * Free-text search over participant names (the customer's first/last
         * name). Applied across the whole collection before pagination.
         */
        search?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<InboxPreviewConversationsResponse, ErrorResponse>({
        path: `/v1_private/inbox-analysis/inbox-preview/conversations`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns the data behind the Inbox Preview donut (sentiment split for the current platform/topic/operator scope) plus the available filter facets for the date range. Sentiment-tab filtering is NOT applied here — the donut always shows the full split for the current scope. Sentiment percentages are server-rounded so they sum to 100 when total > 0.
     *
     * @tags Inbox Analysis
     * @name InboxAnalysisInboxPreviewSummaryList
     * @summary Inbox Preview donut + facets
     * @request GET:/v1_private/inbox-analysis/inbox-preview/summary
     */
    inboxAnalysisInboxPreviewSummaryList: (
      query: {
        pageId: string
        /**
         * Lifetime if omitted.
         * @format date-time
         */
        fromDate?: string
        /**
         * Now if omitted.
         * @format date-time
         */
        toDate?: string
        /** Comma-separated platform ids. Omit/empty = all. */
        platforms?: string
        /** Comma-separated topic ids. */
        topics?: string
        /** Comma-separated operator ids (display names). */
        operators?: string
        /** Restrict the donut to paid or organic conversations. */
        source?: 'paid' | 'organic'
        /** Keep only converted, committed or unconverted (no status) conversations. Ignored for pages without conversion data. */
        conversion?: 'converted' | 'committed' | 'unconverted'
      },
      params: RequestParams = {}
    ) =>
      this.request<InboxPreviewSummaryResponse, ErrorResponse>({
        path: `/v1_private/inbox-analysis/inbox-preview/summary`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns message volume trends for a specific page/account across different time periods and platforms
     *
     * @tags Inbox Analysis
     * @name InboxAnalysisMessageVolumeTrendsList
     * @summary Get message volume trends
     * @request GET:/v1_private/inbox-analysis/message-volume-trends
     */
    inboxAnalysisMessageVolumeTrendsList: (
      query: {
        /**
         * Page/Account ID to fetch trends for
         * @example "page-123"
         */
        pageId: string
        /**
         * Aggregation period for the trends
         * @default "overall"
         */
        period?: 'overall' | 'daily' | 'weekly' | 'monthly'
        /**
         * Start date for analysis (ISO format)
         * @format date
         * @example "2024-01-01"
         */
        fromDate?: string
        /**
         * End date for analysis (ISO format)
         * @format date
         * @example "2024-01-31"
         */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<
        | OverallPeriodResponse
        | DailyPeriodResponse
        | WeeklyPeriodResponse
        | MonthlyPeriodResponse,
        ErrorResponse
      >({
        path: `/v1_private/inbox-analysis/message-volume-trends`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns synthesized "trend / risk / opportunity" cards generated by rolling up multiple smart insights. Reads from the `meta_insights` collection (separate from `smart_insights`). The writer replaces by window range on every run, so the date filter uses simple containment (`window.from >= fromDate AND window.to <= toDate`) rather than overlap math. Important: `title`, `detail`, and `recommendation` may contain inline highlight tags — `<red>...</red>`, `<green>...</green>`, `<yellow>...</yellow>`. The server passes them through unchanged. The frontend is responsible for parsing and rendering them.
     *
     * @tags Inbox Analysis
     * @name InboxAnalysisMetaInsightsList
     * @summary Get meta (synthesized) insights for an inbox page
     * @request GET:/v1_private/inbox-analysis/meta-insights
     */
    inboxAnalysisMetaInsightsList: (
      query: {
        pageId: string
        /**
         * Lower bound on `window.from`. Lifetime if omitted.
         * @format date-time
         */
        fromDate?: string
        /**
         * Upper bound on `window.to`. Now if omitted.
         * @format date-time
         */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<MetaInsightsResponse, ErrorResponse>({
        path: `/v1_private/inbox-analysis/meta-insights`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns performance metrics for customer service operators including sentiment analysis breakdown
     *
     * @tags Inbox Analysis
     * @name InboxAnalysisOperatorPerformanceList
     * @summary Get operator performance breakdown
     * @request GET:/v1_private/inbox-analysis/operator-performance
     */
    inboxAnalysisOperatorPerformanceList: (
      query: {
        /**
         * Page/Account ID to fetch operator performance for
         * @example "page-123"
         */
        pageId: string
        /**
         * Start date for analysis (ISO format)
         * @format date
         * @example "2024-01-01"
         */
        fromDate?: string
        /**
         * End date for analysis (ISO format)
         * @format date
         * @example "2024-01-31"
         */
        toDate?: string
        /**
         * Optional platform filter (single value or comma-separated list).
         * Use "all" or omit for every platform.
         * @example "facebook"
         */
        platforms?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<OperatorPerformanceResponse, ErrorResponse>({
        path: `/v1_private/inbox-analysis/operator-performance`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns the data backing the Inbox Analysis "Overview" card: total chats / messages with sentiment breakdown, the platforms or operators active in the date range, the top platform/operator, the top day of week, and the top topic. The `groupBy` toggle drives whether the `groups` and `topGroup` blocks are broken down by platform or by operator. Notes: - Sentiment percentages are server-rounded so they always sum to 100 when total > 0 (no rounding drift on the frontend). - `topDay.trendPercent` compares the matching day-of-week's total in the requested range with the same length immediately preceding window. When no explicit `fromDate`+`toDate` is provided (lifetime mode), trends are returned as `null` so the frontend can hide the badge. - `totalMessages` is computed on-demand from `inbox_messages_raw` (non-system messages, bucketed by the bedrock sentiment of each conversation), so it is a true message count and will differ from `totalChats` (which counts conversations).
     *
     * @tags Inbox Analysis
     * @name InboxAnalysisOverviewList
     * @summary Get inbox analysis overview card
     * @request GET:/v1_private/inbox-analysis/overview
     */
    inboxAnalysisOverviewList: (
      query: {
        /** @example "223850724706670" */
        pageId: string
        /**
         * Start of the analysis range (ISO). Lifetime if omitted.
         * @format date-time
         */
        fromDate?: string
        /**
         * End of the analysis range (ISO). Now if omitted.
         * @format date-time
         */
        toDate?: string
        /** Drives the breakdown for the `groups` and `topGroup` blocks. */
        groupBy: 'platforms' | 'operators'
        /** Optional comma-separated platform ids. Omit or pass `all` for all platforms. */
        platforms?: string
        /** Optional comma-separated operator ids or names. Omit for all operators. */
        operatorIds?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<InboxOverviewResponse, ErrorResponse>({
        path: `/v1_private/inbox-analysis/overview`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Inbox Analysis
     * @name InboxAnalysisPagesList
     * @request GET:/v1_private/inbox-analysis/pages
     */
    inboxAnalysisPagesList: (
      query?: {
        /**
         * Start date for analysis (defaults to 1970-01-01 if not provided)
         * @example "2024-01-01T00:00:00.000Z"
         */
        fromDate?: string
        /**
         * End date for analysis (defaults to current date if not provided)
         * @example "2024-01-31T23:59:59.999Z"
         */
        toDate?: string
        /**
         * IANA timezone for the Key Insights peak day (defaults to UTC)
         * @example "Asia/Tbilisi"
         */
        tz?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<any, any>({
        path: `/v1_private/inbox-analysis/pages`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @name SummaryV1Private
     * @request SUMMARY:/v1_private/inbox-analysis/pages
     */
    summaryV1Private: (
      query?: {
        /**
         * Start date for analysis (defaults to 1970-01-01 if not provided)
         * @example "2024-01-01T00:00:00.000Z"
         */
        fromDate?: string
        /**
         * End date for analysis (defaults to current date if not provided)
         * @example "2024-01-31T23:59:59.999Z"
         */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<any, any>({
        path: `/v1_private/inbox-analysis/pages`,
        method: 'SUMMARY',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @name DescriptionV1Private
     * @request DESCRIPTION:/v1_private/inbox-analysis/pages
     */
    descriptionV1Private: (
      query?: {
        /**
         * Start date for analysis (defaults to 1970-01-01 if not provided)
         * @example "2024-01-01T00:00:00.000Z"
         */
        fromDate?: string
        /**
         * End date for analysis (defaults to current date if not provided)
         * @example "2024-01-31T23:59:59.999Z"
         */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<any, any>({
        path: `/v1_private/inbox-analysis/pages`,
        method: 'DESCRIPTION',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @name ResponsesV1Private
     * @request RESPONSES:/v1_private/inbox-analysis/pages
     */
    responsesV1Private: (
      query?: {
        /**
         * Start date for analysis (defaults to 1970-01-01 if not provided)
         * @example "2024-01-01T00:00:00.000Z"
         */
        fromDate?: string
        /**
         * End date for analysis (defaults to current date if not provided)
         * @example "2024-01-31T23:59:59.999Z"
         */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<any, any>({
        path: `/v1_private/inbox-analysis/pages`,
        method: 'RESPONSES',
        query: query,
        ...params,
      }),

    /**
     * @description Returns response time metrics for platforms or operators including average response times and performance rankings
     *
     * @tags Inbox Analysis
     * @name InboxAnalysisResponseTimeList
     * @summary Get response time analysis
     * @request GET:/v1_private/inbox-analysis/response-time
     */
    inboxAnalysisResponseTimeList: (
      query: {
        /**
         * Page/Account ID to fetch response time analysis for
         * @example "page-123"
         */
        pageId: string
        /**
         * Analysis type - platform or operator based
         * @example "platform"
         */
        type: 'platform' | 'operator'
        /**
         * Start date for analysis (ISO format)
         * @format date
         * @example "2024-01-01"
         */
        fromDate?: string
        /**
         * End date for analysis (ISO format)
         * @format date
         * @example "2024-01-31"
         */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<
        PlatformResponseTimeResponse | OperatorResponseTimeResponse,
        ErrorResponse
      >({
        path: `/v1_private/inbox-analysis/response-time`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns AI-generated strengths/challenges insights for an inbox page. Reads from the shared `smart_insights` collection, filtered to docs with `scope: "inbox"`. Until the smart-analysis pipeline starts writing inbox-scoped documents, this endpoint will return `{ hasInsights: false, insights: [] }`. No pagination — expect ≤ ~30 insights per response. Category tab filtering happens client-side from the returned `category` values.
     *
     * @tags Inbox Analysis
     * @name InboxAnalysisSmartInsightsList
     * @summary Get AI-powered inbox smart insights
     * @request GET:/v1_private/inbox-analysis/smart-insights
     */
    inboxAnalysisSmartInsightsList: (
      query: {
        pageId: string
        /**
         * Filters by `createdAt`. Lifetime if omitted.
         * @format date-time
         */
        fromDate?: string
        /**
         * Filters by `createdAt`. Now if omitted.
         * @format date-time
         */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<InboxSmartInsightsResponse, ErrorResponse>({
        path: `/v1_private/inbox-analysis/smart-insights`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns the most frequently used phrases from inbox conversations, aggregated from the daily inbox precompute. Use `type=customers` for customer-side phrases or `type=operators` for operator-side phrases (templates). Note: precompute keeps the top 100 phrases per daily bucket, so cross-bucket totals are accurate at the head and approximate in the long tail.
     *
     * @tags Inbox Analysis
     * @name InboxAnalysisTopPhrasesList
     * @summary Get top phrases analysis
     * @request GET:/v1_private/inbox-analysis/top-phrases
     */
    inboxAnalysisTopPhrasesList: (
      query: {
        /**
         * Page/Account ID to fetch phrases for
         * @example "223850724706670"
         */
        pageId: string
        /**
         * Source side of phrases — customer messages or operator messages
         * @example "customers"
         */
        type: 'customers' | 'operators'
        /**
         * Start date for analysis (ISO format). Defaults to lifetime.
         * @format date
         * @example "2026-03-31"
         */
        fromDate?: string
        /**
         * End date for analysis (ISO format). Defaults to now.
         * @format date
         * @example "2026-04-07"
         */
        toDate?: string
        /**
         * Maximum number of phrases to return
         * @min 1
         * @max 100
         * @default 20
         */
        limit?: number
        /** Comma-separated platform ids to filter by (omit or 'all' for every platform) */
        platforms?: string
        /** Comma-separated operator ids to filter by (omit or 'all' for every operator) */
        operators?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<TopPhrasesResponse, ErrorResponse>({
        path: `/v1_private/inbox-analysis/top-phrases`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Keyword
     * @name KeywordAddRevewIdCreate
     * @summary Add review id for keyword, e.g google place id or booking.com link
     * @request POST:/v1_private/keyword/addRevewId
     */
    keywordAddRevewIdCreate: (
      query: {
        keyword: string
        campaign: string
        placeId?: string
        TripadvisorPlaceId: string
        bookingLink: string
      },
      params: RequestParams = {}
    ) =>
      this.request<object, any>({
        path: `/v1_private/keyword/addRevewId`,
        method: 'POST',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Keywords
     * @name KeywordFetchDailyTrendsList
     * @summary Get daily trends on keyword
     * @request GET:/v1_private/keyword/fetchDailyTrends
     */
    keywordFetchDailyTrendsList: (
      query?: {
        /** get data from */
        fromDate?: string
        /** get data until */
        toDate?: string
        /**
         * Filter by campaign id
         * @example "63847e707c37f9574546d86f"
         */
        campaign?: string
        /**
         * Filter by campaign keyword
         * @example "ABC"
         */
        keyword?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<KeywordFetchDailyTrends, any>({
        path: `/v1_private/keyword/fetchDailyTrends`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Keyword
     * @name KeywordFetchKeywordsWithStatsList
     * @summary Get Keyword with stats
     * @request GET:/v1_private/keyword/fetchKeywordsWithStats
     */
    keywordFetchKeywordsWithStatsList: (
      query?: {
        /**
         * Filter by Date
         * @example "2023-03-14"
         */
        fromDate?: string
        /**
         * Filter by Date
         * @example "2023-03-14"
         */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<KeywordFetchKeywordsWithStats[], any>({
        path: `/v1_private/keyword/fetchKeywordsWithStats`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Keyword
     * @name KeywordFetchSentimentAnalysisList
     * @summary Get Sentiment Analysis
     * @request GET:/v1_private/keyword/fetchSentimentAnalysis
     */
    keywordFetchSentimentAnalysisList: (
      query?: {
        /**
         * Filter by Date
         * @example "2023-03-14"
         */
        fromDate?: string
        /**
         * Filter by Date
         * @example "2023-03-14"
         */
        toDate?: string
        /**
         * Filter by Date
         * @example "63847e707c37f9574546d86f"
         */
        campaign?: string
        /**
         * Filter by Date
         * @example "Abc Abc"
         */
        keyword?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<KeywordFetchSentimentAnalysis, any>({
        path: `/v1_private/keyword/fetchSentimentAnalysis`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Keyword
     * @name KeywordFetchSentimentChartList
     * @summary Get Sentiment chart data
     * @request GET:/v1_private/keyword/fetchSentimentChart
     */
    keywordFetchSentimentChartList: (
      query?: {
        /**
         * Filter by Date
         * @example "2023-03-14"
         */
        fromDate?: string
        /**
         * Filter by Date
         * @example "2023-03-14"
         */
        toDate?: string
        /**
         * Filter by Date
         * @example "63847e707c37f9574546d86f"
         */
        campaign?: string
        /**
         * Filter by Date
         * @example "Abc Abc"
         */
        keyword?: string
        /**
         * list of campaign ids
         * @example "63847e707c37f9574546d86f,63847e707c37f9574546d86f"
         */
        campaigns?: string
        /**
         * list of sources
         * @example "asd,asd"
         */
        sources?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<KeywordFetchSentimentChart, any>({
        path: `/v1_private/keyword/fetchSentimentChart`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Keywords
     * @name KeywordFetchTopSourcesList
     * @summary Get top sources
     * @request GET:/v1_private/keyword/fetchTopSources
     */
    keywordFetchTopSourcesList: (
      query?: {
        /** get data from */
        fromDate?: string
        /** get data until */
        toDate?: string
        /**
         * Filter by campaign id
         * @example "63847e707c37f9574546d86f"
         */
        campaign?: string
        /**
         * Filter by campaign keyword
         * @example "Abc Abc"
         */
        keyword?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<KeywordFetchTopSources[], any>({
        path: `/v1_private/keyword/fetchTopSources`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Review Analysis Campaign
     * @name ReviewAnalysisCampaignList
     * @summary List the authenticated user's review-analysis campaigns
     * @request GET:/v1_private/review-analysis/campaign
     */
    reviewAnalysisCampaignList: (params: RequestParams = {}) =>
      this.request<
        ReviewAnalysisCampaignListResponse,
        ReviewAnalysisCampaignErrorResponse
      >({
        path: `/v1_private/review-analysis/campaign`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Review Analysis Campaign
     * @name ReviewAnalysisCampaignCreate
     * @summary Create a new review-analysis campaign
     * @request POST:/v1_private/review-analysis/campaign
     */
    reviewAnalysisCampaignCreate: (
      data: ReviewAnalysisCampaignCreateBody,
      params: RequestParams = {}
    ) =>
      this.request<
        ReviewAnalysisCampaignResponse,
        | ReviewAnalysisCampaignValidationErrorResponse
        | ReviewAnalysisCampaignErrorResponse
      >({
        path: `/v1_private/review-analysis/campaign`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Review Analysis Campaign
     * @name ReviewAnalysisCampaignDetail
     * @summary Fetch a single review-analysis campaign by id
     * @request GET:/v1_private/review-analysis/campaign/{reviewAnalysisCampaignId}
     */
    reviewAnalysisCampaignDetail: (
      reviewAnalysisCampaignId: string,
      params: RequestParams = {}
    ) =>
      this.request<ReviewAnalysisCampaignResponse, void>({
        path: `/v1_private/review-analysis/campaign/${reviewAnalysisCampaignId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Review Analysis Campaign
     * @name ReviewAnalysisCampaignUpdate
     * @summary Update a review-analysis campaign (currently only `name`)
     * @request PUT:/v1_private/review-analysis/campaign/{reviewAnalysisCampaignId}
     */
    reviewAnalysisCampaignUpdate: (
      reviewAnalysisCampaignId: string,
      data: ReviewAnalysisCampaignUpdateBody,
      params: RequestParams = {}
    ) =>
      this.request<
        ReviewAnalysisCampaignResponse,
        ReviewAnalysisCampaignValidationErrorResponse | void
      >({
        path: `/v1_private/review-analysis/campaign/${reviewAnalysisCampaignId}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Review Analysis Campaign
     * @name ReviewAnalysisCampaignDelete
     * @summary Delete a review-analysis campaign
     * @request DELETE:/v1_private/review-analysis/campaign/{reviewAnalysisCampaignId}
     */
    reviewAnalysisCampaignDelete: (
      reviewAnalysisCampaignId: string,
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /** @example true */
          success?: boolean
          /** @example "Review analysis campaign deleted successfully" */
          message?: string
        },
        void
      >({
        path: `/v1_private/review-analysis/campaign/${reviewAnalysisCampaignId}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * @description Drives whether the Review Analysis page shows the empty state or the populated dashboard. Derived from the campaign's platforms[].
     *
     * @tags Review Analysis
     * @name ReviewAnalysisCampaignStatusDetail
     * @summary Has this campaign added any review platforms?
     * @request GET:/v1_private/review-analysis/campaign/{reviewAnalysisCampaignId}/status
     */
    reviewAnalysisCampaignStatusDetail: (
      reviewAnalysisCampaignId: string,
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /** @example true */
          hasPlatforms?: boolean
        },
        any
      >({
        path: `/v1_private/review-analysis/campaign/${reviewAnalysisCampaignId}/status`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Aggregated brand overview: stats, sentiment, reviews-by-platform, top issues, facilities. Reads the embedded analytics fields on the campaign doc.
     *
     * @tags Review Analysis
     * @name ReviewAnalysisCampaignOverviewDetail
     * @summary Brand-level review dashboard for a campaign
     * @request GET:/v1_private/review-analysis/campaign/{reviewAnalysisCampaignId}/overview
     */
    reviewAnalysisCampaignOverviewDetail: (
      reviewAnalysisCampaignId: string,
      params: RequestParams = {}
    ) =>
      this.request<BrandOverviewResponse, any>({
        path: `/v1_private/review-analysis/campaign/${reviewAnalysisCampaignId}/overview`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Aggregated from the raw review_analysis_location records for this facility. Returns the facility headline (review-weighted rating, summed reviews, summed sentiment) plus a per-platform card breakdown. 404 if the facility has no review data.
     *
     * @tags Review Analysis
     * @name ReviewAnalysisCampaignFacilityOverviewDetail
     * @summary Facility-scoped headline stats + per-platform breakdown
     * @request GET:/v1_private/review-analysis/campaign/{reviewAnalysisCampaignId}/facility/{facilityId}/overview
     */
    reviewAnalysisCampaignFacilityOverviewDetail: (
      reviewAnalysisCampaignId: string,
      facilityId: string,
      params: RequestParams = {}
    ) =>
      this.request<
        {
          facility?: {
            id?: string
            name?: string
          }
          stats?: BrandStats
          byPlatform?: {
            platform?: string
            providerName?: string
            rating?: number
            reviewCount?: number
            sentiment?: {
              positive?: number
              neutral?: number
              negative?: number
              total?: number
            }
            /** @example "ready" */
            status?: string
          }[]
        },
        void
      >({
        path: `/v1_private/review-analysis/campaign/${reviewAnalysisCampaignId}/facility/${facilityId}/overview`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description The facility id is STABLE and independent of the name — only the name is updated (across the facility's reviews and submissions), so card ids ("<facilityId>::<platform>::<venue>") and targeting survive the rename. 404 if the facility has no data (no reviews and no submissions).
     *
     * @tags Review Analysis
     * @name ReviewAnalysisCampaignFacilityPartialUpdate
     * @summary Rename a facility
     * @request PATCH:/v1_private/review-analysis/campaign/{reviewAnalysisCampaignId}/facility/{facilityId}
     */
    reviewAnalysisCampaignFacilityPartialUpdate: (
      reviewAnalysisCampaignId: string,
      facilityId: string,
      data: {
        /** @example "Rooms Georgia" */
        name: string
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /** @example true */
          success?: boolean
          facility?: {
            /** @example "fac-rooms" */
            id?: string
            /** @example "Rooms Georgia" */
            name?: string
          }
        },
        void
      >({
        path: `/v1_private/review-analysis/campaign/${reviewAnalysisCampaignId}/facility/${facilityId}`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Cascades like the per-card delete but for the whole facility: removes every review and submission for the facility, cleans up each platform it leaves orphaned (platforms[] + platform-scoped insights), deletes facility-scoped insights, and clears brand-wide insights + topIssues if the campaign ends up empty. 404 if the facility has no data.
     *
     * @tags Review Analysis
     * @name ReviewAnalysisCampaignFacilityDelete
     * @summary Delete an entire facility and ALL its data
     * @request DELETE:/v1_private/review-analysis/campaign/{reviewAnalysisCampaignId}/facility/{facilityId}
     */
    reviewAnalysisCampaignFacilityDelete: (
      reviewAnalysisCampaignId: string,
      facilityId: string,
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /** @example true */
          success?: boolean
        },
        void
      >({
        path: `/v1_private/review-analysis/campaign/${reviewAnalysisCampaignId}/facility/${facilityId}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * @description All derived from per-review data. velocity[] = review counts in the last day/week/month with % trend vs the prior equal window. platformActivity reflects the busiest platform (or ?platformId). spike = busiest day. alerts = most recent low-rating reviews. alerts[].time is ISO (frontend formats "5m ago"). 404 if the facility has no data.
     *
     * @tags Review Analysis
     * @name ReviewAnalysisCampaignFacilityVelocityDetail
     * @summary Facility review velocity & alerts
     * @request GET:/v1_private/review-analysis/campaign/{reviewAnalysisCampaignId}/facility/{facilityId}/velocity
     */
    reviewAnalysisCampaignFacilityVelocityDetail: (
      reviewAnalysisCampaignId: string,
      facilityId: string,
      query?: {
        /**
         * Scope platformActivity to one platform
         * @example "booking"
         */
        platformId?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<ActivityResponse, void>({
        path: `/v1_private/review-analysis/campaign/${reviewAnalysisCampaignId}/facility/${facilityId}/velocity`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Same payload as the facility activity endpoint, but scoped to one platform across every facility. All derived from per-review data. 404 if the platform has no data.
     *
     * @tags Review Analysis
     * @name ReviewAnalysisCampaignPlatformActivityDetail
     * @summary Platform-level review velocity & alerts (across all facilities)
     * @request GET:/v1_private/review-analysis/campaign/{reviewAnalysisCampaignId}/platform/{platformId}/activity
     */
    reviewAnalysisCampaignPlatformActivityDetail: (
      reviewAnalysisCampaignId: string,
      platformId: string,
      params: RequestParams = {}
    ) =>
      this.request<ActivityResponse, void>({
        path: `/v1_private/review-analysis/campaign/${reviewAnalysisCampaignId}/platform/${platformId}/activity`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Campaign-level competitors plus the brand's own benchmark column (rating/reviews/positiveSentiment), derived from all reviews.
     *
     * @tags Review Analysis
     * @name ReviewAnalysisCampaignCompetitorsDetail
     * @summary List competitors + our own brand benchmark
     * @request GET:/v1_private/review-analysis/campaign/{reviewAnalysisCampaignId}/competitors
     */
    reviewAnalysisCampaignCompetitorsDetail: (
      reviewAnalysisCampaignId: string,
      params: RequestParams = {}
    ) =>
      this.request<
        {
          competitors?: Competitor[]
          /** Our own brand's benchmark column */
          brand?: {
            /** @example 4.3 */
            rating?: number
            /** @example 3560 */
            reviews?: number
            /**
             * Percent
             * @example 80
             */
            positiveSentiment?: number
          }
        },
        any
      >({
        path: `/v1_private/review-analysis/campaign/${reviewAnalysisCampaignId}/competitors`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Review Analysis
     * @name ReviewAnalysisCampaignCompetitorsCreate
     * @summary Add a competitor under this campaign (max 3)
     * @request POST:/v1_private/review-analysis/campaign/{reviewAnalysisCampaignId}/competitors
     */
    reviewAnalysisCampaignCompetitorsCreate: (
      reviewAnalysisCampaignId: string,
      data: {
        /** @example "Aversi Pharma" */
        name: string
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /** @example true */
          success?: boolean
          competitor?: Competitor
        },
        void
      >({
        path: `/v1_private/review-analysis/campaign/${reviewAnalysisCampaignId}/competitors`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Review Analysis
     * @name ReviewAnalysisCampaignCompetitorsDelete
     * @summary Remove a competitor from this campaign
     * @request DELETE:/v1_private/review-analysis/campaign/{reviewAnalysisCampaignId}/competitors/{competitorId}
     */
    reviewAnalysisCampaignCompetitorsDelete: (
      reviewAnalysisCampaignId: string,
      competitorId: string,
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /** @example true */
          success?: boolean
        },
        any
      >({
        path: `/v1_private/review-analysis/campaign/${reviewAnalysisCampaignId}/competitors/${competitorId}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns candidate brands the user can add, excluding ones already on this campaign.
     *
     * @tags Review Analysis
     * @name ReviewAnalysisCampaignCompetitorTargetsDetail
     * @summary Search competitor targets by brand name
     * @request GET:/v1_private/review-analysis/campaign/{reviewAnalysisCampaignId}/competitor-targets
     */
    reviewAnalysisCampaignCompetitorTargetsDetail: (
      reviewAnalysisCampaignId: string,
      query?: {
        /** Search query (brand name) */
        q?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          results?: CompetitorTarget[]
        },
        any
      >({
        path: `/v1_private/review-analysis/campaign/${reviewAnalysisCampaignId}/competitor-targets`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Global integration catalog. Not actually campaign-specific, but kept under the campaign scope for routing consistency.
     *
     * @tags Review Analysis
     * @name ReviewAnalysisCampaignSupportedPlatformsDetail
     * @summary List supported review platforms
     * @request GET:/v1_private/review-analysis/campaign/{reviewAnalysisCampaignId}/supported-platforms
     */
    reviewAnalysisCampaignSupportedPlatformsDetail: (
      reviewAnalysisCampaignId: string,
      params: RequestParams = {}
    ) =>
      this.request<
        {
          platforms?: {
            /** @example "google" */
            id?: string
            /** @example "Google Maps" */
            label?: string
          }[]
        },
        any
      >({
        path: `/v1_private/review-analysis/campaign/${reviewAnalysisCampaignId}/supported-platforms`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description stats, locations, and performance are aggregated from the raw review_analysis_location records for this platform. distribution (star histogram) and trend (time series) are supplementary per-platform data (not derivable from snapshot counts). Pass ?facilityId to scope stats / locations / performance to a single facility — distribution/trend stay platform-wide. 404 if the platform (or platform+facility) has no data.
     *
     * @tags Review Analysis
     * @name ReviewAnalysisCampaignPlatformAnalysisDetail
     * @summary Per-platform review analytics for this campaign
     * @request GET:/v1_private/review-analysis/campaign/{reviewAnalysisCampaignId}/platform-analysis/{platformId}
     */
    reviewAnalysisCampaignPlatformAnalysisDetail: (
      reviewAnalysisCampaignId: string,
      platformId: string,
      query?: {
        /**
         * Scope stats/locations/performance to one facility
         * @example "fac-stamba"
         */
        facilityId?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<PlatformAnalysis, void>({
        path: `/v1_private/review-analysis/campaign/${reviewAnalysisCampaignId}/platform-analysis/${platformId}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Strictly scoped: ?facilityId returns only that facility's insights, ?platformId only that platform's, and neither returns the brand-wide set. A scope with no insights returns hasInsights:false (no fallback to another scope).
     *
     * @tags Review Analysis
     * @name ReviewAnalysisCampaignSmartInsightsDetail
     * @summary Review-specific smart insights & AI recommendations
     * @request GET:/v1_private/review-analysis/campaign/{reviewAnalysisCampaignId}/smart-insights
     */
    reviewAnalysisCampaignSmartInsightsDetail: (
      reviewAnalysisCampaignId: string,
      query?: {
        /**
         * Scope insights to a specific facility
         * @example "fac-lolita"
         */
        facilityId?: string
        /**
         * Scope insights to a specific platform
         * @example "tripadvisor"
         */
        platformId?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /** @example true */
          hasInsights?: boolean
          insights?: {
            id?: string
            title?: string
            details?: string
            aiRecommendation?: string
            category?:
              | 'brand_health_signals'
              | 'competitor_moves'
              | 'content_recommendations'
              | 'crisis_warnings'
            type?: 'challenge' | 'strength'
            percentageChange?: number
            isAIRecommendation?: boolean
            isSmartInsight?: boolean
            sources?: {
              platform?: string
              text?: string
              links?: {
                url?: string
                date?: string
                language?: string
                text?: string
              }[]
            }[]
          }[]
        },
        any
      >({
        path: `/v1_private/review-analysis/campaign/${reviewAnalysisCampaignId}/smart-insights`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Derived from per-review data. Optional ?facilityId scopes it to one facility (C3); otherwise campaign-wide.
     *
     * @tags Review Analysis
     * @name ReviewAnalysisCampaignSpikeBreakdownDetail
     * @summary Per-platform spike breakdown (busiest day + each platform's change)
     * @request GET:/v1_private/review-analysis/campaign/{reviewAnalysisCampaignId}/spike-breakdown
     */
    reviewAnalysisCampaignSpikeBreakdownDetail: (
      reviewAnalysisCampaignId: string,
      query?: {
        /**
         * Scope the spike breakdown to one facility
         * @example "fac-stamba"
         */
        facilityId?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /** @example "Jan 14" */
          spikeDate?: string
          platforms?: {
            /** @example "google" */
            platform?: string
            /** @example "Google Maps" */
            name?: string
            /** @example 52 */
            change?: number
          }[]
        },
        any
      >({
        path: `/v1_private/review-analysis/campaign/${reviewAnalysisCampaignId}/spike-breakdown`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Appends to campaign.platformSubmissions[] and adds the platform id to campaign.platforms[] (via $addToSet).
     *
     * @tags Review Analysis
     * @name ReviewAnalysisCampaignPlatformsCreate
     * @summary Submit a review platform under this campaign
     * @request POST:/v1_private/review-analysis/campaign/{reviewAnalysisCampaignId}/platforms
     */
    reviewAnalysisCampaignPlatformsCreate: (
      reviewAnalysisCampaignId: string,
      data: {
        /**
         * Attach to this existing facility (from a card's facilityId). If omitted, derived from facilityName and frozen.
         * @example "fac-rooms"
         */
        facilityId?: string
        /** @example "Lolita" */
        facilityName: string
        /** @example "google" */
        platform: string
        /** @example "Lolita downtown" */
        title?: string
        /** @example ["ChIJu7yy4DlzREARbpVJRWLU1y0"] */
        placeIds?: string[]
        files?: object[]
        dataSourceLinks?: string[]
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /** @example true */
          success?: boolean
          platform?: object
        },
        any
      >({
        path: `/v1_private/review-analysis/campaign/${reviewAnalysisCampaignId}/platforms`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Accepts an array of platform entries. Valid entries are persisted; invalid ones are reported per item (best-effort — the batch is never rejected wholesale unless the request body itself is malformed). Each created entry appends to campaign.platformSubmissions[] and adds its platform id to campaign.platforms[] (via $addToSet). Top-level dataSourceLinks/files are shared across all created entries (a per-entry value, if provided, takes precedence). After a successful call, refetch the same queries you invalidate for the single endpoint: overview (new pending cards), status (hasPlatforms may flip true), and the campaign doc (platforms[] / platformSubmissions[]).
     *
     * @tags Review Analysis
     * @name ReviewAnalysisCampaignPlatformsBatchCreate
     * @summary Submit multiple review platforms in one request (best-effort)
     * @request POST:/v1_private/review-analysis/campaign/{reviewAnalysisCampaignId}/platforms/batch
     */
    reviewAnalysisCampaignPlatformsBatchCreate: (
      reviewAnalysisCampaignId: string,
      data: {
        /** @minItems 1 */
        platforms: {
          /**
           * Attach to this existing facility (from a card's facilityId). If omitted, a stable id is derived from facilityName and frozen.
           * @example "fac-rooms"
           */
          facilityId?: string
          /** @example "Rooms Tbilisi" */
          facilityName: string
          /** @example "google" */
          platform: string
          /** @example "Rooms Tbilisi" */
          title?: string
          /** @example ["ChIJu7yy4DlzREARbpVJRWLU1y0"] */
          placeIds?: string[]
        }[]
        /** Applied to every created entry */
        dataSourceLinks?: string[]
        /** Applied to every created entry */
        files?: object[]
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /**
           * true when the request was validly shaped and processed; check results[] for per-item outcomes
           * @example true
           */
          success?: boolean
          results?: {
            /** @example "google" */
            platform?: string
            /** @example "Rooms Tbilisi" */
            facilityName?: string
            status?: 'created' | 'failed'
            /** Submission id (present when status=created) */
            id?: string | null
            /** Reason (present when status=failed) */
            error?: string | null
          }[]
        },
        void
      >({
        path: `/v1_private/review-analysis/campaign/${reviewAnalysisCampaignId}/platforms/batch`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Full purge of a (facility, platform, venue) card, keyed by the card's `id` ("<facilityId>::<platform>::<venue>", e.g. "fac-stamba::google::Cafe Stamba") — works for both scraped (ready) and pending/collecting/failed cards. Removes: - all review_analysis_review for that facility+platform+venue, - the matching campaign.platformSubmissions[] entry (if any), - the platform from campaign.platforms[] (only if nothing else uses it), - facility-scoped smart insights if the facility has no reviews left, and platform-scoped smart insights if the platform has none left. 404 if the card has no data (no reviews and no matching submission).
     *
     * @tags Review Analysis
     * @name ReviewAnalysisCampaignPlatformsDelete
     * @summary Delete a platform card and ALL its data
     * @request DELETE:/v1_private/review-analysis/campaign/{reviewAnalysisCampaignId}/platforms/{cardId}
     */
    reviewAnalysisCampaignPlatformsDelete: (
      reviewAnalysisCampaignId: string,
      cardId: string,
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /** @example true */
          success?: boolean
        },
        void
      >({
        path: `/v1_private/review-analysis/campaign/${reviewAnalysisCampaignId}/platforms/${cardId}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * @description Adds each {name, url} entry to campaign.locations[].
     *
     * @tags Review Analysis
     * @name ReviewAnalysisCampaignLocationsCreate
     * @summary Append named locations to this campaign
     * @request POST:/v1_private/review-analysis/campaign/{reviewAnalysisCampaignId}/locations
     */
    reviewAnalysisCampaignLocationsCreate: (
      reviewAnalysisCampaignId: string,
      data: {
        locations: {
          /** @example "Head Office" */
          name: string
          /** @example "https://maps.app.goo.gl/cE7eZLz2bPyACF3A" */
          url: string
        }[]
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /** @example true */
          success?: boolean
          locations?: {
            id?: string
            name?: string
            url?: string
            createdAt?: string
          }[]
        },
        any
      >({
        path: `/v1_private/review-analysis/campaign/${reviewAnalysisCampaignId}/locations`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns AI-powered insights across all user's campaigns
     *
     * @tags Smart Insights
     * @name SmartInsightsList
     * @summary Get Smart Insights & AI Recommendations
     * @request GET:/v1_private/smart-insights
     */
    smartInsightsList: (
      query?: {
        /**
         * Filter by Campaign ID (optional, defaults to all user campaigns)
         * @example "694a659f2828441b7516cc0a"
         */
        campaign?: string
        /**
         * Filter by Date From
         * @example "2023-03-11T20:00:00.000Z"
         */
        fromDate?: string
        /**
         * Filter by Date To
         * @example "2023-03-14T19:59:59.999Z"
         */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<SmartInsightsResponse, any>({
        path: `/v1_private/smart-insights`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns a list of word variations for the given keyword (spelling variants, morphological forms, transliterations, etc.), generated via OpenRouter LLM. Results are cached in Redis. Rate-limited to 30 requests/minute per user (shared bucket with keyword-sentiments). Clients can inspect `Rate-Limit-Remaining` on any 2xx response to throttle proactively.
     *
     * @tags Suggestions
     * @name SuggestionsKeywordVariationsList
     * @summary Get keyword variations
     * @request GET:/v1_private/suggestions/keyword-variations
     */
    suggestionsKeywordVariationsList: (
      query: {
        /**
         * Keyword to expand into variations
         * @example "blox"
         */
        keyword: string
        /**
         * Optional. When provided, results bias toward this language's morphology
         * and script (e.g., for "blox" + "Georgian" you get "ბლოქსი", "blox-ი",
         * "blox-მა", "ბლოქსის"). Accepts language names ("Georgian", "Russian")
         * or ISO codes ("ka", "ru"). When omitted, returns script-agnostic
         * spelling/morphological/transliteration variants.
         * @example "Georgian"
         */
        language?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /** @example ["blox","blox-ს","blox-ში","blox-ზე"] */
          variations?: string[]
        },
        string
      >({
        path: `/v1_private/suggestions/keyword-variations`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns positive and negative sentiment words people commonly use about the given keyword, generated via OpenRouter LLM. Results are cached in Redis. Rate-limited to 30 requests/minute per user (shared bucket with keyword-variations).
     *
     * @tags Suggestions
     * @name SuggestionsKeywordSentimentsList
     * @summary Get sentiment words for a keyword
     * @request GET:/v1_private/suggestions/keyword-sentiments
     */
    suggestionsKeywordSentimentsList: (
      query: {
        /**
         * Keyword to fetch sentiment words for
         * @example "blox"
         */
        keyword: string
        /**
         * Optional. When provided, returned sentiment words are in this
         * language's native script and reflect how that language's speakers
         * actually express sentiment online (colloquial, not formal).
         * Accepts language names ("Georgian", "Russian") or ISO codes
         * ("ka", "ru"). When omitted, returns English-leaning generic terms.
         * @example "Georgian"
         */
        language?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /** @example ["good","cheap","quality"] */
          positive?: string[]
          /** @example ["bad","expensive","trash"] */
          negative?: string[]
        },
        string
      >({
        path: `/v1_private/suggestions/keyword-sentiments`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags TripAdvisor
     * @name TripadvisorSearchTripAdvisorList
     * @summary Search TripAdvisor locations
     * @request GET:/v1_private/tripadvisor/searchTripAdvisor
     */
    tripadvisorSearchTripAdvisorList: (
      query: {
        /** Search query for TripAdvisor locations */
        searchQuery: string
        /** Language for the search results */
        language: string
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          data?: {
            location_id?: string
            name?: string
            address_obj?: {
              street1?: string
              street2?: string
              city?: string
              country?: string
              postalcode?: string
              address_string?: string
            }
          }[]
        },
        void
      >({
        path: `/v1_private/tripadvisor/searchTripAdvisor`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns all feature flags for the authenticated user based on their session
     *
     * @tags User Features
     * @name UserFeaturesMeList
     * @summary Get current user's feature flags
     * @request GET:/v1_private/user-features/me
     */
    userFeaturesMeList: (params: RequestParams = {}) =>
      this.request<
        {
          /** @example true */
          success?: boolean
          data?: {
            /** @example "65f1234567890abcdef12345" */
            _id?: string
            /** @example "507f1f77bcf86cd799439011" */
            userId?: string
            /**
             * Whether inbox analysis is enabled for this user
             * @example false
             */
            inboxAnalysisEnabled?: boolean
            /**
             * Whether content analysis is enabled for this user
             * @example false
             */
            contentAnalysisEnabled?: boolean
            /**
             * Whether the Ads Library feature is enabled for this user
             * @example false
             */
            adsLibraryEnabled?: boolean
            /**
             * Whether the Ads Performance feature is enabled for this user
             * @example false
             */
            adsPerformanceEnabled?: boolean
            /** User's saved campaign comparison preferences */
            campaignComparisonPreferences?: {
              /** @example ["63ff25da11b15267d928b99c","63ff25da11b15267d928b99d"] */
              campaignIds?: string[]
              /** @example ["mentions","sources","sentiments"] */
              metrics?: string[]
              dateRange?: {
                /**
                 * @format date-time
                 * @example "2023-03-01T00:00:00.000Z"
                 */
                fromDate?: string
                /**
                 * @format date-time
                 * @example "2023-03-31T23:59:59.999Z"
                 */
                toDate?: string
              } | null
              /** @example "63ff25da11b15267d928b99c" */
              benchmarkCampaignId?: string | null
              /**
               * @format date-time
               * @example "2024-01-20T14:45:00.000Z"
               */
              lastUpdated?: string
            }
            /**
             * @format date-time
             * @example "2024-01-15T10:30:00.000Z"
             */
            createdAt?: string
            /**
             * @format date-time
             * @example "2024-01-20T14:45:00.000Z"
             */
            updatedAt?: string
          }
        },
        | {
            /** @example false */
            success?: boolean
            /** @example "Unauthorized" */
            error?: string
          }
        | {
            /** @example false */
            success?: boolean
            /** @example "Failed to fetch user features" */
            error?: string
          }
      >({
        path: `/v1_private/user-features/me`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns trial status for the authenticated user. Reads `trial.endsAt` from the `user_features` document. If the user has no trial set, `isTrial` is false and `trialEndsAt` is null.
     *
     * @tags User Features
     * @name UserFeaturesTrialStatusList
     * @summary Get current user's trial status
     * @request GET:/v1_private/user-features/trial-status
     */
    userFeaturesTrialStatusList: (params: RequestParams = {}) =>
      this.request<
        {
          /** @example true */
          success?: boolean
          data?: {
            /**
             * True if the user has a trial configured (regardless of whether it has expired)
             * @example true
             */
            isTrial?: boolean
            /**
             * True if the trial end date is in the past
             * @example false
             */
            isExpired?: boolean
            /**
             * @format date-time
             * @example "2026-05-06T00:00:00.000Z"
             */
            trialEndsAt?: string | null
            /**
             * Whole days remaining until `trialEndsAt`. 0 if no trial or expired.
             * @example 8
             */
            daysRemaining?: number
          }
        },
        | {
            /** @example false */
            success?: boolean
            /** @example "Unauthorized" */
            error?: string
          }
        | {
            /** @example false */
            success?: boolean
            /** @example "Failed to fetch trial status" */
            error?: string
          }
      >({
        path: `/v1_private/user-features/trial-status`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Features
     * @name UserFeaturesDetail
     * @summary Get all feature flags for a specific user
     * @request GET:/v1_private/user-features/{userId}
     */
    userFeaturesDetail: (
      userId: string,
      query: {
        /**
         * Admin password for authentication
         * @example "your_admin_password"
         */
        password: string
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /** @example true */
          success?: boolean
          data?: {
            /** @example "65f1234567890abcdef12345" */
            _id?: string
            /** @example "507f1f77bcf86cd799439011" */
            userId?: string
            /** @example true */
            inboxAnalysisEnabled?: boolean
            /** @example false */
            contentAnalysisEnabled?: boolean
            /**
             * @format date-time
             * @example "2024-01-15T10:30:00.000Z"
             */
            createdAt?: string
            /**
             * @format date-time
             * @example "2024-01-20T14:45:00.000Z"
             */
            updatedAt?: string
          }
        },
        | {
            /** @example false */
            success?: boolean
            /** @example "userId is required" */
            error?: string
          }
        | {
            /** @example false */
            success?: boolean
            /** @example "Unauthorized" */
            error?: string
          }
        | {
            /** @example false */
            success?: boolean
            /** @example "Invalid or missing admin password" */
            error?: string
          }
        | {
            /** @example false */
            success?: boolean
            /** @example "Failed to fetch user features" */
            error?: string
          }
      >({
        path: `/v1_private/user-features/${userId}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Features
     * @name UserFeaturesContentAnalysisEnabledList
     * @summary Get all users with content analysis enabled
     * @request GET:/v1_private/user-features/content-analysis/enabled
     */
    userFeaturesContentAnalysisEnabledList: (
      query: {
        /**
         * Admin password for authentication
         * @example "your_admin_password"
         */
        password: string
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /** @example true */
          success?: boolean
          data?: {
            /**
             * Array of user IDs with content analysis enabled
             * @example ["507f1f77bcf86cd799439011","507f1f77bcf86cd799439012","507f1f77bcf86cd799439013"]
             */
            userIds?: string[]
            /**
             * Total count of users with content analysis enabled
             * @example 3
             */
            total?: number
          }
        },
        | {
            /** @example false */
            success?: boolean
            /** @example "Unauthorized" */
            error?: string
          }
        | {
            /** @example false */
            success?: boolean
            /** @example "Invalid or missing admin password" */
            error?: string
          }
        | {
            /** @example false */
            success?: boolean
            /** @example "Failed to fetch users with content analysis" */
            error?: string
          }
      >({
        path: `/v1_private/user-features/content-analysis/enabled`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Features
     * @name UserFeaturesInboxAnalysisEnabledList
     * @summary Get all users with inbox analysis enabled
     * @request GET:/v1_private/user-features/inbox-analysis/enabled
     */
    userFeaturesInboxAnalysisEnabledList: (
      query: {
        /**
         * Admin password for authentication
         * @example "your_admin_password"
         */
        password: string
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /** @example true */
          success?: boolean
          data?: {
            /**
             * Array of user IDs with inbox analysis enabled
             * @example ["507f1f77bcf86cd799439011","507f1f77bcf86cd799439012","507f1f77bcf86cd799439013"]
             */
            userIds?: string[]
            /**
             * Total count of users with inbox analysis enabled
             * @example 3
             */
            total?: number
          }
        },
        | {
            /** @example false */
            success?: boolean
            /** @example "Unauthorized" */
            error?: string
          }
        | {
            /** @example false */
            success?: boolean
            /** @example "Invalid or missing admin password" */
            error?: string
          }
        | {
            /** @example false */
            success?: boolean
            /** @example "Failed to fetch users with inbox analysis" */
            error?: string
          }
      >({
        path: `/v1_private/user-features/inbox-analysis/enabled`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Features
     * @name UserFeaturesContentAnalysisCreate
     * @summary Enable or disable content analysis for a specific user
     * @request POST:/v1_private/user-features/content-analysis
     */
    userFeaturesContentAnalysisCreate: (
      data: {
        /**
         * User ID to update
         * @example "507f1f77bcf86cd799439011"
         */
        userId: string
        /**
         * Whether to enable or disable content analysis
         * @example true
         */
        enabled: boolean
        /**
         * Admin password for authentication
         * @example "your_admin_password"
         */
        password: string
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /** @example true */
          success?: boolean
          data?: {
            /** @example "507f1f77bcf86cd799439011" */
            userId?: string
            /** @example true */
            contentAnalysisEnabled?: boolean
            /** @example "Content analysis enabled for user 507f1f77bcf86cd799439011" */
            message?: string
          }
        },
        | {
            /** @example false */
            success?: boolean
            /** @example "userId is required" */
            error?: string
          }
        | {
            /** @example false */
            success?: boolean
            /** @example "Unauthorized" */
            error?: string
          }
        | {
            /** @example false */
            success?: boolean
            /** @example "Invalid or missing admin password" */
            error?: string
          }
        | {
            /** @example false */
            success?: boolean
            /** @example "Failed to update content analysis access" */
            error?: string
          }
      >({
        path: `/v1_private/user-features/content-analysis`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Features
     * @name UserFeaturesInboxAnalysisCreate
     * @summary Enable or disable inbox analysis for a specific user
     * @request POST:/v1_private/user-features/inbox-analysis
     */
    userFeaturesInboxAnalysisCreate: (
      data: {
        /**
         * User ID to update
         * @example "507f1f77bcf86cd799439011"
         */
        userId: string
        /**
         * Whether to enable or disable inbox analysis
         * @example true
         */
        enabled: boolean
        /**
         * Admin password for authentication
         * @example "your_admin_password"
         */
        password: string
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /** @example true */
          success?: boolean
          data?: {
            /** @example "507f1f77bcf86cd799439011" */
            userId?: string
            /** @example true */
            inboxAnalysisEnabled?: boolean
            /** @example "Inbox analysis enabled for user 507f1f77bcf86cd799439011" */
            message?: string
          }
        },
        | {
            /** @example false */
            success?: boolean
            /** @example "userId is required" */
            error?: string
          }
        | {
            /** @example false */
            success?: boolean
            /** @example "Unauthorized" */
            error?: string
          }
        | {
            /** @example false */
            success?: boolean
            /** @example "Invalid or missing admin password" */
            error?: string
          }
        | {
            /** @example false */
            success?: boolean
            /** @example "Failed to update inbox analysis access" */
            error?: string
          }
      >({
        path: `/v1_private/user-features/inbox-analysis`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
}
